const MAX_FRAME_BUFFERS = 1000;
const MAX_PROGRAMS      = 1000;
const MAX_ARRAY_BUFFERS = 1000;

// Singleton use to track gl objects and delete them when the 'beforeunload' event is triggered.
// this is to fix a  bug on Edge on windows 11 that keeps any allocated gl objects between page reloads of a given browser tab resulting in crashes
var MemoryManager = {
   
    buffers:      [],
    textures:     [],
    frameBuffers: [],
    programs:     [],

    trackProgram(program) {
        this.programs.push(program);
    },
    trackBuffer(buffer) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_ARRAY_BUFFERS} ArrayBuffers.`);
            return;
        }
        this.buffers.push(buffer);
    },
    trackFrameBuffer(frameBuffer) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_FRAME_BUFFERS} FrameBuffers.`);
            return;
        }
        this.frameBuffers.push(frameBuffer);
    },
    trackTexture(texture) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_PROGRAMS} Textures.`);
            return;
        }
        this.textures.push(texture);
    },
    untrackProgram(program) {
        if (this.textures.length > 100000) {
            console.error(`Memory Error: The application created more than ${MAX_PROGRAMS} Programs.`);
            return;
        }
        for (let i=this.programs.length-1; i>=0; i--) {
            if (this.programs === program) {
                this.programs.splice(i, 1);
                break;
            }
        }
    },
    untrackBuffer(buffer) {
        for (let i=this.buffers.length-1; i>=0; i--) {
            if (this.buffers === buffer) {
                this.buffers.splice(i, 1);
                break;
            }
        }
    },
    untrackTexture(texture) {
        for (let i=this.textures.length-1; i>=0; i--) {
            if (this.textures === texture) {
                this.textures.splice(i, 1);
                break;
            }
        }
    },
    untrackFrameBuffer(frameBuffer) {
        for (let i=this.frameBuffers.length-1; i>=0; i--) {
            if (this.frameBuffers === frameBuffer) {
                this.frameBuffers.splice(i, 1);
                break;
            }
        }
    },
    destroy(gl) {
        this.textures.forEach(texture => {
            gl.deleteTexture(texture);
        });
        this.buffers.forEach(buffer => {
            gl.deleteBuffer(buffer);
        });
        this.frameBuffers.forEach(frameBuffer => {
            gl.deleteFramebuffer(frameBuffer);
        });
        // this.programs.forEach(program => {
        //     gl.deleteProgram(program);
        // });
        this.textures     = [];
        this.buffers      = [];
        this.frameBuffers = [];
        this.programs     = [];
    }
    
};

// cache
let bindedBuffer$1 = null; 

class ArrayBuffer$1 {

	constructor(gl, data, size, element, name, type) {
		this.name     = name;
		this.gl       = gl;
		this._buffer  = this.gl.createBuffer();

		MemoryManager.trackBuffer(this._buffer);

		this.type     = type || this.gl.FLOAT;
		this._element = element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER';
		this._target  = this.gl[ element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER' ];
		this.update(data, size);
	}

	update(data, size) {
		// if (this.hasCalledSubUpdate) {
		// 	console.warn('cannot call update() on an attribute after calling subUpdate()')
		// 	return;
		// }
		this.data   = data;
		this.size   = size; 
		this.length = this.data.length;
		this.gl.bindBuffer( this._target, this._buffer);
		// any attribute starting with "instance" will is considered and instance attribute
		// TODO: do we really need to do this  istead of bufferData  for instanced attributes ?
		if ( /^instance/.test(this.name) ){
			this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, this.data);//, this.gl.STATIC_DRAW);//if the attribute chnages oftenly, we need to use DYNAMIC_DRAW
		}
		else {
			this.gl.bufferData( this._target, this.data, this.gl.STATIC_DRAW);
		}
        this.gl.bindBuffer(this._target, null);
	}

    subUpdate(data, size, offset) {
		// this.hasCalledSubUpdate = true
		if (bindedBuffer$1 != this) {
			bindedBuffer$1 = this;
			this.gl.bindBuffer( this._target, this._buffer );
		}
        this.gl.bindBuffer( this._target, this._buffer);
        let byteOffset = offset * size * Float32Array.BYTES_PER_ELEMENT; 
        this.gl.bufferSubData(this.gl.ARRAY_BUFFER, byteOffset, data, 0);
    }

	bind() {
		if (bindedBuffer$1 != this) {
			bindedBuffer$1 = this;
			this.gl.bindBuffer( this._target, this._buffer );
		}
	}

}

// cache
let bindedBuffer = null; 

class InstancedArrayBuffer {

    constructor(gl, data, size, element, name, type) {
        this.name     = name;
        this.gl       = gl;
        this._buffer  = this.gl.createBuffer();
        MemoryManager.trackBuffer(this._buffer);
        this.type     = type || this.gl.FLOAT;
        this._element = element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER';
        this._target  = this.gl[ element ? 'ELEMENT_ARRAY_BUFFER' : 'ARRAY_BUFFER' ];
        this.update(data, size);
    }

    update(data, size) {
        this.data   = data;
        this.size   = size; 
        this.length = this.data.length;
        this.gl.bindBuffer( this._target, this._buffer);
        this.gl.bufferSubData(this.gl.ARRAY_BUFFER, 0, this.data);
        this.gl.bindBuffer(this._target, null);
    }

    subUpdate(data, size, offset) {
        if (bindedBuffer != this) {
            bindedBuffer = this;
            this.gl.bindBuffer( this._target, this._buffer );
        }
        this.gl.bindBuffer( this._target, this._buffer);
        let byteOffset = offset * size * Float32Array.BYTES_PER_ELEMENT; 
        this.gl.bufferSubData(this.gl.ARRAY_BUFFER, byteOffset, data, 0);
    }

    bind() {
        if (bindedBuffer != this) {
            bindedBuffer = this;
            this.gl.bindBuffer( this._target, this._buffer );
        }
    }

}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * Common utilities
 * @module glMatrix
 */

// Configuration Constants
const EPSILON = 0.000001;
let ARRAY_TYPE = (typeof Float32Array !== 'undefined') ? Float32Array : Array;
const RANDOM = Math.random;

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 4x4 Matrix
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */
function create$7() {
  let out = new ARRAY_TYPE(16);
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */
function clone$7(a) {
  let out = new ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}

/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function copy$7(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}

/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */
function fromValues$7(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  let out = new ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}

/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */
function set$7(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}


/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */
function identity$4(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function transpose$2(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    let a01 = a[1], a02 = a[2], a03 = a[3];
    let a12 = a[6], a13 = a[7];
    let a23 = a[11];

    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }

  return out;
}

/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function invert$4(out, a) {
  let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
  let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
  let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
  let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;

  // Calculate the determinant
  let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

  return out;
}

/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
function adjoint$2(out, a) {
  let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
  let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
  let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
  let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

  out[0]  =  (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
  out[1]  = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2]  =  (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
  out[3]  = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4]  = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5]  =  (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
  out[6]  = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7]  =  (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
  out[8]  =  (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
  out[9]  = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] =  (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] =  (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] =  (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
  return out;
}

/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant$3(a) {
  let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
  let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
  let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
  let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;

  // Calculate the determinant
  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}

/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function multiply$7(out, a, b) {
  let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
  let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
  let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
  let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

  // Cache only the current line of the second matrix
  let b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
  out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
  out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
  out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
  out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

  b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
  out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
  out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
  out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
  out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

  b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
  out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
  out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
  out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
  out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

  b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
  out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
  out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
  out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
  out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
  return out;
}

/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
function translate$2(out, a, v) {
  let x = v[0], y = v[1], z = v[2];
  let a00, a01, a02, a03;
  let a10, a11, a12, a13;
  let a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
    a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
    a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

    out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
    out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
    out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;

    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}

/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/
function scale$7(out, a, v) {
  let x = v[0], y = v[1], z = v[2];

  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}

/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function rotate$3(out, a, rad, axis) {
  let x = axis[0], y = axis[1], z = axis[2];
  let len = Math.sqrt(x * x + y * y + z * z);
  let s, c, t;
  let a00, a01, a02, a03;
  let a10, a11, a12, a13;
  let a20, a21, a22, a23;
  let b00, b01, b02;
  let b10, b11, b12;
  let b20, b21, b22;

  if (Math.abs(len) < EPSILON) { return null; }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;

  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;

  a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
  a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
  a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

  // Construct the elements of the rotation matrix
  b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
  b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
  b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;

  // Perform rotation-specific matrix multiplication
  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;

  if (a !== out) { // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }
  return out;
}

/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateX$2(out, a, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  let a10 = a[4];
  let a11 = a[5];
  let a12 = a[6];
  let a13 = a[7];
  let a20 = a[8];
  let a21 = a[9];
  let a22 = a[10];
  let a23 = a[11];

  if (a !== out) { // If the source and destination differ, copy the unchanged rows
    out[0]  = a[0];
    out[1]  = a[1];
    out[2]  = a[2];
    out[3]  = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  // Perform axis-specific matrix multiplication
  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}

/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateY$2(out, a, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  let a00 = a[0];
  let a01 = a[1];
  let a02 = a[2];
  let a03 = a[3];
  let a20 = a[8];
  let a21 = a[9];
  let a22 = a[10];
  let a23 = a[11];

  if (a !== out) { // If the source and destination differ, copy the unchanged rows
    out[4]  = a[4];
    out[5]  = a[5];
    out[6]  = a[6];
    out[7]  = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  // Perform axis-specific matrix multiplication
  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}

/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function rotateZ$2(out, a, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  let a00 = a[0];
  let a01 = a[1];
  let a02 = a[2];
  let a03 = a[3];
  let a10 = a[4];
  let a11 = a[5];
  let a12 = a[6];
  let a13 = a[7];

  if (a !== out) { // If the source and destination differ, copy the unchanged last row
    out[8]  = a[8];
    out[9]  = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  // Perform axis-specific matrix multiplication
  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromTranslation$2(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Scaling vector
 * @returns {mat4} out
 */
function fromScaling$3(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
function fromRotation$3(out, rad, axis) {
  let x = axis[0], y = axis[1], z = axis[2];
  let len = Math.sqrt(x * x + y * y + z * z);
  let s, c, t;

  if (Math.abs(len) < EPSILON) { return null; }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;

  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;

  // Perform rotation-specific matrix multiplication
  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromXRotation(out, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);

  // Perform axis-specific matrix multiplication
  out[0]  = 1;
  out[1]  = 0;
  out[2]  = 0;
  out[3]  = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromYRotation(out, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);

  // Perform axis-specific matrix multiplication
  out[0]  = c;
  out[1]  = 0;
  out[2]  = -s;
  out[3]  = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
function fromZRotation(out, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);

  // Perform axis-specific matrix multiplication
  out[0]  = c;
  out[1]  = s;
  out[2]  = 0;
  out[3]  = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}

/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
function fromRotationTranslation(out, q, v) {
  // Quaternion math
  let x = q[0], y = q[1], z = q[2], w = q[3];
  let x2 = x + x;
  let y2 = y + y;
  let z2 = z + z;

  let xx = x * x2;
  let xy = x * y2;
  let xz = x * z2;
  let yy = y * y2;
  let yz = y * z2;
  let zz = z * z2;
  let wx = w * x2;
  let wy = w * y2;
  let wz = w * z2;

  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;

  return out;
}

/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {mat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */
function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];

  return out;
}

/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {mat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */
function getScaling(out, mat) {
  let m11 = mat[0];
  let m12 = mat[1];
  let m13 = mat[2];
  let m21 = mat[4];
  let m22 = mat[5];
  let m23 = mat[6];
  let m31 = mat[8];
  let m32 = mat[9];
  let m33 = mat[10];

  out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
  out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
  out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);

  return out;
}

/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {mat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */
function getRotation(out, mat) {
  // Algorithm taken from http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
  let trace = mat[0] + mat[5] + mat[10];
  let S = 0;

  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (mat[6] - mat[9]) / S;
    out[1] = (mat[8] - mat[2]) / S;
    out[2] = (mat[1] - mat[4]) / S;
  } else if ((mat[0] > mat[5])&(mat[0] > mat[10])) {
    S = Math.sqrt(1.0 + mat[0] - mat[5] - mat[10]) * 2;
    out[3] = (mat[6] - mat[9]) / S;
    out[0] = 0.25 * S;
    out[1] = (mat[1] + mat[4]) / S;
    out[2] = (mat[8] + mat[2]) / S;
  } else if (mat[5] > mat[10]) {
    S = Math.sqrt(1.0 + mat[5] - mat[0] - mat[10]) * 2;
    out[3] = (mat[8] - mat[2]) / S;
    out[0] = (mat[1] + mat[4]) / S;
    out[1] = 0.25 * S;
    out[2] = (mat[6] + mat[9]) / S;
  } else {
    S = Math.sqrt(1.0 + mat[10] - mat[0] - mat[5]) * 2;
    out[3] = (mat[1] - mat[4]) / S;
    out[0] = (mat[8] + mat[2]) / S;
    out[1] = (mat[6] + mat[9]) / S;
    out[2] = 0.25 * S;
  }

  return out;
}

/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @returns {mat4} out
 */
function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  let x = q[0], y = q[1], z = q[2], w = q[3];
  let x2 = x + x;
  let y2 = y + y;
  let z2 = z + z;

  let xx = x * x2;
  let xy = x * y2;
  let xz = x * z2;
  let yy = y * y2;
  let yz = y * z2;
  let zz = z * z2;
  let wx = w * x2;
  let wy = w * y2;
  let wz = w * z2;
  let sx = s[0];
  let sy = s[1];
  let sz = s[2];

  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;

  return out;
}

/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @param {vec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */
function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  let x = q[0], y = q[1], z = q[2], w = q[3];
  let x2 = x + x;
  let y2 = y + y;
  let z2 = z + z;

  let xx = x * x2;
  let xy = x * y2;
  let xz = x * z2;
  let yy = y * y2;
  let yz = y * z2;
  let zz = z * z2;
  let wx = w * x2;
  let wy = w * y2;
  let wz = w * z2;

  let sx = s[0];
  let sy = s[1];
  let sz = s[2];

  let ox = o[0];
  let oy = o[1];
  let oz = o[2];

  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0] + ox - (out[0] * ox + out[4] * oy + out[8] * oz);
  out[13] = v[1] + oy - (out[1] * ox + out[5] * oy + out[9] * oz);
  out[14] = v[2] + oz - (out[2] * ox + out[6] * oy + out[10] * oz);
  out[15] = 1;

  return out;
}

/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */
function fromQuat$1(out, q) {
  let x = q[0], y = q[1], z = q[2], w = q[3];
  let x2 = x + x;
  let y2 = y + y;
  let z2 = z + z;

  let xx = x * x2;
  let yx = y * x2;
  let yy = y * y2;
  let zx = z * x2;
  let zy = z * y2;
  let zz = z * z2;
  let wx = w * x2;
  let wy = w * y2;
  let wz = w * z2;

  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;

  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;

  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;

  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;

  return out;
}

/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */
function frustum(out, left, right, bottom, top, near, far) {
  let rl = 1 / (right - left);
  let tb = 1 / (top - bottom);
  let nf = 1 / (near - far);
  out[0] = (near * 2) * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = (near * 2) * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = (far * near * 2) * nf;
  out[15] = 0;
  return out;
}

/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspective(out, fovy, aspect, near, far) {
  let f = 1.0 / Math.tan(fovy / 2);
  let nf = 1 / (near - far);
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = (2 * far * near) * nf;
  out[15] = 0;
  return out;
}

/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function perspectiveFromFieldOfView(out, fov, near, far) {
  let upTan = Math.tan(fov.upDegrees * Math.PI/180.0);
  let downTan = Math.tan(fov.downDegrees * Math.PI/180.0);
  let leftTan = Math.tan(fov.leftDegrees * Math.PI/180.0);
  let rightTan = Math.tan(fov.rightDegrees * Math.PI/180.0);
  let xScale = 2.0 / (leftTan + rightTan);
  let yScale = 2.0 / (upTan + downTan);

  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = ((upTan - downTan) * yScale * 0.5);
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = (far * near) / (near - far);
  out[15] = 0.0;
  return out;
}

/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
function ortho(out, left, right, bottom, top, near, far) {
  let lr = 1 / (left - right);
  let bt = 1 / (bottom - top);
  let nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}

/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
function lookAt(out, eye, center, up) {
  let x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  let eyex = eye[0];
  let eyey = eye[1];
  let eyez = eye[2];
  let upx = up[0];
  let upy = up[1];
  let upz = up[2];
  let centerx = center[0];
  let centery = center[1];
  let centerz = center[2];

  if (Math.abs(eyex - centerx) < EPSILON &&
      Math.abs(eyey - centery) < EPSILON &&
      Math.abs(eyez - centerz) < EPSILON) {
    return identity$4(out);
  }

  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;

  len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;

  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;

  len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }

  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;

  return out;
}

/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
function targetTo(out, eye, target, up) {
  let eyex = eye[0],
      eyey = eye[1],
      eyez = eye[2],
      upx = up[0],
      upy = up[1],
      upz = up[2];

  let z0 = eyex - target[0],
      z1 = eyey - target[1],
      z2 = eyez - target[2];

  let len = z0*z0 + z1*z1 + z2*z2;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }

  let x0 = upy * z2 - upz * z1,
      x1 = upz * z0 - upx * z2,
      x2 = upx * z1 - upy * z0;

  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {mat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str$7(a) {
  return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' +
          a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' +
          a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' +
          a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
}

/**
 * Returns Frobenius norm of a mat4
 *
 * @param {mat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob$3(a) {
  return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2) + Math.pow(a[9], 2) + Math.pow(a[10], 2) + Math.pow(a[11], 2) + Math.pow(a[12], 2) + Math.pow(a[13], 2) + Math.pow(a[14], 2) + Math.pow(a[15], 2) ))
}

/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function add$7(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
function subtract$6(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */
function multiplyScalar$3(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}

/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */
function multiplyScalarAndAdd$3(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  out[3] = a[3] + (b[3] * scale);
  out[4] = a[4] + (b[4] * scale);
  out[5] = a[5] + (b[5] * scale);
  out[6] = a[6] + (b[6] * scale);
  out[7] = a[7] + (b[7] * scale);
  out[8] = a[8] + (b[8] * scale);
  out[9] = a[9] + (b[9] * scale);
  out[10] = a[10] + (b[10] * scale);
  out[11] = a[11] + (b[11] * scale);
  out[12] = a[12] + (b[12] * scale);
  out[13] = a[13] + (b[13] * scale);
  out[14] = a[14] + (b[14] * scale);
  out[15] = a[15] + (b[15] * scale);
  return out;
}

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals$7(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] &&
         a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] &&
         a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] &&
         a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals$7(a, b) {
  let a0  = a[0],  a1  = a[1],  a2  = a[2],  a3  = a[3];
  let a4  = a[4],  a5  = a[5],  a6  = a[6],  a7  = a[7];
  let a8  = a[8],  a9  = a[9],  a10 = a[10], a11 = a[11];
  let a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];

  let b0  = b[0],  b1  = b[1],  b2  = b[2],  b3  = b[3];
  let b4  = b[4],  b5  = b[5],  b6  = b[6],  b7  = b[7];
  let b8  = b[8],  b9  = b[9],  b10 = b[10], b11 = b[11];
  let b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];

  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
          Math.abs(a3 - b3) <= EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
          Math.abs(a4 - b4) <= EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
          Math.abs(a5 - b5) <= EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
          Math.abs(a6 - b6) <= EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
          Math.abs(a7 - b7) <= EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
          Math.abs(a8 - b8) <= EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)) &&
          Math.abs(a9 - b9) <= EPSILON*Math.max(1.0, Math.abs(a9), Math.abs(b9)) &&
          Math.abs(a10 - b10) <= EPSILON*Math.max(1.0, Math.abs(a10), Math.abs(b10)) &&
          Math.abs(a11 - b11) <= EPSILON*Math.max(1.0, Math.abs(a11), Math.abs(b11)) &&
          Math.abs(a12 - b12) <= EPSILON*Math.max(1.0, Math.abs(a12), Math.abs(b12)) &&
          Math.abs(a13 - b13) <= EPSILON*Math.max(1.0, Math.abs(a13), Math.abs(b13)) &&
          Math.abs(a14 - b14) <= EPSILON*Math.max(1.0, Math.abs(a14), Math.abs(b14)) &&
          Math.abs(a15 - b15) <= EPSILON*Math.max(1.0, Math.abs(a15), Math.abs(b15)));
}

/**
 * Alias for {@link mat4.multiply}
 * @function
 */
const mul$7 = multiply$7;

/**
 * Alias for {@link mat4.subtract}
 * @function
 */
const sub$6 = subtract$6;

var mat4 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$7,
   clone: clone$7,
   copy: copy$7,
   fromValues: fromValues$7,
   set: set$7,
   identity: identity$4,
   transpose: transpose$2,
   invert: invert$4,
   adjoint: adjoint$2,
   determinant: determinant$3,
   multiply: multiply$7,
   translate: translate$2,
   scale: scale$7,
   rotate: rotate$3,
   rotateX: rotateX$2,
   rotateY: rotateY$2,
   rotateZ: rotateZ$2,
   fromTranslation: fromTranslation$2,
   fromScaling: fromScaling$3,
   fromRotation: fromRotation$3,
   fromXRotation: fromXRotation,
   fromYRotation: fromYRotation,
   fromZRotation: fromZRotation,
   fromRotationTranslation: fromRotationTranslation,
   getTranslation: getTranslation,
   getScaling: getScaling,
   getRotation: getRotation,
   fromRotationTranslationScale: fromRotationTranslationScale,
   fromRotationTranslationScaleOrigin: fromRotationTranslationScaleOrigin,
   fromQuat: fromQuat$1,
   frustum: frustum,
   perspective: perspective,
   perspectiveFromFieldOfView: perspectiveFromFieldOfView,
   ortho: ortho,
   lookAt: lookAt,
   targetTo: targetTo,
   str: str$7,
   frob: frob$3,
   add: add$7,
   subtract: subtract$6,
   multiplyScalar: multiplyScalar$3,
   multiplyScalarAndAdd: multiplyScalarAndAdd$3,
   exactEquals: exactEquals$7,
   equals: equals$7,
   mul: mul$7,
   sub: sub$6
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */
function create$6() {
  let out = new ARRAY_TYPE(9);
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}

/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {mat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */
function fromMat4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[4];
  out[4] = a[5];
  out[5] = a[6];
  out[6] = a[8];
  out[7] = a[9];
  out[8] = a[10];
  return out;
}

/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {mat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */
function clone$6(a) {
  let out = new ARRAY_TYPE(9);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}

/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function copy$6(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}

/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */
function fromValues$6(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  let out = new ARRAY_TYPE(9);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}

/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */
function set$6(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}

/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */
function identity$3(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}

/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function transpose$1(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    let a01 = a[1], a02 = a[2], a12 = a[5];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a01;
    out[5] = a[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a[0];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a[1];
    out[4] = a[4];
    out[5] = a[7];
    out[6] = a[2];
    out[7] = a[5];
    out[8] = a[8];
  }

  return out;
}

/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function invert$3(out, a) {
  let a00 = a[0], a01 = a[1], a02 = a[2];
  let a10 = a[3], a11 = a[4], a12 = a[5];
  let a20 = a[6], a21 = a[7], a22 = a[8];

  let b01 = a22 * a11 - a12 * a21;
  let b11 = -a22 * a10 + a12 * a20;
  let b21 = a21 * a10 - a11 * a20;

  // Calculate the determinant
  let det = a00 * b01 + a01 * b11 + a02 * b21;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}

/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
function adjoint$1(out, a) {
  let a00 = a[0], a01 = a[1], a02 = a[2];
  let a10 = a[3], a11 = a[4], a12 = a[5];
  let a20 = a[6], a21 = a[7], a22 = a[8];

  out[0] = (a11 * a22 - a12 * a21);
  out[1] = (a02 * a21 - a01 * a22);
  out[2] = (a01 * a12 - a02 * a11);
  out[3] = (a12 * a20 - a10 * a22);
  out[4] = (a00 * a22 - a02 * a20);
  out[5] = (a02 * a10 - a00 * a12);
  out[6] = (a10 * a21 - a11 * a20);
  out[7] = (a01 * a20 - a00 * a21);
  out[8] = (a00 * a11 - a01 * a10);
  return out;
}

/**
 * Calculates the determinant of a mat3
 *
 * @param {mat3} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant$2(a) {
  let a00 = a[0], a01 = a[1], a02 = a[2];
  let a10 = a[3], a11 = a[4], a12 = a[5];
  let a20 = a[6], a21 = a[7], a22 = a[8];

  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}

/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function multiply$6(out, a, b) {
  let a00 = a[0], a01 = a[1], a02 = a[2];
  let a10 = a[3], a11 = a[4], a12 = a[5];
  let a20 = a[6], a21 = a[7], a22 = a[8];

  let b00 = b[0], b01 = b[1], b02 = b[2];
  let b10 = b[3], b11 = b[4], b12 = b[5];
  let b20 = b[6], b21 = b[7], b22 = b[8];

  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;

  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;

  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}

/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to translate
 * @param {vec2} v vector to translate by
 * @returns {mat3} out
 */
function translate$1(out, a, v) {
  let a00 = a[0], a01 = a[1], a02 = a[2],
    a10 = a[3], a11 = a[4], a12 = a[5],
    a20 = a[6], a21 = a[7], a22 = a[8],
    x = v[0], y = v[1];

  out[0] = a00;
  out[1] = a01;
  out[2] = a02;

  out[3] = a10;
  out[4] = a11;
  out[5] = a12;

  out[6] = x * a00 + y * a10 + a20;
  out[7] = x * a01 + y * a11 + a21;
  out[8] = x * a02 + y * a12 + a22;
  return out;
}

/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
function rotate$2(out, a, rad) {
  let a00 = a[0], a01 = a[1], a02 = a[2],
    a10 = a[3], a11 = a[4], a12 = a[5],
    a20 = a[6], a21 = a[7], a22 = a[8],

    s = Math.sin(rad),
    c = Math.cos(rad);

  out[0] = c * a00 + s * a10;
  out[1] = c * a01 + s * a11;
  out[2] = c * a02 + s * a12;

  out[3] = c * a10 - s * a00;
  out[4] = c * a11 - s * a01;
  out[5] = c * a12 - s * a02;

  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/
function scale$6(out, a, v) {
  let x = v[0], y = v[1];

  out[0] = x * a[0];
  out[1] = x * a[1];
  out[2] = x * a[2];

  out[3] = y * a[3];
  out[4] = y * a[4];
  out[5] = y * a[5];

  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Translation vector
 * @returns {mat3} out
 */
function fromTranslation$1(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
function fromRotation$2(out, rad) {
  let s = Math.sin(rad), c = Math.cos(rad);

  out[0] = c;
  out[1] = s;
  out[2] = 0;

  out[3] = -s;
  out[4] = c;
  out[5] = 0;

  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat3} out
 */
function fromScaling$2(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;

  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;

  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}

/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat2d} a the matrix to copy
 * @returns {mat3} out
 **/
function fromMat2d(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = 0;

  out[3] = a[2];
  out[4] = a[3];
  out[5] = 0;

  out[6] = a[4];
  out[7] = a[5];
  out[8] = 1;
  return out;
}

/**
* Calculates a 3x3 matrix from the given quaternion
*
* @param {mat3} out mat3 receiving operation result
* @param {quat} q Quaternion to create matrix from
*
* @returns {mat3} out
*/
function fromQuat(out, q) {
  let x = q[0], y = q[1], z = q[2], w = q[3];
  let x2 = x + x;
  let y2 = y + y;
  let z2 = z + z;

  let xx = x * x2;
  let yx = y * x2;
  let yy = y * y2;
  let zx = z * x2;
  let zy = z * y2;
  let zz = z * z2;
  let wx = w * x2;
  let wy = w * y2;
  let wz = w * z2;

  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;

  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;

  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;

  return out;
}

/**
* Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
*
* @param {mat3} out mat3 receiving operation result
* @param {mat4} a Mat4 to derive the normal matrix from
*
* @returns {mat3} out
*/
function normalFromMat4(out, a) {
  let a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
  let a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
  let a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
  let a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

  let b00 = a00 * a11 - a01 * a10;
  let b01 = a00 * a12 - a02 * a10;
  let b02 = a00 * a13 - a03 * a10;
  let b03 = a01 * a12 - a02 * a11;
  let b04 = a01 * a13 - a03 * a11;
  let b05 = a02 * a13 - a03 * a12;
  let b06 = a20 * a31 - a21 * a30;
  let b07 = a20 * a32 - a22 * a30;
  let b08 = a20 * a33 - a23 * a30;
  let b09 = a21 * a32 - a22 * a31;
  let b10 = a21 * a33 - a23 * a31;
  let b11 = a22 * a33 - a23 * a32;

  // Calculate the determinant
  let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;

  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;

  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;

  return out;
}

/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */
function projection(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}

/**
 * Returns a string representation of a mat3
 *
 * @param {mat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str$6(a) {
  return 'mat3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' +
          a[3] + ', ' + a[4] + ', ' + a[5] + ', ' +
          a[6] + ', ' + a[7] + ', ' + a[8] + ')';
}

/**
 * Returns Frobenius norm of a mat3
 *
 * @param {mat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob$2(a) {
  return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2)))
}

/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function add$6(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  return out;
}

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
function subtract$5(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  return out;
}



/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */
function multiplyScalar$2(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  return out;
}

/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */
function multiplyScalarAndAdd$2(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  out[3] = a[3] + (b[3] * scale);
  out[4] = a[4] + (b[4] * scale);
  out[5] = a[5] + (b[5] * scale);
  out[6] = a[6] + (b[6] * scale);
  out[7] = a[7] + (b[7] * scale);
  out[8] = a[8] + (b[8] * scale);
  return out;
}

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals$6(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] &&
         a[3] === b[3] && a[4] === b[4] && a[5] === b[5] &&
         a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals$6(a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
          Math.abs(a3 - b3) <= EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
          Math.abs(a4 - b4) <= EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
          Math.abs(a5 - b5) <= EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
          Math.abs(a6 - b6) <= EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
          Math.abs(a7 - b7) <= EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
          Math.abs(a8 - b8) <= EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)));
}

/**
 * Alias for {@link mat3.multiply}
 * @function
 */
const mul$6 = multiply$6;

/**
 * Alias for {@link mat3.subtract}
 * @function
 */
const sub$5 = subtract$5;

var mat3 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$6,
   fromMat4: fromMat4,
   clone: clone$6,
   copy: copy$6,
   fromValues: fromValues$6,
   set: set$6,
   identity: identity$3,
   transpose: transpose$1,
   invert: invert$3,
   adjoint: adjoint$1,
   determinant: determinant$2,
   multiply: multiply$6,
   translate: translate$1,
   rotate: rotate$2,
   scale: scale$6,
   fromTranslation: fromTranslation$1,
   fromRotation: fromRotation$2,
   fromScaling: fromScaling$2,
   fromMat2d: fromMat2d,
   fromQuat: fromQuat,
   normalFromMat4: normalFromMat4,
   projection: projection,
   str: str$6,
   frob: frob$2,
   add: add$6,
   subtract: subtract$5,
   multiplyScalar: multiplyScalar$2,
   multiplyScalarAndAdd: multiplyScalarAndAdd$2,
   exactEquals: exactEquals$6,
   equals: equals$6,
   mul: mul$6,
   sub: sub$5
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */
function create$5() {
  let out = new ARRAY_TYPE(3);
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  return out;
}

/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */
function clone$5(a) {
  var out = new ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}

/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */
function length$3(a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  return Math.sqrt(x*x + y*y + z*z);
}

/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */
function fromValues$5(x, y, z) {
  let out = new ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}

/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */
function copy$5(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}

/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */
function set$5(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}

/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function add$5(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}

/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function subtract$4(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}

/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function multiply$5(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}

/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function divide$2(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}

/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to ceil
 * @returns {vec3} out
 */
function ceil$2(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}

/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to floor
 * @returns {vec3} out
 */
function floor$2(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}

/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function min$2(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}

/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function max$2(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}

/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to round
 * @returns {vec3} out
 */
function round$2(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}

/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */
function scale$5(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}

/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */
function scaleAndAdd$2(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  return out;
}

/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */
function distance$2(a, b) {
  let x = b[0] - a[0];
  let y = b[1] - a[1];
  let z = b[2] - a[2];
  return Math.sqrt(x*x + y*y + z*z);
}

/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance$2(a, b) {
  let x = b[0] - a[0];
  let y = b[1] - a[1];
  let z = b[2] - a[2];
  return x*x + y*y + z*z;
}

/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength$3(a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  return x*x + y*y + z*z;
}

/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */
function negate$2(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}

/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */
function inverse$2(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}

/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */
function normalize$3(out, a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  let len = x*x + y*y + z*z;
  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
  }
  return out;
}

/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot$3(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
function cross$1(out, a, b) {
  let ax = a[0], ay = a[1], az = a[2];
  let bx = b[0], by = b[1], bz = b[2];

  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}

/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function lerp$3(out, a, b, t) {
  let ax = a[0];
  let ay = a[1];
  let az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}

/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function hermite(out, a, b, c, d, t) {
  let factorTimes2 = t * t;
  let factor1 = factorTimes2 * (2 * t - 3) + 1;
  let factor2 = factorTimes2 * (t - 2) + t;
  let factor3 = factorTimes2 * (t - 1);
  let factor4 = factorTimes2 * (3 - 2 * t);

  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;

  return out;
}

/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
function bezier(out, a, b, c, d, t) {
  let inverseFactor = 1 - t;
  let inverseFactorTimesTwo = inverseFactor * inverseFactor;
  let factorTimes2 = t * t;
  let factor1 = inverseFactorTimesTwo * inverseFactor;
  let factor2 = 3 * t * inverseFactorTimesTwo;
  let factor3 = 3 * factorTimes2 * inverseFactor;
  let factor4 = factorTimes2 * t;

  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;

  return out;
}

/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */
function random$2(out, scale) {
  scale = scale || 1.0;

  let r = RANDOM() * 2.0 * Math.PI;
  let z = (RANDOM() * 2.0) - 1.0;
  let zScale = Math.sqrt(1.0-z*z) * scale;

  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}

/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */
function transformMat4$2(out, a, m) {
  let x = a[0], y = a[1], z = a[2];
  let w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}

/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */
function transformMat3$1(out, a, m) {
  let x = a[0], y = a[1], z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}

/**
 * Transforms the vec3 with a quat
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec3} out
 */
function transformQuat$1(out, a, q) {
  // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations

  let x = a[0], y = a[1], z = a[2];
  let qx = q[0], qy = q[1], qz = q[2], qw = q[3];

  // calculate quat * vec
  let ix = qw * x + qy * z - qz * y;
  let iy = qw * y + qz * x - qx * z;
  let iz = qw * z + qx * y - qy * x;
  let iw = -qx * x - qy * y - qz * z;

  // calculate result * inverse quat
  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  return out;
}

/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateX$1(out, a, b, c){
  let p = [], r=[];
  //Translate point to the origin
  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2];

  //perform rotation
  r[0] = p[0];
  r[1] = p[1]*Math.cos(c) - p[2]*Math.sin(c);
  r[2] = p[1]*Math.sin(c) + p[2]*Math.cos(c);

  //translate to correct position
  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];

  return out;
}

/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateY$1(out, a, b, c){
  let p = [], r=[];
  //Translate point to the origin
  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2];

  //perform rotation
  r[0] = p[2]*Math.sin(c) + p[0]*Math.cos(c);
  r[1] = p[1];
  r[2] = p[2]*Math.cos(c) - p[0]*Math.sin(c);

  //translate to correct position
  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];

  return out;
}

/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
function rotateZ$1(out, a, b, c){
  let p = [], r=[];
  //Translate point to the origin
  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2];

  //perform rotation
  r[0] = p[0]*Math.cos(c) - p[1]*Math.sin(c);
  r[1] = p[0]*Math.sin(c) + p[1]*Math.cos(c);
  r[2] = p[2];

  //translate to correct position
  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];

  return out;
}

/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */
function angle(a, b) {
  let tempA = fromValues$5(a[0], a[1], a[2]);
  let tempB = fromValues$5(b[0], b[1], b[2]);

  normalize$3(tempA, tempA);
  normalize$3(tempB, tempB);

  let cosine = dot$3(tempA, tempB);

  if(cosine > 1.0) {
    return 0;
  }
  else if(cosine < -1.0) {
    return Math.PI;
  } else {
    return Math.acos(cosine);
  }
}

/**
 * Returns a string representation of a vector
 *
 * @param {vec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$5(a) {
  return 'vec3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')';
}

/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$5(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$5(a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2];
  let b0 = b[0], b1 = b[1], b2 = b[2];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)));
}

/**
 * Alias for {@link vec3.subtract}
 * @function
 */
const sub$4 = subtract$4;

/**
 * Alias for {@link vec3.multiply}
 * @function
 */
const mul$5 = multiply$5;

/**
 * Alias for {@link vec3.divide}
 * @function
 */
const div$2 = divide$2;

/**
 * Alias for {@link vec3.distance}
 * @function
 */
const dist$2 = distance$2;

/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */
const sqrDist$2 = squaredDistance$2;

/**
 * Alias for {@link vec3.length}
 * @function
 */
const len$3 = length$3;

/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */
const sqrLen$3 = squaredLength$3;

/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach$2 = (function() {
  let vec = create$5();

  return function(a, stride, offset, count, fn, arg) {
    let i, l;
    if(!stride) {
      stride = 3;
    }

    if(!offset) {
      offset = 0;
    }

    if(count) {
      l = Math.min((count * stride) + offset, a.length);
    } else {
      l = a.length;
    }

    for(i = offset; i < l; i += stride) {
      vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2];
      fn(vec, vec, arg);
      a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2];
    }

    return a;
  };
})();

var vec3 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$5,
   clone: clone$5,
   length: length$3,
   fromValues: fromValues$5,
   copy: copy$5,
   set: set$5,
   add: add$5,
   subtract: subtract$4,
   multiply: multiply$5,
   divide: divide$2,
   ceil: ceil$2,
   floor: floor$2,
   min: min$2,
   max: max$2,
   round: round$2,
   scale: scale$5,
   scaleAndAdd: scaleAndAdd$2,
   distance: distance$2,
   squaredDistance: squaredDistance$2,
   squaredLength: squaredLength$3,
   negate: negate$2,
   inverse: inverse$2,
   normalize: normalize$3,
   dot: dot$3,
   cross: cross$1,
   lerp: lerp$3,
   hermite: hermite,
   bezier: bezier,
   random: random$2,
   transformMat4: transformMat4$2,
   transformMat3: transformMat3$1,
   transformQuat: transformQuat$1,
   rotateX: rotateX$1,
   rotateY: rotateY$1,
   rotateZ: rotateZ$1,
   angle: angle,
   str: str$5,
   exactEquals: exactEquals$5,
   equals: equals$5,
   sub: sub$4,
   mul: mul$5,
   div: div$2,
   dist: dist$2,
   sqrDist: sqrDist$2,
   len: len$3,
   sqrLen: sqrLen$3,
   forEach: forEach$2
});

function getVertexKey(vertex) {
    return `${Math.floor(vertex[0] * 10000) / 10000},${Math.floor(vertex[1] * 10000) / 10000},${Math.floor(vertex[2] * 10000) / 10000}`;
}

class GeometryBuffer {
	
	constructor(gl, size) {
		if (!gl) {
			return;
		}
		this.gl = gl;
		this.attributes = {};
		this.length = size || 0;
		this.groups = [];// different materials
		// this.vertices = [];
		// this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		// this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		// this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		// this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
	}

	addAttribute(attribName, data, size, geometry, type) {
		this.attributes[attribName] = new ArrayBuffer$1(this.gl, data, size, attribName === 'index', geometry, type);//true=use element array buffer
	}
	
	addInstancedAttribute(attribName, data, size, geometry, type) {
		this.attributes[attribName] = new InstancedArrayBuffer(this.gl, data, size, attribName === 'index', geometry, type);//true=use element array buffer
	}

	getBoundingBox() {
		if (!this.boudingBox) {
			this.computeBoudingBox();
		}
		return this.boudingBox
	}
	// Legacy support for old typo in function name
	computeBoudingBox(origin) {
		return this.computeBoundingBox(origin);
	}
	computeBoundingBox(origin) {
		if (!this.attributes.position) {
			return;
		}
		let min = fromValues$5(Infinity,Infinity,Infinity);
		let max = fromValues$5(-Infinity,-Infinity,-Infinity);
		let positions = this.attributes.position.data;
		for (let i=0; i<positions.length; i+=3) {
			min[0] = Math.min(min[0], positions[i+0]);
			min[1] = Math.min(min[1], positions[i+1]);
			min[2] = Math.min(min[2], positions[i+2]);
			max[0] = Math.max(max[0], positions[i+0]);
			max[1] = Math.max(max[1], positions[i+1]);
			max[2] = Math.max(max[2], positions[i+2]);
		}
		let boundingBoxCenter = create$5();
		boundingBoxCenter[0] = min[0] + (max[0] + min[0]*-1) * .5;
		boundingBoxCenter[1] = min[1] + (max[1] + min[1]*-1) * .5;
		boundingBoxCenter[2] = min[2] + (max[2] + min[2]*-1) * .5;
		let boudingBoxWidth  = Math.abs(max[0]-boundingBoxCenter[0])*2;
		let boudingBoxHeight = Math.abs(max[1]-boundingBoxCenter[1])*2;
		let boudingBoxDepth  = Math.abs(max[2]-boundingBoxCenter[2])*2;
		this.boundingBox =  {
			center: boundingBoxCenter,
			width:  boudingBoxWidth,
			height: boudingBoxHeight,
			depth:  boudingBoxDepth,
			min:   [min[0],min[1],min[2]],
			max:   [max[0],max[1],max[2]],
			aabb: [
				min[0],min[1],min[2],
				max[0],max[1],max[2]
			]
		};
		// Legacy: old bug used thie wrong synatx for 'boundingBox'
		this.boudingBox = this.boundingBox;
	}

	computeBoundingSphere() {
if (!this.attributes.position) {
			return;
		}
		let minX = 100000;
		let minY = 100000;
		let minZ = 100000;
		let maxX = -100000;
		let maxY = -100000;
		let maxZ = -100000;
		let positions = this.attributes.position.data;
		for (let i=0; i<positions.length; i+=3) {
			if (positions[i+0] < minX)  minX = positions[i+0];
			if (positions[i+0] > maxX)  maxX = positions[i+0];
			if (positions[i+1] < minY)  minY = positions[i+1];
			if (positions[i+1] > maxY)  maxY = positions[i+1];
			if (positions[i+2] < minZ)  minZ = positions[i+2];
			if (positions[i+2] > maxZ)  maxZ = positions[i+2];
		}
		let boundingSphereCenter = create$5();
		boundingSphereCenter[0] = minX + (maxX + minX*-1) * .5;
		boundingSphereCenter[1] = minY + (maxY + minY*-1) * .5;
		boundingSphereCenter[2] = minZ + (maxZ + minZ*-1) * .5;
		let boundingSphereRadius = 0;
		let p = create$5();
		for (let i=0; i<positions.length; i+=3) {
			set$5(p, positions[i+0], positions[i+1], positions[i+2]);
			subtract$4( p, p, boundingSphereCenter );
			boundingSphereRadius = Math.max( boundingSphereRadius, (length$3(p)) );
		}
		this.boundingSphere = {
			center: boundingSphereCenter,
			radius: boundingSphereRadius,
		};
	}
	getBoundingSphere() {
		if (!this.boundingSphere) {
			this.computeBoundingSphere();
		}
		return this.boundingSphere;
	}

	getAttribute(name) {
		return this.attributes[name]
	}
	
	computeVertexNormals() {

		if (!this.attributes.position) {
			// console.warn('cannot compute vertex normals: missing `position` attribute on the geometry')
			return
		}

		const positions  = this.attributes.position.data;
		const verticesTriangles = new Map();
		let triIndex = 0;
		for ( let i = 0; i < positions.length; i += 9 ) {
			const a    = [ positions[ i + 0 ],  positions[ i + 1 ],  positions[ i + 2 ] ];
			const b    = [ positions[ i + 3 ],  positions[ i + 4 ],  positions[ i + 5 ] ];
			const c    = [ positions[ i + 6 ],  positions[ i + 7 ],  positions[ i + 8 ] ];
			const aKey = getVertexKey(a);
			const bKey = getVertexKey(b);
			const cKey = getVertexKey(c);
			if ( !verticesTriangles.has(aKey) ) {
				verticesTriangles.set(aKey, new Set() );
			}
			if ( !verticesTriangles.has(bKey) ) {
				verticesTriangles.set(bKey, new Set() );
			}
			if ( !verticesTriangles.has(cKey) ) {
				verticesTriangles.set(cKey, new Set() );
			}
			verticesTriangles.get(aKey).add(triIndex);
			verticesTriangles.get(bKey).add(triIndex);
			verticesTriangles.get(cKey).add(triIndex);
			triIndex++;
		}

		const verticesNormals = new Map();
		for (const [key,v1] of verticesTriangles) {
			const triIndices = Array.from(v1);
			const connectedNormals = [];
			for (let i=0; i<triIndices.length; i++) {
				const triangleIndex = triIndices[i];
				let pA = [
					positions[ triangleIndex * 9 + 0 ],
					positions[ triangleIndex * 9 + 1 ],
					positions[ triangleIndex * 9 + 2 ]
				];
				let pB = [
					positions[ triangleIndex * 9 + 3 ],
					positions[ triangleIndex * 9 + 4 ],
					positions[ triangleIndex * 9 + 5 ]
				];
				let pC = [
					positions[ triangleIndex * 9 + 6 ],
					positions[ triangleIndex * 9 + 7 ],
					positions[ triangleIndex * 9 + 8 ]
				];
				let cb = create$5(); 
				let ab = create$5();
				subtract$4( cb, pC, pB );
				subtract$4( ab, pA, pB );
				cross$1( cb, cb, ab );
				normalize$3(cb, cb);
				connectedNormals.push( cb );
			}
			let avNormal = [0,0,0];
			for (let j=0; j<connectedNormals.length; j++) {
				avNormal[0] += connectedNormals[j][0];
				avNormal[1] += connectedNormals[j][1];
				avNormal[2] += connectedNormals[j][2];
			}
			if (connectedNormals.length > 0) {
				avNormal[0] /= connectedNormals.length;
				avNormal[1] /= connectedNormals.length;
				avNormal[2] /= connectedNormals.length;
			}
			let nA = create$5();
			copy$5(nA, avNormal);
			normalize$3( nA, nA );
			verticesNormals.set( key, nA );
		}

		const normals = [];
		for ( let i = 0; i < positions.length; i+=3 ) {
			const v = [
				positions[ i + 0 ], 
				positions[ i + 1 ], 
				positions[ i + 2 ]
			];
			const vKey      = getVertexKey(v);
			const normalSet = verticesNormals.get(vKey);
			const n = Array.from(normalSet);
			normals.push( n[0], n[1], n[2] );
		}

		if (this.attributes['normal']) {
			this.attributes['normal'].update( new Float32Array(this.attributes.position.data.length), 3 );
		}
		else {
			this.addAttribute('normal', new Float32Array(this.attributes.position.data.length), 3 );
		}
	}

	computeVertexNormals2() {
		if (!this.attributes.position) {
			return
		}
		this.attributes.position.data;
		if (this.attributes['normal']) {
			this.attributes['normal'].update( new Float32Array(this.attributes.position.data.length), 3 );
		}
		else {
			this.addAttribute('normal', new Float32Array(this.attributes.position.data.length), 3 );
		}
	}

	addGroup( start, count, materialIndex = 0 ) {
		this.groups.push({
			start:         start,
			count:         count,
			materialIndex: materialIndex
		});
	}

}

const UNIFORM_TYPES = {};
UNIFORM_TYPES[ 5126  /*FLOAT       */ ] = '1f';
UNIFORM_TYPES[ 35664 /*FLOAT_VEC2  */ ] = '2f';
UNIFORM_TYPES[ 35665 /*FLOAT_VEC3  */ ] = '3f';
UNIFORM_TYPES[ 35666 /*FLOAT_VEC4  */ ] = '4f';

UNIFORM_TYPES[ 35670 /*BOOL        */ ]     = '1i';
UNIFORM_TYPES[ 5124  /*INT         */ ]     = '1i';
UNIFORM_TYPES[ 35678 /*SAMPLER_2D  */ ]     = '1i';
UNIFORM_TYPES[ 35679 /*SAMPLER_3D */ ]      = '1i';  
UNIFORM_TYPES[ 35680 /*SAMPLER_CUBE*/ ]     = '1i';  
UNIFORM_TYPES[ 36289 /*SAMPLER_2D_ARRAY*/ ] = '1i';

UNIFORM_TYPES[ 35671 /*BOOL_VEC2   */ ] = '2i';
UNIFORM_TYPES[ 35667 /*INT_VEC2    */ ] = '2i';

UNIFORM_TYPES[ 35672 /*BOOL_VEC3   */ ] = '3i';
UNIFORM_TYPES[ 35668 /*INT_VEC3    */ ] = '3i';

UNIFORM_TYPES[ 35673 /*BOOL_VEC4   */ ] = '4i';
UNIFORM_TYPES[ 35669 /*INT_VEC4    */ ] = '4i';

UNIFORM_TYPES[ 35674 /*FLOAT_MAT2  */ ] = 'Matrix2f';
UNIFORM_TYPES[ 35675 /*FLOAT_MAT3  */ ] = 'Matrix3f';
UNIFORM_TYPES[ 35676 /*FLOAT_MAT4  */ ] = 'Matrix4f';

var vertexShader = "precision highp float;\n\nattribute vec2 uv;\nattribute vec3 position;\n\nuniform mat4 uMVMatrix;\nuniform mat4 uPMatrix;\n\nvarying vec2 vUv;\n\nvoid main(void) {\nvUv = uv;\ngl_Position = uPMatrix * uMVMatrix * vec4(position, 1.0);\n}"; // eslint-disable-line

var defaultFragmentShader = "precision highp float;\n\nuniform float alpha;\nvarying vec2 vUv;\n\nvoid main(void) {\ngl_FragColor = vec4( vec3(1., 1., 1.), alpha);\n}"; // eslint-disable-line

// http://www.broofa.com/Tools/Math.uuid.htm
var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
var uuid = new Array( 36 );
var rnd = 0, r;

function generateUUID() {

	for ( var i = 0; i < 36; i ++ ) {

		if ( i === 8 || i === 13 || i === 18 || i === 23 ) {

			uuid[ i ] = '-';

		} else if ( i === 14 ) {

			uuid[ i ] = '4';

		} else {

			if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
			r = rnd & 0xf;
			rnd = rnd >> 4;
			uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];

		}

	}

	return uuid.join( '' );

}

const settings$1 = {

};

/**
 * This function handles '#pragma unroll' directive without 
 * the need for unroll end direction or replacing iterator variable as they do in three js
 */
function unrollLoops(source) {
  let src = String(source);
  if (!/#pragma\s+unroll/.test(src)) return src;
  // Collect #define NAME VALUE
  const defines = {};
  src.replace(/#define\s+([_A-Za-z]\w*)\s+(\d+)/g, (_, name, value) => {
    defines[name] = value;
  });
  // Matches: #pragma unroll for (int i = X; i < Y; i++) {
  const re = /#pragma\s+unroll\s+for\s*\(\s*int\s+([_A-Za-z]\w*)\s*=\s*(\d+)\s*;\s*[_A-Za-z]\w*\s*<\s*([_A-Za-z]\w*)\s*;\s*[_A-Za-z]\w*\+\+\s*\)\s*\{/g;
  let m;
  while ((m = re.exec(src)) !== null) {
    const [match, iterator, startRaw, endRaw] = m;
    const matchIndex = m.index;
    // Find the matching closing brace of the loop body
    const loopStart = matchIndex + match.length;
    let depth = 1;
    let i = loopStart;
    while (i < src.length && depth > 0) {
      const ch = src[i++];
      if (ch === '{') depth++;
      else if (ch === '}') depth--;
    }
    if (depth !== 0) {
      // Unbalanced braces; bail out safely.
      break;
    }
    const loopEnd = i - 1; // index of the closing '}'
    // IMPORTANT: slice from the current, updated src
    const loopContent = src.slice(loopStart, loopEnd);
    // Resolve defines, then numeric parse
    const start = parseInt(defines[startRaw] ?? startRaw, 10);
    const end   = parseInt(defines[endRaw]   ?? endRaw,   10);
    let out = '';
    for (let k = start; k < end; k++) {
      // note that we use brackers to create scope and avoid variable conflicts
      out += `{\n` +
        loopContent
          .replace(new RegExp(`\\[\\s*${iterator}\\s*\\]`, 'g'), `[ ${k} ]`)
          .replace(new RegExp(`\\b${iterator}\\b`, 'g'), String(k)) +
        `\n}`;
    }
    // Splice replacement into the evolving buffer
    src = src.slice(0, matchIndex) + out + src.slice(loopEnd + 1);
    // Move regex cursor past what we just inserted
    re.lastIndex = matchIndex + out.length;
  }
  return src;
}

function addLineNumbers( string, lineNumber ) {
  var lines = string.split( '\n' );
  let nLines = [];
  for ( var i = 0; i < lines.length; i ++ ) {
    if ( lineNumber && (i < lineNumber - 20 || i > lineNumber + 20) ) continue
    lines[ i ] = ( i + 1 ) + ': ' + lines[ i ];
    nLines.push( lines[ i ] );
  }
  return nLines.join( '\n' );
}
 
function handleImports(source) {
    return source;
} 

function compile( gl, shader, code, defines ){

    let source   = code.trim();
    
    // /* Webgl2: make sure version is always defined first */
    let version = '';
    let initSource = source;
    source = source.replace(/\#version[^\n\r]+/, (a,b,c)=>{
      version = a;
      return ''
    });

    var definesStr = '';
    for (var d in defines) {
      if (defines[d] !== null && defines[d] !== void 0) {
        definesStr += '#define '+d+' '+defines[d]+'\n';
      }
    }

    source = version + '\n' + definesStr + '\n' + source;

    source = handleImports( source );
    source = unrollLoops( source );

    gl.shaderSource( shader, source );
    gl.compileShader( shader );

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        console.error('Shader cannot compile: \n' + (gl.getShaderInfoLog(shader) || "") );
        console.log('ERROR: initSource', initSource);
        
        if ( gl.getShaderInfoLog(shader)) {
            let lineErr = Number( gl.getShaderInfoLog(shader).match(/ERROR\:\s0\:([^:]+)\:/)[1] );
            console.warn(addLineNumbers(source, lineErr));
        }
        else {
            console.log("shader issue", source);
        }
        return false;
    }

    return true;
}



var ShaderCompiler = {
    compile,
    settings: settings$1
};

const IS_SAFARI = /Safari/g.test(navigator.userAgent) && !/Chrome/g.test(navigator.userAgent);
const TEXTURE_2D       = 35678;
const TEXTURE_3D       = 35679; 
const TEXTURE_CUBE_MAP = 35680;
const SAMPLER_2D_ARRAY = 36289;
// let angle_instanced_array;
let currentState = {
  attributes: [],
  uniforms: {},
  depthTest:  null,
  blend: false,
  program: null,
  geometry: null
};


class Program {

  constructor(gl, options={}) {

    if (options.name) {
      this.name = options.name;
    }
    if (options.id) {
      this.id = options.id;
    }

    this._uuid = generateUUID();
    this.uuid = this._uuid;

    if (!gl) {
      return;
    }

    options = Object.assign({}, {
      vertexShader:   vertexShader,
      fragmentShader: defaultFragmentShader,
      defines:    {},
      extentions: {},
      type: gl.TRIANGLES,
      uniforms: {},
      transformFeedbackVaryings: null
    }, options);

    this.options = options;
    
    this._vertexShaderSource   = options.vertexShader;
    this._fragmentShaderSource = options.fragmentShader;

    this.name = options.name;

    this.gl             = gl;
    this._program       = gl.createProgram(this.name);
    this.vertexShader   = gl.createShader( gl.VERTEX_SHADER );
    this.fragmentShader = gl.createShader( gl.FRAGMENT_SHADER );

    gl.attachShader(this._program, this.vertexShader);
    gl.attachShader(this._program, this.fragmentShader);
    
    if (options.transformFeedbackVaryings) {
      this.transformFeedback = gl.createTransformFeedback();
      gl.bindTransformFeedback(gl.TRANSFORM_FEEDBACK, this.transformFeedback);
      gl.transformFeedbackVaryings( this._program, options.transformFeedbackVaryings, gl.SEPARATE_ATTRIBS );
    }

    this.type          = options.type;
    this.attributes    = {};
    this.defines       = options.defines;
    this._lastDefines  = {};
    this.extentions    = options.extentions;

    this._textureUnit  = 0;

    this.depthTest     = options.depthTest     !== void 0 ? options.depthTest     : true ;
    this.blend         = options.blend         !== void 0 ? options.blend         : false ;
    this.blendEquation = options.blendEquation !== void 0 ? options.blendEquation : this.gl.FUNC_ADD ;

    this.blendEquationSeparate = options.blendEquationSeparate !== void 0 ? options.blendEquationSeparate :  null ;

    this.blendSrc      = options.blendSrc      !== void 0 ? options.blendSrc      : this.gl.SRC_ALPHA ;
    this.blendDst      = options.blendDst      !== void 0 ? options.blendDst      : this.gl.ONE_MINUS_SRC_ALPHA ;
    this.blendSrcRGB   = options.blendSrcRGB   !== void 0 ? options.blendSrcRGB   : this.gl.SRC_ALPHA ;
    this.blendDstRGB   = options.blendDstRGB   !== void 0 ? options.blendDstRGB   : this.gl.ONE_MINUS_SRC_ALPHA ;
    this.blendSrcAlpha = options.blendSrcAlpha !== void 0 ? options.blendSrcAlpha : this.gl.ONE ;
    this.blendDstAlpha = options.blendDstAlpha !== void 0 ? options.blendDstAlpha : this.gl.ONE_MINUS_SRC_ALPHA ;
    this.wireframe     = options.wireframe     !== void 0 ? options.wireframe     : false ;
    this.lines        = options.lines     !== void 0 ? options.lines     : false ;


    this.uniforms = {};
    this.defaultUniforms = options.uniforms;
    this.compile();

  }

  compile(force) {

    if (!this.gl) {
      return;
    }
    
    if (this.isCompiling) {
      return;
    }

    this.isCompiling = true;
 
    //fix: this forces Safari to update ACTIVE_UNIFORMS after first compile()
    if (IS_SAFARI || force) {
      this.gl.detachShader(this._program, this.vertexShader);
      this.gl.detachShader(this._program, this.fragmentShader);
      this.vertexShader   = this.gl.createShader( this.gl.VERTEX_SHADER );
      this.fragmentShader = this.gl.createShader( this.gl.FRAGMENT_SHADER );
      this.gl.attachShader(this._program, this.vertexShader);
      this.gl.attachShader(this._program, this.fragmentShader);
    }

    if( !( ShaderCompiler.compile( this.gl, this.vertexShader,   this._vertexShaderSource, this.defines ) &&
           ShaderCompiler.compile( this.gl, this.fragmentShader, this._fragmentShaderSource, this.defines ) ) ) {
      console.warn('compile error');
      return false;
    }

    this.gl.linkProgram(this._program);

    if (!this.gl.getProgramParameter(this._program, this.gl.LINK_STATUS)) {
      console.error("Cannot link program: \n" + this.gl.getProgramInfoLog(this._program) || "");
      // console.warn("VERTEX_SHADER:\n"+addLineNumbers(this._vertexShaderSource)
      //             +"\n\nFRAGMENT_SHADER:\n"+addLineNumbers(this._fragmentShaderSource));
    }

    this.gl.useProgram(this._program);
    this._retrieveUniformsFromShader();

  }

  _retrieveUniformsFromShader() {

    /**
     * When re-compiling, we dont wanna loose current uniform values
     * another appoch would be to set uniforms on Program instead of tagrte uniform.value:
     * program.uniform[uniformName]
     *   instead of 
     *  program.uniforms[uniformName].value
     */
    this._savedUniforms = {};
    for (let k in this.uniforms) {
      this._savedUniforms[k] = {
        value: this.uniforms[k].value
      };
    }

    this.uniforms      = {};
    this._textureUnit = 0;

    var numUniforms = this.gl.getProgramParameter( this._program, this.gl.ACTIVE_UNIFORMS );

    for (let i = 0; i < numUniforms; ++i) {
      
      var uniform = this.gl.getActiveUniform( this._program, i );


      if( uniform === null ){
        this.gl.getError();
        continue;
      }

      let name = uniform.name;

      let isArray = false;//is uniform array  ?(ex: 3fv, 4fv...)

      // tltr; we want 'myUniform[0]' to become 'myUniform'
      // if array uniform, replace the retrieved name as it includes the first index acces
      if (/\[.*\]/.test(name) ) {
        isArray = true;
        name = name.replace(/\[.*\]/,'');
      }

      if (this.uniforms[ name ] !== void 0) {
        this.uniforms[ name ].location = this.gl.getUniformLocation( this._program, name );
        this.uniforms[ name ].type = uniform.type;

      }
      else {

        this.uniforms[ name ] = {
          isArray: isArray,
          location: this.gl.getUniformLocation( this._program, name ),
          type: uniform.type,
          value: null,
          oldValue: null,
          size: uniform.size
        };
      
        //set texture unit
        if (uniform.type === TEXTURE_2D || uniform.type === TEXTURE_CUBE_MAP || uniform.type == TEXTURE_3D || uniform.type == SAMPLER_2D_ARRAY ) {
          this.uniforms[ name ].unit = this._textureUnit;
          this._textureUnit++;
        }
      
      }

    }
    //merge user defined uniforms
    for (let u in this._savedUniforms) {
        if (this.uniforms[u] !== void 0){ 
          if (this._savedUniforms[u].value !== void 0 
              && this._savedUniforms[u].value !== null) {
            this.uniforms[u].value = this._savedUniforms[u].value;
          }
        }
    }

    /**
     * Restore unfiroms values set on Program creation by user
     */
    for (let u in this.defaultUniforms) {
      if (this.uniforms[u] !== void 0 
        && this.defaultUniforms[u] !== void 0 
          && this.defaultUniforms[u] !== null) {
          this.uniforms[u].value = this.defaultUniforms[u];
      }
    }

    var numAttributes = this.gl.getProgramParameter( this._program, this.gl.ACTIVE_ATTRIBUTES );

    
    for (let i = 0; i < numAttributes; ++i) {
      
      var attribute = this.gl.getActiveAttrib( this._program, i );
        
      if( attribute === null ){
        this.gl.getError();
        continue;
      } 

      this.attributes[ attribute.name ] = {
        location: this.gl.getAttribLocation( this._program, attribute.name ),
        type: attribute.type
      };

      //the attribute is only enabled when the buffer is binded
      //(so it's enabled by the Program that will use the buffer)
      //this way we make sure that any enabled attribute has some data not to trigger an error
      //see http://www.mjbshaw.com/2013/03/webgl-fixing-invalidoperation.html
      // this.gl.enableVertexAttribArray( this.attributes[attribute.name].location );
    
    }

    this.isCompiling = false;
  }

  dispose() {

  }

  use () {
    if (!this.gl) {
      return;
    }
    this.gl.useProgram(this._program);
  }

  attribPointer(geometry) {

    if (!this.gl) {
      console.warn('Program.attribPointer error: missing gl');
      return;
    }
    
    // angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );

  


    for (var attr in this.attributes) {
      if (geometry.attributes[attr] !== void 0) {
        if (attr == 'instanceMatrix') {
          // const bytesPerMatrix = 16 * 4;
          // for (let i = 0; i < 4; ++i) {
          //   const loc = this.attributes[attr].location + i;
          //   geometry.attributes[attr].bind();
          //   this.gl.enableVertexAttribArray(loc);
          //   this.gl?.vertexAttribDivisor(loc, 1);
          //   const offset = i * 16;  // 4 floats per row, 4 bytes per float
          //   this.gl.vertexAttribPointer(
          //     loc,                // location
          //     4,                  // size (num values to pull from buffer per iteration)
          //     geometry.attributes[attr].type,         // type of data in buffer
          //     false,              // normalize
          //     bytesPerMatrix,     // stride, num bytes to advance to get to next set of values
          //     offset              // offset in buffer
          //   );
          // }
          // in webgl, we cannot pass matrix as single 16 floats array, instead we pass it a 4 rows of 4 floats
          // so  matrix row here is a vec4 attribute, and in the shader, it groups those 4 rows into a mat4
          // const bytesPerMatrix = (16) * 4;//4 bits * 4 flat = 1 row
          for (let i = 0; i < 4; ++i) {
            const loc = this.attributes[attr].location + i;
            this.gl.enableVertexAttribArray(loc);
            this.gl.vertexAttribDivisor(loc, 1);
            geometry.attributes[attr].bind();//bindin the same buffer, but we use different offset/stride
            this.gl.vertexAttribPointer(
              loc, // location
              4, // size (num values to pull from buffer per iteration) : 4 float = 1 row
              this.gl.FLOAT,//geometry.attributes[attr].type, // type of data in buffer
              false, // normalize
              16 * 4,//bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
              i * 4 * 4 // offset in buffer |  4 floats per row, 4 bytes per float
            );
          }
          // console.log('attribPointer', Object.keys(this.attributes))
        }
        // else if (attr == 'instanceCardAtlasInfos0' || attr == 'instanceCardAtlasInfos1' || attr == 'instanceCardAtlasInfos2' || attr == 'instanceCardAtlasInfos3' || attr == 'instanceCardAtlasInfos4' || attr == 'instanceCardAtlasInfos5' ) {
        //   const loc = this.attributes[attr].location;
        //   this.gl.enableVertexAttribArray(loc);
        //   this.gl.vertexAttribDivisor(loc, 1);
        //   geometry.attributes[attr].bind();
        //   this.gl.vertexAttribPointer(
        //     loc, // location
        //     4, // size (num values to pull from buffer per iteration) : 4 float = 1 row
        //     this.gl.FLOAT,//geometry.attributes[attr].type, // type of data in buffer
        //     false, // normalize
        //     4 * 4,//bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
        //     0 // offset in buffer |  4 floats per row, 4 bytes per float
        //   );
        // }

        else if (attr == 'instanceColor' || attr == 'instancePosition' || attr == 'instanceRotation' || attr == 'instanceScale' || attr == 'instanceTilePosition' || attr == 'instanceTileScale') {
          const loc = this.attributes[attr].location;
          // console.log('  -'+attr, "vertexAttribPointer: instanced vec3",loc )
          this.gl.enableVertexAttribArray(loc);
          this.gl.vertexAttribDivisor(loc, 1);
          geometry.attributes[attr].bind();
          this.gl.vertexAttribPointer(
            loc, // location
            3, // size (num values to pull from buffer per iteration) : 4 float = 1 row
            this.gl.FLOAT,//geometry.attributes[attr].type, // type of data in buffer
            false, // normalize
            3 * 4,//bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
            0 // offset in buffer |  4 floats per row, 4 bytes per float
          );
        }
        else if (attr == 'instanceUv' || attr == 'instanceLightmapTileOffset') {
          const loc = this.attributes[attr].location;
          // console.log('  -'+attr, "vertexAttribPointer: instanced vec2",loc )
          this.gl.enableVertexAttribArray(loc);
          this.gl.vertexAttribDivisor(loc, 1);
          geometry.attributes[attr].bind();
          this.gl.vertexAttribPointer(
            loc, // location
            2, // size (num values to pull from buffer per iteration) : 4 float = 1 row
            this.gl.FLOAT,//geometry.attributes[attr].type, // type of data in buffer
            false, // normalize
            2 * 4,//bytesPerMatrix, // stride, num bytes to advance to get to next set of values: 16 float per matrix , with 4 bist per float
            0 // offset in buffer |  4 floats per row, 4 bytes per float
          );
        }
        else if (
          
          // TODO: need to pass this as a settign to the program. maybe setting instances attribute, and their types
          attr == 'instanceShadowVisibility' || attr == 'instanceCardAtlasInfos'  || attr == 'probeIndex' ||  
          attr == 'instanceClusterIndex' || attr == 'instanceFaceAtlasStartIndex' || attr == 'instanceTileLevel' || 
          attr == 'instanceTileIndex'    || attr == 'instanceIndex2' || attr == 'instanceLightmapTileSize' || 
          attr == 'instanceFoliageTileIndex' || attr == 'instanceFoliageIndex' ||
          attr == 'instanceMatrixIndex'

        ) {
          const loc = this.attributes[attr].location ;
          // console.log('  -'+attr, "vertexAttribPointer: instanced float",loc )
          // const bytesPerMatrix = 4 ;
          geometry.attributes[attr].bind();
          this.gl.enableVertexAttribArray(loc);
          this.gl?.vertexAttribDivisor(loc, 1);
          const offset = 0 ;  // 4 bytes per float
          this.gl.vertexAttribPointer(
            loc,              // location
            1,                // size (num values to pull from buffer per iteration)
            geometry.attributes[attr].type,         // type of data in buffer
            false,            // normalize
            1 * 4/*bytesPerMatrix*/,   // stride, num bytes to advance to get to next set of values
            offset,           // offset in buffer
          );
        }
        else 
        {

          const {location, stride, offset} =  this.attributes[attr];
          const {size, type} = geometry.attributes[attr];

          // if (   !currentState.attributes[ location ]
          //     || currentState.attributes[ location ].buffer != geometry.attributes[attr]
              // || !settings.compareAttributes
          // ){
            // if ( currentState.attributes[ location ]
            //      && currentState.attributes[ location ].divisor  ) {
              this.gl?.vertexAttribDivisor( location, 0 );
            // }
            // if (!currentState.attributes[ location ]
                // || !settings.compareAttributes
                // ) {
              this.gl.enableVertexAttribArray(  location );
            // }
            geometry.attributes[attr].bind();
            
            if (offset && stride) {
              this.gl.vertexAttribPointer( location, size, type, false/*normalized*/, stride, offset);
            }
            else {
              this.gl.vertexAttribPointer( location, size, type, false/*normalized*/, 0, 0);
            }
            // currentState.attributes[ location ] = {divisor: false, name: attr, buffer: geometry.attributes[attr]}
          // }


        }
      }
    }
  }


  clone() {
    return 
  }


  //overrides: applied on Scene, passed by Mesh
  // same as overrideMaterial but just for GL states
  draw(geometry, options ) {

    const usetransformFeedback = options?.usetransformFeedback;
    const overrides            = options?.overrides;

  
    if (!this.gl) {
      return;
    }

    let definesL = Object.keys(this.defines);
    let lastDefinesL = Object.keys(this._lastDefines);
    let needsCompile = definesL.length != lastDefinesL.length;

    for (var d in this.defines) {
      if (this.defines[d] !== this._lastDefines[d]) {
        // console.log('NEEDS COMPILE',this.name,  d,this._lastDefines[d], '->',this.defines[d] )
        needsCompile = true;
      }
    }

    if (needsCompile) { 
      this._lastDefines = {};
      for (var d in this.defines) {
        this._lastDefines[d] = this.defines[d]; 
      }

      this.compile();
    }
    if (needsCompile || this._program !== currentState.program) {
      this.gl.useProgram(this._program);
      currentState.program = this._program;
    }
    


          
    //!!! WARNING  THIS OPTIM BREAKS SKY ADN OTHER THINGS ON WINDOWS !!!
    // if (geometry !== _lastUsedGeometry) {
      //TODO: check if geometry has changed
      this.attribPointer(geometry);
    // }

    let _depthTest = overrides?.depthTest != void 0 ? overrides.depthTest : this.depthTest;

    if (_depthTest !== currentState.depthTest) {
      this.gl[ _depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      currentState.depthTest = _depthTest;
    }

    if (overrides?.blend || this.blend) {

      // this.gl.disable(this.gl.DEPTH_TEST);
      // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      if (_depthTest) {
        if (overrides?.depthFunc) {
          this.gl.depthFunc( overrides.depthFunc );
        }
        else {
          this.gl.depthFunc( this.gl.LESS );
        }
      }
      
      if (overrides?.blendEquation) {
        this.gl.blendEquationSeparate(this.blendEquation, overrides?.blendEquation);
        currentState.blendEquation = null;
      }
      else if (overrides?.blendEquationRGB) {
        this.gl.blendEquationSeparate(overrides?.blendEquationRGB, this.blendEquation);
        currentState.blendEquation = null;
      }
      else if (overrides?.blendEquationSeparate) {
        this.gl.blendEquationSeparate(overrides.blendEquationSeparate.rgb, overrides.blendEquationSeparate.alpha);
        currentState.blendEquation = null;
      }
      else {
        if (this.blendEquationSeparate ) {
          this.gl.blendEquationSeparate(this.blendEquationSeparate.rgb, this.blendEquationSeparate.alpha);
        }
        else {
          if (currentState.blendEquation !== (overrides?.blendEquation||overrides?.blendEquationRGB||this.blendEquation)) {
            this.gl.blendEquation((overrides?.blendEquation||overrides?.blendEquationRGB||this.blendEquation));
            currentState.blendEquation = (overrides?.blendEquation||overrides?.blendEquationRGB||this.blendEquation);
          }
        }

      }

      const blendSrcRGB   = (overrides?.blendSrcRGB   !== void 0 ? overrides?.blendSrcRGB   :  this.blendSrcRGB   );
      const blendDstRGB   = (overrides?.blendDstRGB   !== void 0 ? overrides?.blendDstRGB   :  this.blendDstRGB   );
      const blendSrcAlpha = (overrides?.blendSrcAlpha !== void 0 ? overrides?.blendSrcAlpha :  this.blendSrcAlpha );
      const blendDstAlpha = (overrides?.blendDstAlpha !== void 0 ? overrides?.blendDstAlpha :  this.blendDstAlpha );

      if ( 
        currentState.blendSrcRGB   !== blendSrcRGB   || 
        currentState.blendDstRGB   !== blendDstRGB   ||
        currentState.blendSrcAlpha !== blendSrcAlpha ||
        currentState.blendDstAlpha !== blendDstAlpha 
      ) {

        currentState.blendSrcRGB   = blendSrcRGB;
        currentState.blendDstRGB   = blendDstRGB;
        currentState.blendSrcAlpha = blendSrcAlpha;
        currentState.blendDstAlpha = blendDstAlpha;

        this.gl.blendFuncSeparate( blendSrcRGB, blendDstRGB, blendSrcAlpha, blendDstAlpha );

      }

      // this.gl.blendFunc(this.blendSrc,this.blendDst);
      if (!currentState.blend) {
        this.gl.enable(this.gl.BLEND);
        currentState.blend = true;
      }

    }
    else {

      if (currentState.blend) {
        this.gl.disable(this.gl.BLEND);
        currentState.blend = false;
      }
      
      // this.gl[ this.depthTest ? 'enable' : 'disable' ](this.gl.DEPTH_TEST);
      if (overrides?.depthFunc) {
        this.gl.depthFunc( overrides.depthFunc );
      }
      else {
        this.gl.depthFunc( this.gl.LESS );
      }
    
    }

    var keys = Object.keys(this.uniforms);

    for (var i=0,l=keys.length; i<l; i++) 
    {
      let uniformName = keys[i];

      if ( 
           this.uniforms[ uniformName ].value !== null
        && this.uniforms[ uniformName ].value !== void 0
        ){


          switch (this.uniforms[ uniformName ].type) {

            case this.gl.FLOAT_MAT2:
            case this.gl.FLOAT_MAT3:
            case this.gl.FLOAT_MAT4:
                // if (settings.compareUniforms) {
                  // if (this.uniforms[ uniformName ].oldValue !== null && !isNewProgram) {
                  //   needChange = false
                  //   let array1 = this.uniforms[ uniformName ].value;
                  //   let array2 = this.uniforms[ uniformName ].oldValue;
                  //   if (array1.length !== array2.length) {
                  //     needChange = true
                  //   }
                  //   else {
                  //     for (var j = 0; j < array1.length; j++) {
                  //       if (array1[j] !== array2[j]) {
                  //         needChange = true
                  //         break
                  //       }
                  //     }
                  //   }
                  // }
                  // else {
                  //   needChange = true 
                  // }
                // }

                {
                  if (this.uniforms[ uniformName ].value &&  this.uniforms[ uniformName ].value.length > 0) {
                    this.gl['uniform' + UNIFORM_TYPES[this.uniforms[ uniformName ].type]+'v'](this.uniforms[ uniformName ].location, false, this.uniforms[ uniformName ].value);
                    this.uniforms[ uniformName ].oldValue = this.uniforms[ uniformName ].value;
                    currentState.uniforms[ uniformName ] = this.uniforms[ uniformName ].value;
                  }

                }
              break;

            default:
            

              //texture unfirom
              if (this.uniforms[ uniformName ].type === TEXTURE_2D ||
                    this.uniforms[ uniformName ].type === TEXTURE_CUBE_MAP || 
                    this.uniforms[ uniformName ].type === TEXTURE_3D ||
                    this.uniforms[ uniformName ].type === SAMPLER_2D_ARRAY 
              ){
                    // let needChange = true;
                    // if (settings.compareUniforms) {
                      // if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] != void 0 &&
                      //     currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== null && 
                      //     !isNewProgram) {
                      //     needChange = false;
                      //   if (currentBindedSamplers[ this.uniforms[ uniformName ].unit ] !== this.uniforms[ uniformName ].value) {
                      //     needChange = true
                      //   }
                      //   currentBindedSamplers[ this.uniforms[ uniformName ].unit ] = this.uniforms[ uniformName ].value
                      // }
                      // else {
                      //   needChange = true;
                      // }
                    // }
         
                    // if (needChange) {
                      this.uniforms[ uniformName ].value.bind( this.uniforms[ uniformName ].unit );
                      this.gl['uniform' + UNIFORM_TYPES[this.uniforms[ uniformName ].type] ](this.uniforms[ uniformName ].location, this.uniforms[ uniformName ].unit);
                    // }
                }
                else {
      
                  let type = UNIFORM_TYPES[this.uniforms[ keys[i] ].type];
                  
                  //add 'v' to the uniformType if the unifor is an array: ex "3f" => "3fv"
                  if (this.uniforms[ uniformName ].isArray) {
                    type += 'v';
                  }

                  // if (settings.compareUniforms) {
                    // if (currentBindedUniforms[ uniformName ] != void 0 &&
                    //     currentBindedUniforms[ uniformName ] !== null && 
                    //     !isNewProgram) {
                    //       needChange = false;
                    //     if ( typeof currentBindedUniforms[ uniformName ] == 'number') {
                    //       if (currentBindedUniforms[ uniformName ] !== this.uniforms[ uniformName ].value) {
                    //         needChange = true
                    //       }
                    //     }
                    //     else if (currentBindedUniforms[ uniformName ].length) {
                    //       needChange = false
                    //       let array1 = this.uniforms[ uniformName ].value;
                    //       let array2 = currentBindedUniforms[ uniformName ];
                    //       if (array1.length !== array2.length) {
                    //         needChange = true
                    //       }
                    //       else {
                    //         for (var j = 0; j < array1.length; j++) {
                    //           if (array1[j] !== array2[j]) {
                    //             needChange = true
                    //             break
                    //           }
                    //         }
                    //       }
                    //     }
                    //     else {
                    //       needChange = true    
                    //     }
                    //     currentBindedUniforms[ uniformName ] = this.uniforms[ uniformName ].value
                    // }
                    // else {
                    //   needChange = true;
                    // }
                  // }
                  
                  {
                    let v = this.uniforms[ uniformName ].value;
                    switch (type) {
                      case '2f':
                        // console.log('BIND VEC2 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                        this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1]);
                        break;
                      case '3f':  
                        // console.log('BIND VEC3 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                        this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2]);
                      break;
                      case '4f':
                        // console.log('BIND VEC4 UNFIROM ' +uniformName, 'uniform' + type, this.uniforms[ uniformName ].location )
                        this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v[0], v[1], v[2], v[3]);
                        break;
                      default:
                        this.gl['uniform' + type ](this.uniforms[ uniformName ].location, v);
                        break;
                    }
                  }
              }
              break;
          }

      }
    }


    let meshType = overrides?.type != void 0 ? overrides.type : this.type;

    // angle_instanced_array = angle_instanced_array || this.gl.getExtension( 'ANGLE_instanced_arrays' );

    let isInstancing = false;
    let numInstances = 1;
    for (let k in geometry.attributes) {
      // TODO: this is because of virtual geometry instance selection that relies on a instanceIndex attribute, but without instancing
      // the fix is simply to rename this atteibute on cluster to something like "indexInstance".
      // a better fix would be to find a betetr way to detect instancing
      if (/^instance/.test(k) && k !== 'instanceIndex'  ) {
        isInstancing = true;
        numInstances = Math.max(1, geometry.attributes[k].length / geometry.attributes[k].size);
        geometry.attributes[k];
        // console.log('numInstances',numInstances); 
      }
    }
    
    if (geometry.indirectBuffer && geometry.drawCommands) 
    {
      if (!this.multiDrawExtention) {
        this.multiDrawExtention = this.gl.getExtension("WEBGL_multi_draw");
        if (!this.multiDrawExtention) {
          console.error("WEBGL_multi_draw extension not available!");
        }
      }

      // Convert drawCommands buffer to separate arrays
      const drawCount      = geometry.drawCommands.length / 5;
      const firsts         = new Int32Array(drawCount);
      const counts         = new Int32Array(drawCount);
      const instanceCounts = new Int32Array(drawCount);
      const baseInstances  = new Int32Array(drawCount);

      for (let i = 0, j = 0; i < drawCount; i++, j += 5) {
        counts[i]         = geometry.drawCommands[j];        // vertexCount
        instanceCounts[i] = geometry.drawCommands[j + 1];    // instanceCount
        firsts[i]         = geometry.drawCommands[j + 2];    // firstVertex
        baseInstances[i]  = geometry.drawCommands[j + 4];    // baseInstance
      }
      
      // this.gl.bindBuffer(this.gl.DRAW_INDIRECT_BUFFER, geometry.indirectBuffer);

      this.multiDrawExtention.multiDrawArraysInstancedWEBGL(
        this.gl.TRIANGLES,
        firsts, 0,          // First vertices
        counts, 0,          // Vertex counts
        instanceCounts, 0,  // Instance counts
        drawCount
      );

    }
    else if (usetransformFeedback) 
    {
      // console.log('TRANSFORM_FEEDBACK TRANSFORM_FEEDBACK TRANSFORM_FEEDBACK ', geometry.length, overrides, usetransformFeedback )
      this.gl.enable(this.gl.RASTERIZER_DISCARD);
      this.gl.bindTransformFeedback(this.gl.TRANSFORM_FEEDBACK, this.transformFeedback);
      this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, overrides.transformFeedBackBuffer);
      this.gl.beginTransformFeedback(this.gl.POINTS);
      this.gl.drawArrays(this.gl.POINTS, 0, geometry.length);
      this.gl.endTransformFeedback();
      this.gl.bindBufferBase(this.gl.TRANSFORM_FEEDBACK_BUFFER, 0, null);
      this.gl.disable(this.gl.RASTERIZER_DISCARD);
    }
    else if (isInstancing) 
    {
      
      // geometry.attributes['instanceFoliageIndex'] !== void 0 && instanceAttributeName !== 'instanceFoliageIndex' && console.log('instanceAttributeName', instanceAttributeName, numInstances);
      
      let indices = geometry.attributes['index'];
      if ( indices ) {
        let indicesType = this.gl.UNSIGNED_SHORT;
        if (indices.data instanceof Uint32Array) {
          indicesType = this.gl.UNSIGNED_INT;
        } 
        // else if (indices instanceof Uint8Array) {
        //   indicesType = this.gl.UNSIGNED_BYTE;
        // }
        indices.bind();
        this.gl.drawElementsInstanced(
          this.lines ? this.gl.LINES  : (this.wireframe ? this.gl.LINE_STRIP : meshType),
          indices.length,
          indicesType,
          0,   // offset
          numInstances  // num instances
        );
      }
      else {
        this.gl.drawArraysInstanced(
          this.lines ? this.gl.LINES : (this.wireframe ? this.gl.LINE_STRIP :  meshType),
          0,                 // offset
          geometry.length,   // num vertices per instance
          numInstances,      // num instances
        );
      }

    }
    else {
      let indices = geometry.attributes['index'];
      if (  
        (meshType !== this.gl.POINTS) 
        && indices 
      ) {
        let indicesType = this.gl.UNSIGNED_SHORT;
        if (indices.data instanceof Uint32Array) {
          indicesType = this.gl.UNSIGNED_INT;
        } 
        // else if (indices instanceof Uint8Array) {
        //   indicesType = this.gl.UNSIGNED_BYTE;
        // }
        indices.bind();
        this.gl.drawElements( this.lines ? this.gl.LINES :  (this.wireframe ? this.gl.LINE_STRIP : meshType), indices.length, indicesType, 0);
      }
      else {
        this.gl.drawArrays( this.lines ? this.gl.LINES :  (this.wireframe ? this.gl.LINE_STRIP : meshType), 0, geometry.length);
      }

    }  

  }

  setUniform(name, value) {
    if (this.uniforms[name]) {
      this.uniforms[name].value = value;
    }
  }

  setDefine(name, value) {
    if (value == null) {
      delete this.defines[ name ];
    }
    else {
      this.defines[ name ] = value;
    }
  }


}

/*
 * compute filtering enum, return one of the following :
 *  NEAREST
 *  LINEAR
 *  NEAREST_MIPMAP_NEAREST
 *  LINEAR_MIPMAP_NEAREST
 *  NEAREST_MIPMAP_LINEAR
 *  LINEAR_MIPMAP_LINEAR
 */
function getFilter$1( smooth, mipmap, miplinear ){
  return 0x2600 | (+smooth) | (+mipmap<<8) | ( +( mipmap && miplinear )<<1 );
}

function isPowerOf2(value) {
  return (value & (value - 1)) == 0;
}

// var TEXTURE_CACHE = {};

class Texture {

  constructor(gl, options) {

    if (!gl) {
      return;
    }
    
    this.options = Object.assign({}, {
      format: gl.RGBA,
      type:   gl.UNSIGNED_BYTE,
      width: 1,
      height: 1,
      linear: true,
      mipmap: false,
      miplinear: false,
      wrapS: gl.CLAMP_TO_EDGE,
      wrapT: gl.CLAMP_TO_EDGE,
      anisotropy: 0,
      flipY: true,
      dataFlipY: false,
      repeat: [1,1],
      data: null,//new Uint8Array([0, 0, 0, 255]),
      isHeightmap: false,
      target: gl.TEXTURE_2D,
    }, options);

    this._uid        = generateUUID();//debug purpose
    this.uuid        = this._uid;
    this.gl          = gl;
    this.width       = this.options.width;
    this.height      = this.options.height;
    this.format      = this.options.format;
    this.type        = this.options.type;
    this.flipY       = this.options.flipY;
    this._data       = this.options.data;// || null
    this.repeat      = this.options.repeat;
    this._anisotropy = this.options.anisotropy;
    this.target      = this.options.target;


    if (this.type == gl.FLOAT) {
      gl.getExtension('EXT_color_buffer_float');
      gl.getExtension('OES_texture_float_linear');
      //   if (!floatTextures){//} || (window.innerWidth < 768)) {
      //       // console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
      //       this.type = "HALF_FLOAT"
      //   }
    }

    if (this.type == "HALF_FLOAT") {
      gl.getExtension('EXT_color_buffer_float');
      gl.getExtension('OES_texture_half_float_linear');
      //   if (!halfFloatTexturesExt) {
      //     console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
      //     this.type = gl.UNSIGNED_BYTE;
      //   }
      //   else {
      //     this.type = halfFloatTexturesExt.HALF_FLOAT_OES;
      //     this.isHalfFloat = true;
      //   }
    }

    this._texture = this.gl.createTexture();

    MemoryManager.trackTexture( this._texture );
    
    gl.bindTexture( this.target, this._texture );
    
    //1x1 pixel default texture
    // gl.texImage2D(this.target, 0, (this.options.type == this.gl.FLOAT ? this.gl.RGBA32F : this.gl.RGBA), this.width, this.height, 0, this.gl.RGBA, (this.options.type), this._data);
    if (this.type == this.gl.FLOAT && this._data) {
      this.gl.pixelStorei( this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
      this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
    }

    this.wrapS = this.options.wrapS;
    this.wrapT = this.options.wrapT;
    this.gl.bindTexture(this.target, this._texture);
    this.gl.texParameteri( this.target, this.gl.TEXTURE_WRAP_S, this.wrapS );
    this.gl.texParameteri( this.target, this.gl.TEXTURE_WRAP_T, this.wrapT );

    //nPOT texture cannot mipmap
    this.setFilter( this.options.linear, this.options.mipmap, this.options.mipmapLinear );

    //unbind texture
    gl.bindTexture( this.target, null);
    
    Object.defineProperty(this, 'anisotropy', {
      set: (value) => {
        this._anisotropy = value;
        this.updateAnisotropyFilter();
      },
      get: () => {
        return this._anisotropy 
      }
    });

  }

  updateAnisotropyFilter() {
    let gl = this.gl;
    if (!gl || this._anisotropy == 0) {
        return;
    }
    var ext = (
      gl.getExtension('EXT_texture_filter_anisotropic') ||
      gl.getExtension('MOZ_EXT_texture_filter_anisotropic') ||
      gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic')
    );
    if (ext) {
      if (this._anisotropy > 0) {
        gl.bindTexture( this.target, this._texture );
        var max = gl.getParameter(ext.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        gl.texParameterf(this.target, ext.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this._anisotropy, max) );
      }
    }
    console.log('ANISOTROPY');
  }

  bindData(data, width, height) {
    if (width) this.width = width;
    if (height) this.height = height; 
    this._data = data;
    if (this.type == this.gl.FLOAT && this._data) {
      this.gl.bindTexture( this.target, this._texture );
      // this.gl.pixelStorei( this.gl.UNPACK_FLIP_Y_WEBGL, this.dataFlipY);
      this.gl.texImage2D(this.target, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, this._data);
      this.gl.bindTexture( this.target, null);
    }
  }

  bindImage(img) {

    if (!this.gl) {
        return;
    }

    this.img = img;
    this.image = img;
    this.width  = img.width;
    this.height = img.height;

    var isPOT = isPowerOf2(img.width) && isPowerOf2(img.height);

    this.gl.bindTexture( this.target, this._texture);
    
    this.gl.pixelStorei( this.gl.UNPACK_FLIP_Y_WEBGL, this.flipY);

    if (this.options.type == this.gl.FLOAT) {
      this.gl.texImage2D(  this.target, 0, this.gl.RGBA32F, this.gl.RGBA, this.options.type, img);
    }
    else {
      this.gl.texImage2D(  this.target, 0, this.gl.RGBA, this.gl.RGBA,this.options.type, img);
    }
    
    
    if (isPOT) {
      //nPOT texture cannot mipmap
      this.setFilter( this.options.linear, this.options.mipmap, this.options.mipmapLinear );
      this.gl.generateMipmap(this.target);
    }
    else {
      this.setFilter(this.options.linear, false, false);
      this.wrapS = this.gl.CLAMP_TO_EDGE;
      this.wrapT = this.gl.CLAMP_TO_EDGE;
    }

    this.gl.bindTexture( this.target, null);
    
  }
  
  bind(unit) {
    if (!this.gl) {
      return;
    }
    //unit is sent by the Program and defined by the unfirom order in the shaders; 
    if (unit !== void 0) {
      this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
    }
    this.gl.bindTexture(this.target, this._texture);
  }

  delete() {
    if (this.gl) {
      this.gl.deleteTexture( this._texture );
      MemoryManager.untrackTexture( this._texture );
    }
    this._texture = null;
    this.gl = null;
  }

  /**
   * Change the filtering parameters
   *   @param {boolean} [smooth=false]    if true, use LINEAR filtering
   *   @param {boolean} [mipmap=false]    if true, enable mipmaping
   *   @param {boolean} [miplinear=false] if true, use linear Mipmapping
   */
  setFilter(smooth, mipmap, miplinear) {

    
    if (!this.gl) {
        return;
    }
    var gl = this.gl;
    var filter = getFilter$1( !!smooth, !!mipmap, !!miplinear);
    gl.bindTexture( this.target, this._texture );
    gl.texParameteri( this.target, gl.TEXTURE_MAG_FILTER, getFilter$1( !!smooth, false, false ) );
    gl.texParameteri( this.target, gl.TEXTURE_MIN_FILTER, filter );
    // this.updateAnisotropyFilter()
  }

  loadFromUrl(url, options={}) {
    if (options.useImageBitmap) {
(async()=>{
        try {
          // Fetch the image as a Blob
          const response = await fetch(url);
          if (!response.ok) throw new Error(`Failed to fetch: ${url}`);
          const blob = await response.blob();
          // Decode asynchronously into an ImageBitmap
          const bitmap = await createImageBitmap(blob, {
            premultiplyAlpha: 'default',
            colorSpaceConversion: 'default',
          });
          // Bind image to GPU texture
          this.isImageBitmap = true;
          this.bindImage(bitmap);
          this.loaded = true;
          this.error = false;
          if (options.onLoaded) options.onLoaded(url);
        } 
        catch (err) {
          this.loaded = false;
          this.error  = true;
          if (options.onError) options.onError(err);
          // if (options.onLoaded) options.onLoaded(url);
          console.warn(`this.fromUrl(${url}) failed`, err);
        }
      })();
    }
    else {
      var img = new Image();
      img.crossOrigin = "";
      img.onload = ()=>{
        img.onload = null;
        img.onerror = null;
        this.loaded = true;
        this.error  = false;
        this.bindImage(img);
        if (options && options.onLoaded) {
          options.onLoaded(url);
        }
      }; 
      img.onerror = ()=>{
        img.onload = null;
        img.onerror = null;
        this.loaded = false;
        this.error = true;
        if (options && options.onError) {
          options.onError(url);
        }
        // if (options && options.onLoaded) {
        //   options.onLoaded(url);
        // }
        console.warn('Invalid url provided to Texture.fromUrl() : ' + url);
      };
      img.src        = url;
    }
  }

}


Texture.fromUrl = function(gl, url, options={}) {
  const texture = new Texture(gl, options);
  texture.loaded = false;
  texture.loadFromUrl(url, options);
  return texture;
};


Texture.fromImage = function(gl, img, options) {
  if (!img.width || !img.height) {
    console.warn('Cannot create texture with provided image\n Please make sure the image is loaded before calling Texture.fromImage() or use Texture.fromUrl() instead', img);
    return;
  }
  var texture = new Texture(gl, options);
  texture.bindImage(img);
  texture.loaded = true;
  texture.error = false;
  return texture;
};

var fragmentShader = "precision highp float;\n\n\nuniform vec3 uColor;\nuniform float uAlpha;\n\nvarying vec3 vColor;\nvarying vec2 vUv;\n\nuniform sampler2D tMap;\nuniform float useMap;\nuniform int uDepthPass;\n\nvoid main(void) {\n\nif(uDepthPass == 1) {\ngl_FragColor = vec4( gl_FragCoord.z, 0., 0., 1. );\n}\nelse {\nvec4 color = vec4(uColor, uAlpha);\nif (useMap==1.) {\ncolor.rgb = texture2D(tMap, vUv).rgb;\n}\ngl_FragColor = color;\n}\n}"; // eslint-disable-line

let defaultTexture;

class Material extends Program {

  constructor( gl, options  ){

    defaultTexture = defaultTexture || new Texture(gl);

    options = Object.assign({}, {
      vertexShader:   vertexShader,
      fragmentShader: fragmentShader,
      map: null,
    }, options);

    options.uniforms = Object.assign({}, {
      uColor: [0,1,0],
      uAlpha: 1,
      useMap: 0,
      tMap: defaultTexture,
    }, options.uniforms);

    options.defines = Object.assign({}, {
      USE_MAP: false
    }, options.defines);

    super(gl, options);
  
    if (!gl) {
      return;
    }


    Object.defineProperty(this, 'map', {
      set: (value) => {
        if (value) {
          if (this.uniforms.tMap) {
            this.uniforms.tMap.value = value;
            this.uniforms.useMap.value = 1;
          }
        }
        else {
          if (this.uniforms.useMap) {
            this.uniforms.useMap.value = 0;
          }
        }
      }
    });
      
    this.map = options.map;

  }



}

class CubeTexture {

  constructor(gl, options) {

    options = Object.assign({}, {
        format: gl.RGBA,
        type:   gl.UNSIGNED_BYTE,
        width: 1,
        height: 1,
        linear: true,
        mipmap: false,
        miplinear: false,
        wrapS: gl.CLAMP_TO_EDGE,
        wrapT: gl.CLAMP_TO_EDGE,
        urls: null
      }, options);

    this._uid   = generateUUID();//debug purpose
    this.gl     = gl;
    this.width  = options.width;
    this.height = options.height;
    this.format = options.format;
    this.type   = options.type;

    var floatTextures = gl.getExtension('OES_texture_float');
    gl.getExtension('OES_texture_float_linear');

    if (!floatTextures) {
        throw('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support');
    }

    this._texture = this.gl.createTexture();
    MemoryManager.trackTexture( this._texture );

    gl.bindTexture( gl.TEXTURE_CUBE_MAP, this._texture);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.texImage2D(gl.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, this.format, this.width, this.height, 0, this.format, this.type, new Uint8Array(new Array(this.width*this.height*4)));
    gl.bindTexture( gl.TEXTURE_CUBE_MAP, null);

    // /**
    //  * add getter and setter to update texture_wrap when this.wrap changes
    //  */
    // Object.defineProperty(this, 'wrapS', {
    //   set: (value) => {
    //     this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture);
    //     this.gl.texParameteri( this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_S, value );
    //   }
    // });
    // Object.defineProperty(this, 'wrapT', {
    //   set: (value) => {
    //     this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture);
    //     this.gl.texParameteri( this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_T, value );
    //   }
    // });
    // //nPOT texture can't repeat
    // this.wrapS = options.wrapS;
    // this.wrapT = options.wrapT;
    
    //nPOT texture cannot mipmap
    // this.setFilter( options.linear, options.mipmap, options.mipmapLinear );

    if (options.urls !== null) {  
      this.load(options.urls);
    }

  }

  load(urls) {
    var faces = [
      this.gl.TEXTURE_CUBE_MAP_POSITIVE_X,
      this.gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
      this.gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
      this.gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
      this.gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
      this.gl.TEXTURE_CUBE_MAP_NEGATIVE_Z
    ];
    for (let i = 0; i < urls.length; i++) {
        let face = faces[i];
        let image = new Image();
        image.onload = ()=> {
          image.onload = null;
          // this.bindFaceImage(face, image);
          this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
          this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
          this.gl.texImage2D(face, 0, this.gl.RGBA, this.gl.RGBA, this.gl.UNSIGNED_BYTE, image);
          this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
          this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR);
          this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
          this.gl.texParameteri(this.gl.TEXTURE_CUBE_MAP, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        };
        image.src = urls[i];
    }
  }

  bindFaceImage(face, image) {
    this.gl.bindTexture(this.gl.TEXTURE_CUBE_MAP, this._texture);
    this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
    if (image._texture) {
      this.gl.texImage2D(face, 0, this.format, image.width, image.height, 0, this.format, this.type, image._texture);
    }
    else {
      this.gl.texImage2D(face, 0, this.format, image.width, image.height, 0, this.format, this.type, image);
    }
  }
  
  bindFaceFrameBuffer(face, frameBuffer) {
    this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture);
    this.gl.bindFramebuffer( this.gl.FRAMEBUFFER, frameBuffer.fbo );
    this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, face, this._texture, 0);
    let status_code = this.gl.checkFramebufferStatus(this.gl.FRAMEBUFFER);
    if (status_code != this.gl.FRAMEBUFFER_COMPLETE) {
      if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT) {
        console.warn('GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT');
      }
      if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS) {
        console.warn('FRAMEBUFFER_INCOMPLETE_DIMENSIONS: Not all attached images have the same width and height.');
      }
      if (status_code == this.gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT) {
        console.warn('FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: No images are attached to the framebuffer.');
      }
    }
    // this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, null );
    this.gl.bindFramebuffer( this.gl.FRAMEBUFFER, null );
    frameBuffer.unbind();
  }

  bind(unit) {
    if( unit !== undefined ){
      this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
    }
    this.gl.bindTexture( this.gl.TEXTURE_CUBE_MAP, this._texture );
  }

  delete() {
    this.gl.deleteTexture( this._texture );
    MemoryManager.untrackTexture( this._texture );
    this._texture = null;
    this.gl = null;
  }

}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 4 Dimensional Vector
 * @module vec4
 */

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */
function create$4() {
  let out = new ARRAY_TYPE(4);
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  return out;
}

/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {vec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */
function clone$4(a) {
  let out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */
function fromValues$4(x, y, z, w) {
  let out = new ARRAY_TYPE(4);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}

/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the source vector
 * @returns {vec4} out
 */
function copy$4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */
function set$4(out, x, y, z, w) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = w;
  return out;
}

/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function add$4(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}

/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function subtract$3(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}

/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function multiply$4(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  out[3] = a[3] * b[3];
  return out;
}

/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function divide$1(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  out[3] = a[3] / b[3];
  return out;
}

/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to ceil
 * @returns {vec4} out
 */
function ceil$1(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  out[3] = Math.ceil(a[3]);
  return out;
}

/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to floor
 * @returns {vec4} out
 */
function floor$1(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  out[3] = Math.floor(a[3]);
  return out;
}

/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function min$1(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  out[3] = Math.min(a[3], b[3]);
  return out;
}

/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
function max$1(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  out[3] = Math.max(a[3], b[3]);
  return out;
}

/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to round
 * @returns {vec4} out
 */
function round$1(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  out[3] = Math.round(a[3]);
  return out;
}

/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */
function scale$4(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}

/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */
function scaleAndAdd$1(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  out[3] = a[3] + (b[3] * scale);
  return out;
}

/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} distance between a and b
 */
function distance$1(a, b) {
  let x = b[0] - a[0];
  let y = b[1] - a[1];
  let z = b[2] - a[2];
  let w = b[3] - a[3];
  return Math.sqrt(x*x + y*y + z*z + w*w);
}

/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance$1(a, b) {
  let x = b[0] - a[0];
  let y = b[1] - a[1];
  let z = b[2] - a[2];
  let w = b[3] - a[3];
  return x*x + y*y + z*z + w*w;
}

/**
 * Calculates the length of a vec4
 *
 * @param {vec4} a vector to calculate length of
 * @returns {Number} length of a
 */
function length$2(a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  let w = a[3];
  return Math.sqrt(x*x + y*y + z*z + w*w);
}

/**
 * Calculates the squared length of a vec4
 *
 * @param {vec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength$2(a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  let w = a[3];
  return x*x + y*y + z*z + w*w;
}

/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to negate
 * @returns {vec4} out
 */
function negate$1(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = -a[3];
  return out;
}

/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to invert
 * @returns {vec4} out
 */
function inverse$1(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  out[3] = 1.0 / a[3];
  return out;
}

/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to normalize
 * @returns {vec4} out
 */
function normalize$2(out, a) {
  let x = a[0];
  let y = a[1];
  let z = a[2];
  let w = a[3];
  let len = x*x + y*y + z*z + w*w;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
  }
  return out;
}

/**
 * Calculates the dot product of two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot$2(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}

/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec4} out
 */
function lerp$2(out, a, b, t) {
  let ax = a[0];
  let ay = a[1];
  let az = a[2];
  let aw = a[3];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  out[3] = aw + t * (b[3] - aw);
  return out;
}

/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */
function random$1(out, vectorScale) {
  vectorScale = vectorScale || 1.0;

  //TODO: This is a pretty awful way of doing this. Find something better.
  out[0] = RANDOM();
  out[1] = RANDOM();
  out[2] = RANDOM();
  out[3] = RANDOM();
  normalize$2(out, out);
  scale$4(out, out, vectorScale);
  return out;
}

/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */
function transformMat4$1(out, a, m) {
  let x = a[0], y = a[1], z = a[2], w = a[3];
  out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
  out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
  out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
  out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
  return out;
}

/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec4} out
 */
function transformQuat(out, a, q) {
  let x = a[0], y = a[1], z = a[2];
  let qx = q[0], qy = q[1], qz = q[2], qw = q[3];

  // calculate quat * vec
  let ix = qw * x + qy * z - qz * y;
  let iy = qw * y + qz * x - qx * z;
  let iz = qw * z + qx * y - qy * x;
  let iw = -qx * x - qy * y - qz * z;

  // calculate result * inverse quat
  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  out[3] = a[3];
  return out;
}

/**
 * Returns a string representation of a vector
 *
 * @param {vec4} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$4(a) {
  return 'vec4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}

/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$4(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$4(a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
          Math.abs(a3 - b3) <= EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
}

/**
 * Alias for {@link vec4.subtract}
 * @function
 */
const sub$3 = subtract$3;

/**
 * Alias for {@link vec4.multiply}
 * @function
 */
const mul$4 = multiply$4;

/**
 * Alias for {@link vec4.divide}
 * @function
 */
const div$1 = divide$1;

/**
 * Alias for {@link vec4.distance}
 * @function
 */
const dist$1 = distance$1;

/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */
const sqrDist$1 = squaredDistance$1;

/**
 * Alias for {@link vec4.length}
 * @function
 */
const len$2 = length$2;

/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */
const sqrLen$2 = squaredLength$2;

/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach$1 = (function() {
  let vec = create$4();

  return function(a, stride, offset, count, fn, arg) {
    let i, l;
    if(!stride) {
      stride = 4;
    }

    if(!offset) {
      offset = 0;
    }

    if(count) {
      l = Math.min((count * stride) + offset, a.length);
    } else {
      l = a.length;
    }

    for(i = offset; i < l; i += stride) {
      vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2]; vec[3] = a[i+3];
      fn(vec, vec, arg);
      a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2]; a[i+3] = vec[3];
    }

    return a;
  };
})();

var vec4 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$4,
   clone: clone$4,
   fromValues: fromValues$4,
   copy: copy$4,
   set: set$4,
   add: add$4,
   subtract: subtract$3,
   multiply: multiply$4,
   divide: divide$1,
   ceil: ceil$1,
   floor: floor$1,
   min: min$1,
   max: max$1,
   round: round$1,
   scale: scale$4,
   scaleAndAdd: scaleAndAdd$1,
   distance: distance$1,
   squaredDistance: squaredDistance$1,
   length: length$2,
   squaredLength: squaredLength$2,
   negate: negate$1,
   inverse: inverse$1,
   normalize: normalize$2,
   dot: dot$2,
   lerp: lerp$2,
   random: random$1,
   transformMat4: transformMat4$1,
   transformQuat: transformQuat,
   str: str$4,
   exactEquals: exactEquals$4,
   equals: equals$4,
   sub: sub$3,
   mul: mul$4,
   div: div$1,
   dist: dist$1,
   sqrDist: sqrDist$1,
   len: len$2,
   sqrLen: sqrLen$2,
   forEach: forEach$1
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * Quaternion
 * @module quat
 */

/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */
function create$3() {
  let out = new ARRAY_TYPE(4);
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}

/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */
function identity$2(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}

/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {vec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/
function setAxisAngle(out, axis, rad) {
  rad = rad * 0.5;
  let s = Math.sin(rad);
  out[0] = s * axis[0];
  out[1] = s * axis[1];
  out[2] = s * axis[2];
  out[3] = Math.cos(rad);
  return out;
}

/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {quat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */
function getAxisAngle(out_axis, q) {
  let rad = Math.acos(q[3]) * 2.0;
  let s = Math.sin(rad / 2.0);
  if (s != 0.0) {
    out_axis[0] = q[0] / s;
    out_axis[1] = q[1] / s;
    out_axis[2] = q[2] / s;
  } else {
    // If s is zero, return any axis (no rotation - axis does not matter)
    out_axis[0] = 1;
    out_axis[1] = 0;
    out_axis[2] = 0;
  }
  return rad;
}

/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 */
function multiply$3(out, a, b) {
  let ax = a[0], ay = a[1], az = a[2], aw = a[3];
  let bx = b[0], by = b[1], bz = b[2], bw = b[3];

  out[0] = ax * bw + aw * bx + ay * bz - az * by;
  out[1] = ay * bw + aw * by + az * bx - ax * bz;
  out[2] = az * bw + aw * bz + ax * by - ay * bx;
  out[3] = aw * bw - ax * bx - ay * by - az * bz;
  return out;
}

/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateX(out, a, rad) {
  rad *= 0.5;

  let ax = a[0], ay = a[1], az = a[2], aw = a[3];
  let bx = Math.sin(rad), bw = Math.cos(rad);

  out[0] = ax * bw + aw * bx;
  out[1] = ay * bw + az * bx;
  out[2] = az * bw - ay * bx;
  out[3] = aw * bw - ax * bx;
  return out;
}

/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateY(out, a, rad) {
  rad *= 0.5;

  let ax = a[0], ay = a[1], az = a[2], aw = a[3];
  let by = Math.sin(rad), bw = Math.cos(rad);

  out[0] = ax * bw - az * by;
  out[1] = ay * bw + aw * by;
  out[2] = az * bw + ax * by;
  out[3] = aw * bw - ay * by;
  return out;
}

/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
function rotateZ(out, a, rad) {
  rad *= 0.5;

  let ax = a[0], ay = a[1], az = a[2], aw = a[3];
  let bz = Math.sin(rad), bw = Math.cos(rad);

  out[0] = ax * bw + ay * bz;
  out[1] = ay * bw - ax * bz;
  out[2] = az * bw + aw * bz;
  out[3] = aw * bw - az * bz;
  return out;
}

/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate W component of
 * @returns {quat} out
 */
function calculateW(out, a) {
  let x = a[0], y = a[1], z = a[2];

  out[0] = x;
  out[1] = y;
  out[2] = z;
  out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
  return out;
}

/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 */
function slerp(out, a, b, t) {
  // benchmarks:
  //    http://jsperf.com/quaternion-slerp-implementations
  let ax = a[0], ay = a[1], az = a[2], aw = a[3];
  let bx = b[0], by = b[1], bz = b[2], bw = b[3];

  let omega, cosom, sinom, scale0, scale1;

  // calc cosine
  cosom = ax * bx + ay * by + az * bz + aw * bw;
  // adjust signs (if necessary)
  if ( cosom < 0.0 ) {
    cosom = -cosom;
    bx = - bx;
    by = - by;
    bz = - bz;
    bw = - bw;
  }
  // calculate coefficients
  if ( (1.0 - cosom) > 0.000001 ) {
    // standard case (slerp)
    omega  = Math.acos(cosom);
    sinom  = Math.sin(omega);
    scale0 = Math.sin((1.0 - t) * omega) / sinom;
    scale1 = Math.sin(t * omega) / sinom;
  } else {
    // "from" and "to" quaternions are very close
    //  ... so we can do a linear interpolation
    scale0 = 1.0 - t;
    scale1 = t;
  }
  // calculate final values
  out[0] = scale0 * ax + scale1 * bx;
  out[1] = scale0 * ay + scale1 * by;
  out[2] = scale0 * az + scale1 * bz;
  out[3] = scale0 * aw + scale1 * bw;

  return out;
}

/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate inverse of
 * @returns {quat} out
 */
function invert$2(out, a) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let dot = a0*a0 + a1*a1 + a2*a2 + a3*a3;
  let invDot = dot ? 1.0/dot : 0;

  // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0

  out[0] = -a0*invDot;
  out[1] = -a1*invDot;
  out[2] = -a2*invDot;
  out[3] = a3*invDot;
  return out;
}

/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate conjugate of
 * @returns {quat} out
 */
function conjugate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] = a[3];
  return out;
}

/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {mat3} m rotation matrix
 * @returns {quat} out
 * @function
 */
function fromMat3(out, m) {
  // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
  // article "Quaternion Calculus and Fast Animation".
  let fTrace = m[0] + m[4] + m[8];
  let fRoot;

  if ( fTrace > 0.0 ) {
    // |w| > 1/2, may as well choose w > 1/2
    fRoot = Math.sqrt(fTrace + 1.0);  // 2w
    out[3] = 0.5 * fRoot;
    fRoot = 0.5/fRoot;  // 1/(4w)
    out[0] = (m[5]-m[7])*fRoot;
    out[1] = (m[6]-m[2])*fRoot;
    out[2] = (m[1]-m[3])*fRoot;
  } else {
    // |w| <= 1/2
    let i = 0;
    if ( m[4] > m[0] )
      i = 1;
    if ( m[8] > m[i*3+i] )
      i = 2;
    let j = (i+1)%3;
    let k = (i+2)%3;

    fRoot = Math.sqrt(m[i*3+i]-m[j*3+j]-m[k*3+k] + 1.0);
    out[i] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m[j*3+k] - m[k*3+j]) * fRoot;
    out[j] = (m[j*3+i] + m[i*3+j]) * fRoot;
    out[k] = (m[k*3+i] + m[i*3+k]) * fRoot;
  }

  return out;
}

/**
 * Creates a quaternion from the given euler angle x, y, z.
 *
 * @param {quat} out the receiving quaternion
 * @param {x} Angle to rotate around X axis in degrees.
 * @param {y} Angle to rotate around Y axis in degrees.
 * @param {z} Angle to rotate around Z axis in degrees.
 * @returns {quat} out
 * @function
 */
function fromEuler(out, x, y, z) {
    let halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;

    let sx = Math.sin(x);
    let cx = Math.cos(x);
    let sy = Math.sin(y);
    let cy = Math.cos(y);
    let sz = Math.sin(z);
    let cz = Math.cos(z);

    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;

    return out;
}

/**
 * Returns a string representation of a quatenion
 *
 * @param {quat} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$3(a) {
  return 'quat(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}

/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {quat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */
const clone$3 = clone$4;

/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */
const fromValues$3 = fromValues$4;

/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the source quaternion
 * @returns {quat} out
 * @function
 */
const copy$3 = copy$4;

/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */
const set$3 = set$4;

/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 * @function
 */
const add$3 = add$4;

/**
 * Alias for {@link quat.multiply}
 * @function
 */
const mul$3 = multiply$3;

/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {quat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */
const scale$3 = scale$4;

/**
 * Calculates the dot product of two quat's
 *
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */
const dot$1 = dot$2;

/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 * @function
 */
const lerp$1 = lerp$2;

/**
 * Calculates the length of a quat
 *
 * @param {quat} a vector to calculate length of
 * @returns {Number} length of a
 */
const length$1 = length$2;

/**
 * Alias for {@link quat.length}
 * @function
 */
const len$1 = length$1;

/**
 * Calculates the squared length of a quat
 *
 * @param {quat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */
const squaredLength$1 = squaredLength$2;

/**
 * Alias for {@link quat.squaredLength}
 * @function
 */
const sqrLen$1 = squaredLength$1;

/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */
const normalize$1 = normalize$2;

/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {quat} a The first quaternion.
 * @param {quat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
const exactEquals$3 = exactEquals$4;

/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {quat} a The first vector.
 * @param {quat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
const equals$3 = equals$4;

/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {vec3} a the initial vector
 * @param {vec3} b the destination vector
 * @returns {quat} out
 */
const rotationTo = (function() {
  let tmpvec3 = create$5();
  let xUnitVec3 = fromValues$5(1,0,0);
  let yUnitVec3 = fromValues$5(0,1,0);

  return function(out, a, b) {
    let dot = dot$3(a, b);
    if (dot < -0.999999) {
      cross$1(tmpvec3, xUnitVec3, a);
      if (len$3(tmpvec3) < 0.000001)
        cross$1(tmpvec3, yUnitVec3, a);
      normalize$3(tmpvec3, tmpvec3);
      setAxisAngle(out, tmpvec3, Math.PI);
      return out;
    } else if (dot > 0.999999) {
      out[0] = 0;
      out[1] = 0;
      out[2] = 0;
      out[3] = 1;
      return out;
    } else {
      cross$1(tmpvec3, a, b);
      out[0] = tmpvec3[0];
      out[1] = tmpvec3[1];
      out[2] = tmpvec3[2];
      out[3] = 1 + dot;
      return normalize$1(out, out);
    }
  };
})();

/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {quat} c the third operand
 * @param {quat} d the fourth operand
 * @param {Number} t interpolation amount
 * @returns {quat} out
 */
const sqlerp = (function () {
  let temp1 = create$3();
  let temp2 = create$3();

  return function (out, a, b, c, d, t) {
    slerp(temp1, a, d, t);
    slerp(temp2, b, c, t);
    slerp(out, temp1, temp2, 2 * t * (1 - t));

    return out;
  };
}());

/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {vec3} view  the vector representing the viewing direction
 * @param {vec3} right the vector representing the local "right" direction
 * @param {vec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */
const setAxes = (function() {
  let matr = create$6();

  return function(out, view, right, up) {
    matr[0] = right[0];
    matr[3] = right[1];
    matr[6] = right[2];

    matr[1] = up[0];
    matr[4] = up[1];
    matr[7] = up[2];

    matr[2] = -view[0];
    matr[5] = -view[1];
    matr[8] = -view[2];

    return normalize$1(out, fromMat3(out, matr));
  };
})();

var quat = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$3,
   identity: identity$2,
   setAxisAngle: setAxisAngle,
   getAxisAngle: getAxisAngle,
   multiply: multiply$3,
   rotateX: rotateX,
   rotateY: rotateY,
   rotateZ: rotateZ,
   calculateW: calculateW,
   slerp: slerp,
   invert: invert$2,
   conjugate: conjugate,
   fromMat3: fromMat3,
   fromEuler: fromEuler,
   str: str$3,
   clone: clone$3,
   fromValues: fromValues$3,
   copy: copy$3,
   set: set$3,
   add: add$3,
   mul: mul$3,
   scale: scale$3,
   dot: dot$1,
   lerp: lerp$1,
   length: length$1,
   len: len$1,
   squaredLength: squaredLength$1,
   sqrLen: sqrLen$1,
   normalize: normalize$1,
   exactEquals: exactEquals$3,
   equals: equals$3,
   rotationTo: rotationTo,
   sqlerp: sqlerp,
   setAxes: setAxes
});

function watch(target, cb) {
  return new Proxy(target, {
    set(obj, prop, value) {
      obj[prop] = value;
      cb();
      return true;
    }
  });
}

class Object3d {

	get position() { return this._position; }
	set position(v) {
		this._position = watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}

	get rotation() { return this._rotation; }
	set rotation(v) {
		this._rotation = watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}

	get scale() { return this._scale; }
	set scale(v) {
		this._scale = watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}

	get lookAt() { return this._lookAt; }
	set lookAt(v) {
		this._lookAt = !v ? v : watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}

	get up() { return this._up; }
	set up(v) {
		this._up = watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}

	get quaternion() { return this._quaternion; }
	set quaternion(v) {
		this._quaternion =  !v ? v : watch(v, () => this.needsUpdate = true);
		this.needsUpdate = true;
	}
	
	constructor() {
		
		this.uuid = generateUUID();
		
		this._position     =  watch( fromValues$5(0,0,0), () => this.needsUpdate = true);
		this._rotation     =  watch( fromValues$5(0,0,0), () => this.needsUpdate = true);
		this._scale        =  watch( fromValues$5(1,1,1), () => this.needsUpdate = true);
		this._up           =  watch( fromValues$5(0,1,0), () => this.needsUpdate = true);
		this._lookAt       = null;
		this._quaternion   = null;

		this._normalMatrix = create$7();
		//use to diff and only update matrix if needed
		this.lastPosition       = create$5();
		this.lastRotation       = create$5();
		this.lastScale          = create$5();
		this.lastLookAt         = create$5();

		this.matrix       = create$7();//modelMatrix
		this.worldMatrix  = create$7();//modelMatrix * parentMatri(x|ces)

		// this._quaternion   = quat.create();

		this.inverseWorldMatrix =  create$7();

		this._invLookatMat4 = create$7();
		// this._m3Rotation = mat3.create();
		this._rotationMat4 = create$7();
		this._lookAtMat4 = create$7();
		this._lastUpdate = Date.now();
		this.needsUpdate = true;
	}

	render(force) {
		if (force || this.needsUpdate) {
			this.updateMatrix();
			this.updateWorldMatrix();
			this.needsUpdate = false;
		}
	}

	updateMatrix() {
		
		identity$4(this.matrix);
		identity$4(this._invLookatMat4);
		identity$4(this._rotationMat4);
		identity$4(this._lookAtMat4);

		if (this.quaternion) {
			fromRotationTranslation(this.matrix, this.quaternion, this._position );
		}
		else {
			translate$2(this.matrix, this.matrix, this._position);
			rotateX$2(this._rotationMat4, this._rotationMat4, this._rotation[0]);
			rotateY$2(this._rotationMat4, this._rotationMat4, this._rotation[1]);
			rotateZ$2(this._rotationMat4, this._rotationMat4, this._rotation[2]);
		}

		if (this.lookAt !== null) {
			lookAt(
				this.matrix, 
				this._position, 
				this.lookAt,
				this.up
			);
			// var _rotMat4 = mat4.create();
			// mat4.multiply(_rotMat4, _rotMat4, this._lookAtMat4);
			// mat4.getRotation( this._quaternion, _rotMat4);
			lookAt(
				this._invLookatMat4, 
				this._position, 
				this.lookAt,
				this.up
			);
			copy$7(this._rotationMat4, this._invLookatMat4);
			invert$4(this.matrix, this.matrix);
			scale$7(this.matrix, this.matrix, this._scale);	
		}
		else {
			
			// //position
			// if (!this.quaternion) {
			// 	mat4.translate(this.matrix, this.matrix, this._position);
			// }
				
			//rotate
			multiply$7(this.matrix, this.matrix, this._rotationMat4);
			//scale
			scale$7(this.matrix, this.matrix, this._scale);	
		
			//anchor
			// if (this.anchor) {
			// 	let revertAnchor = [
			// 		this.anchor[0]*-1,
			// 		this.anchor[1]*-1,
			// 		0
			// 	]
			// 	mat4.translate(this.matrix, this.matrix, revertAnchor);
			// }

		}
	}

	updateWorldMatrix() {


		identity$4(this.worldMatrix);

		if (this.parent) {

			// mat4.multiply(this.worldMatrix, this.matrix, this.parent.worldMatrix);
			multiply$7(this.worldMatrix, this.parent.worldMatrix, this.matrix );
		}
		else {
			copy$7(this.worldMatrix, this.matrix );
		}

		invert$4(this.inverseWorldMatrix, this.worldMatrix);
		identity$4( this._normalMatrix, this._normalMatrix);
		multiply$7( this._normalMatrix, this._normalMatrix, this._rotationMat4);
		let n = this;
		while( n.parent) {
			multiply$7( this._normalMatrix, this._normalMatrix, n.parent._rotationMat4);
			n = n.parent;
		}

		if (this.children) {
			this.children?.forEach((child)=>{
				child.updateMatrix();
				child.updateWorldMatrix();
			});
		}

	}

}

function nestedEach(obj, callback) {
    if (!obj) {
        return
    }
    callback( obj );
    obj.children && obj.children.forEach((child)=>{
        nestedEach( child, callback );
    });
}



class Container extends Object3d {

	constructor() {
		super();
		this.visible      = true;
		this.parent       = null;
		this.children     = [];
	}

	traverse(cb) {
        nestedEach(this, cb);
    }

	add(child) {
		let hasChild = false;
		for (let i=0,l=this.children.length;i<l; i++) {
			if (this.children[i] == child) {
				hasChild = true;
				break;
			}
		}
		if (!hasChild) {
			this.children.push(child);
		}
		child.parent = this;
	}

	remove(child) {
		for (let i=0,l=this.children.length;i<l; i++) {
			if (this.children[i] == child) {
				child.parent = null;
				this.children.splice(i, 1);	
				break;
			}
		}
	}
	
	destroy() {
		for (let i=0,l=this.children.length;i<l; i++) {
			this.children[i].destroy();
		}
		if (this.parent !== null) {
			this.parent.removeChild( this );
		}
	}

	render(camera, options) {
		// if (this.visible) {
			super.render();		
			for (let i=0,l=this.children.length;i<l; i++) {
				if (this.children[i].visible) {
					this.children[i].render(camera, options);
				}
			}
		// }
	}

}

// import settings from 'settings';
// import stats, {drawCalls} from 'stats';


// function reset() {
// 	window.maxDrawnGeometry = null;
// 	window.maxDrawnGeometryLength = 0;
// 	requestAnimationFrame(reset);
// }
// reset();



let _scale = create$5();

class Mesh extends Container {

	constructor(options) {
		super();


		this.material  = null;
		this.geometry = null;
		this.options = options || {};

		this.debug = options?.debug;
	
		this._viewMatrix        = create$7();
		this._invViewMatrix     = create$7();
		this._modelViewMatrix   = create$7();
		this._projectViewMatrix = create$7();
		this._projectionMatrix = create$7();


		this.uniforms = {};
		this.bSphere = {center:create$5(),radius:0};
	}

	updateWorldMatrix() {
		super.updateWorldMatrix();
		if (this.geometry) {
			this.geometry._bSphere = this.geometry._bSphere || this.geometry.getBoundingSphere();
			if (!this.geometry._bSphere) {
				return;
			}
			copy$5( this.bSphere.center, this.geometry._bSphere.center);
			transformMat4$2( this.bSphere.center, this.bSphere.center, this.worldMatrix);
			getScaling(_scale, this.worldMatrix);
			this.bSphere.radius = this.geometry._bSphere.radius *  Math.max(_scale[0], Math.max(_scale[1], _scale[2]));
		}
	}

	render(camera, options={}) {


		let material = this.material;
		let isOverriden = false;

		if (options.overrideMaterial) {
			material = options.overrideMaterial;
			isOverriden = true;
		}
		// replace the mesh mùaterial with the overide one
		// Because of defines, we use a different material for Instancing becausde when a material is passed as overdrive, we update it's defines based on the original material defines
		// TODO: this is clearly a hack, we need to find a cleaner approach, maybe in the way defined are handled at material level
		if (options.overrideMaterial && this.material && this.material.defines.USE_INSTANCING && options.overrideInstancedMaterial) {
			material = options.overrideInstancedMaterial;
			isOverriden = true;
		}
		
		if (options.overrideMaterial && this.material && this.material.defines.USE_INSTANCE_MATRIX_TEXTURE && options.overrideInstancedTextureMatrixMaterial) {
			material = options.overrideInstancedTextureMatrixMaterial;
			isOverriden = true;
		}

		if (options.overrideMaterial && this.material && this.material.defines.USE_TERRAIN && options.overrideTerrainMaterial) {
			material = options.overrideTerrainMaterial;
			isOverriden = true;
		}

		if (options.overrideMaterial && this.material && this.material.defines.USE_TERRAIN && options.overrideInstancedTerrainMaterial && this.material.defines.USE_INSTANCING ) {
			material = options.overrideInstancedTerrainMaterial;
			isOverriden = true;
		}

		if (options.overrideMaterial && this.material && this.material.defines.USE_CLUSTER && options.overrideClustersMaterial) {
			material = options.overrideClustersMaterial;
			isOverriden = true;
		}

		// if (options.overrideMaterial && this.material && this.material.defines.USE_IMPOSTOR ){//&& options.overrideImpostorMaterial) {
		// 	material = this.material;
		// }
		// if (options.overrideMaterial && this.material && this.material.defines.USE_AUTO_PLACEMENT  ){//&& options.overrideImpostorAutoPlacementMaterial) {
		// 	material = this.material;
		// }
		// if (options.overrideMaterial && this.material && this.material.defines.USE_FULL_FOLIAGE ){// && options.overrideFullFoliageMaterial) {
		// 	material = this.material;
		// }

		// FOLIAGE NEAR MESH STATIC POSITONNED
		if (options.overrideMaterial && this.material && this.material.defines.USE_FOLIAGE_NEAR && !this.material.defines.USE_AUTO_PLACEMENT && options.overrideFoliageNearMaterial) {
			material =  options.overrideFoliageNearMaterial;
			isOverriden = true;
		}
		// FOLIAGE NEAR MESH AUTO PLACEMENT
		if (options.overrideMaterial && this.material && this.material.defines.USE_FOLIAGE_NEAR && this.material.defines.USE_AUTO_PLACEMENT && options.overrideFoliageNearAutoMaterial) {
			material =  options.overrideFoliageNearAutoMaterial;
			isOverriden = true;
		}
		// FOLIAGE IMPOSTOR MESH STATIC POSITONNED
		if (options.overrideMaterial && this.material && this.material.defines.USE_FOLIAGE_IMPOSTOR && !this.material.defines.USE_AUTO_PLACEMENT && options.overrideFoliageImpostorMaterial) {
			material =  options.overrideFoliageImpostorMaterial;
			isOverriden = true;
		}
		// FOLIAGE IMPOSTOR MESH AUTO PLACEMENT
		if (options.overrideMaterial && this.material && this.material.defines.USE_FOLIAGE_IMPOSTOR && this.material.defines.USE_AUTO_PLACEMENT && options.overrideFoliageImpostorAutoMaterial) {
			material =  options.overrideFoliageImpostorAutoMaterial;
			isOverriden = true;
		}
		// LADNSCAPE GRASS MESHES
		if (options.overrideMaterial && this.material && this.material.defines.USE_INSTANCE_MATRIX_TEXTURE && options.overrideLandscapeGrassMesh) {
			material = options.overrideLandscapeGrassMesh;
			isOverriden = true;
		}

		if (!material?.setUniform) {
			console.log('ERROR WITH MATERIAL', material);
			return;
		}
		
		if (
			camera && 
			material && 
			this.geometry 
			/* TODO: check for geometry.length */ 
		) {
			
			if (!this.visible) {
				return
			}

			super.render( camera, options );

			// let isInstancing = false;
			// let numInstances = 1;
			// for (let k in this.geometry.attributes) {
			// 	if (/^instance/.test(k) && k !== 'instanceIndex') {
			// 		isInstancing = true;
			// 		numInstances = Math.max(1, this.geometry.attributes[k].length / this.geometry.attributes[k].size);
			// 	}
			// }

			// if (!isInstancing && !this.keep  && camera.frustum && (this.boudingBox || this.bSphere) /*&& settings.useFrustumCulling*/    ) {
			// 	if ( !camera.frustum.intersectsSphere(this.bSphere) ){
			// 		// console.log('CULL MESH', this.name || this.id);
			// 		return;
			// 	}
			// }

			copy$7(this._viewMatrix, camera.inverseWorldMatrix);
			copy$7(this._projectionMatrix, camera.projectionMatrix);
			multiply$7(this._modelViewMatrix, this._viewMatrix, this.worldMatrix);
			multiply$7(this._projectViewMatrix, camera.projectionMatrix, this._viewMatrix);

			// if the material is overriden, copy the original material uniforms
			let savedUniforms = {};
			if (isOverriden) {
				for (let k in material.uniforms) {
					savedUniforms[k] = material.uniforms[k].value;
				}
				for (let k in this.material.uniforms) {
					material.setUniform(k,this.material.uniforms[k].value);
				}
			}

			material.setUniform('uCameraPosition',   [camera.worldMatrix[12], camera.worldMatrix[13], camera.worldMatrix[14]] );
			material.setUniform('uNormalViewMatrix', camera._normalMatrix );
			material.setUniform('uPMatrix',          this._projectionMatrix);//camera.projectionMatrix );
			material.setUniform('uVMatrix',          this._viewMatrix );
			material.setUniform('uNormalMatrix',     this._normalMatrix );
			material.setUniform('uMMatrix',          this.worldMatrix );
			material.setUniform('uInvMMatrix',       this.inverseWorldMatrix );
			material.setUniform('uMVMatrix', 		 this._modelViewMatrix );
			material.setUniform('uPVMatrix',         this._projectViewMatrix );



			// Scene uniforms
			if (options.uniforms) {
				let contextUniformsKeys = Object.keys( options.uniforms );
				for (let i =0; i<contextUniformsKeys.length; i++) {
					material.setUniform( contextUniformsKeys[i], options.uniforms[ contextUniformsKeys[i] ] );
				}
			}

			// Mesh uniforms
			let meshUniformsKeys = Object.keys( this.uniforms );
			for (let i =0; i<meshUniformsKeys.length; i++) {
				material.setUniform( meshUniformsKeys[i] , this.uniforms[ meshUniformsKeys[i] ] );
			}
			
			let savedDefines = {};

			if ((options.overrideMaterial || options.overrideInstancedMaterial) && this.material && material.defines) {
				// material.defines = material.defines || {}; 
				for (let k in this.material.defines) {
					if (material.defines[ k ] !== this.material.defines[ k ]) {
						if (material.defines[ k ] !== void 0) {
							savedDefines[k] = material.defines[ k ];
						}
						material.defines[ k ] = this.material.defines[ k ];
					}
				}
			}
			
			// extra defines from scene context
			if (options.defines) {
				material.inheritedDefines = material.inheritedDefines || new Set();
				for (let k in options.defines) {
					if (material.defines[ k ] !== options.defines[ k ]) {
						if (material.defines[ k ] !== void 0) {
							savedDefines[k] = material.defines[ k ];
						}
						material.defines[ k ] = options.defines[ k ];
						if (!material.inheritedDefines.has(k)) {
							material.inheritedDefines.add(k);
						}
					}
				}
				material.inheritedDefines?.forEach(def => {
					if (material.defines[ def ] && !options.defines[ def ]) {
						delete material.defines[ def ];
						console.log('DELETE INHERITED DEFINE:', def);
					}
				});
			}

			// if ( !settings.isRenderingBackAlpha ) {
				// if (settings.backfaceCulling) {
				// 	if (this.doubleSided && material.gl){
				// 		material.gl.disable(material.gl.CULL_FACE);
				// 	}
				// 	if (this.backSided && material.gl ){
				// 		material.gl.cullFace(material.gl.FRONT);
				// 		material.gl.enable(material.gl.CULL_FACE);
				// 	}
				// }
				// else {
				





			// if ( !settings.isRenderingBackAlpha ) {
				// if (settings.backfaceCulling) {
				// 	if (this.doubleSided && material.gl){
				// 		material.gl.disable(material.gl.CULL_FACE);
				// 	}
				// 	if (this.backSided && material.gl ){
				// 		material.gl.cullFace(material.gl.FRONT);
				// 		material.gl.enable(material.gl.CULL_FACE);
				// 	}
				// }
				// else {
					if (material.gl) {
						material.gl.currentState = material.gl.currentState || {};
						if (options?.overrides?.disable === material.gl.CULL_FACE) {
							if (material.gl.currentState.CULL_FACE_ENABLED) {
								material.gl.currentState.CULL_FACE_ENABLED = false;
								material.gl.currentState.CULL_FACE_MODE    = null;
								material.gl.disable(material.gl.CULL_FACE);
								if (options?.overrides?.alphaPass) {
									console.log('OVERRIDE: DISBALE_CULL_FACE');
								}
							}
						}
						else if (options?.overrides?.enable === material.gl.CULL_FACE ) {
							if (!material.gl.currentState.CULL_FACE_ENABLED) {
								material.gl.currentState.CULL_FACE_ENABLED = true;
								material.gl.enable(material.gl.CULL_FACE);
								if (options?.overrides?.alphaPass) {
									console.log('OVERRIDE: ENABLE_CULL_FACE');
								}
							}
							if (options?.overrides?.cullFace === material.gl.FRONT) {
								if (material.gl.currentState.CULL_FACE_MODE !== material.gl.FRONT) {
									material.gl.currentState.CULL_FACE_MODE = material.gl.FRONT;
									material.gl.cullFace(material.gl.FRONT);
									if (options?.overrides?.alphaPass) {
										console.log('OVERRIDE: CULL_FACE_MODE: FRONT');
									}
								}
							}
							else  {
								if (material.gl.currentState.CULL_FACE_MODE !== material.gl.BACK) {
									material.gl.currentState.CULL_FACE_MODE = material.gl.BACK;
									material.gl.cullFace(material.gl.BACK);
									if (options?.overrides?.alphaPass) {
										console.log('OVERRIDE: CULL_FACE_MODE: BACK');
									}
								}
							}
						}
						else {
							// Front face culling
							if (this.backSided) {
								if (!material.gl.currentState.CULL_FACE_ENABLED) {
									material.gl.currentState.CULL_FACE_ENABLED = true;
									material.gl.enable(material.gl.CULL_FACE);
									if (options?.overrides?.alphaPass) {
										console.log('ENABLE_CULL_FACE');
									}
								}
								if (material.gl.currentState.CULL_FACE_MODE !== material.gl.FRONT) {
									material.gl.currentState.CULL_FACE_MODE = material.gl.FRONT;
									material.gl.cullFace(material.gl.FRONT);
									if (options?.overrides?.alphaPass) {
										console.log('CULL_FACE_MODE: FRONT');
									}
								}
							}
							// disable culling
							else if (this.doubleSided || this.twoSided) {
								if (material.gl.currentState.CULL_FACE_ENABLED) {
									material.gl.currentState.CULL_FACE_ENABLED = false;
									material.gl.currentState.CULL_FACE_MODE    = null;
									material.gl.disable(material.gl.CULL_FACE);
									if (options?.overrides?.alphaPass) {
										console.log('DISBALE_CULL_FACE');
									}
								}
							}
							// backface culling (default)
							else {
								if (!material.gl.currentState.CULL_FACE_ENABLED) {
									material.gl.currentState.CULL_FACE_ENABLED = true;
									material.gl.enable(material.gl.CULL_FACE);
									if (options?.overrides?.alphaPass) {
										console.log('ENABLE_CULL_FACE');
									}
								}
								if (material.gl.currentState.CULL_FACE_MODE !== material.gl.BACK) {
									material.gl.currentState.CULL_FACE_MODE = material.gl.BACK;
									material.gl.cullFace(material.gl.BACK);
									if (options?.overrides?.alphaPass) {
										console.log('CULL_FACE_MODE: BACK');
									}
								}
							}
						}
					}
				// }
			// }



				// }
			// }
			
			
			// else {
			// if (options?.overrides?.blend && material.blend) {
			// 	//skip 
			// }
			// else {
				
				// if (
				// 		this.__is_cluster__ 
				// 		&& this.name !== 'cluster_groups_infos_mesh' 
				// 		&& this.name !== 'cluster_instances_infos_mesh' 
				// 		&& this.name !== 'cluster_bvh_infos_mesh' 
				// 		&& this.name !== 'cluster_requests_mesh'
				// 		// && this.name !== 'cluster_triangle_mesh' 
				// 	) {
				// 	console.log('SKIP_DRAW_CLUSTER_MESH', this.name, {mesh: this, options});
				// 	return;
				// }

				// stats.vertices  = stats.vertices  || 0;
				// stats.triangles = stats.triangles || 0;
				// stats.drawCalls = stats.drawCalls || 0;
				// if (this.geometry.attributes?.position) {
				// 	stats.vertices  += (this.geometry.attributes.position.data.length/3);
				// 	stats.triangles += (this.geometry.attributes.position.data.length/3/3);
				// }
				// if (this.geometry.attributes?.position?.length > window.maxDrawnGeometryLength) {
				// 	window.maxDrawnGeometryLength = this.geometry.attributes?.position.length;
				// 	window.maxDrawnGeometry = this;
				// }
				// stats.drawCalls += 1;
				// drawCalls.push({
				// 	name:       this.name || this.id,
				// 	instances:  numInstances,
				// 	instancing: isInstancing,
				// 	vertices:   !this.geometry.attributes?.position ? 0 : (this.geometry.attributes?.position?.length)/3,
				// });




			    // console.timeStamp("Mesh.draw:" + (this.name || this.id));

				if (this.options.beforeRender ) {
					this.options.beforeRender(this, material) ;
				}

					
				material.beforeDraw?.();
				material.draw( this.geometry, options );//.overrides, options.usetransformFeedback );
				material.afterDraw?.();
				
			// }
			// }

			// restore the program
			// if (options.overrideMaterial) {
			// 	options.overrideMaterial.defines = options.overrideMaterial._oldDefines;
			// }

			// restore original material defines
			// if (options.defines) {
			// 	material.defines = savedDefines;
			// }
			for (let k in savedDefines) {
				material.defines[ k ] = savedDefines[ k ];
			}

			// Restore unfiroms OF THE overriden the material
			if (isOverriden) {
				for (let k in savedUniforms) {
					material.setUniform(k,savedUniforms[k]);
				}
			}

			// if ((this.doubleSided || this.backSided) && material.gl &&  settings.backfaceCulling && !settings.isRenderingAlpha) {
				// if (material.gl?.savedState) {
				// 	if ( 
				// 		material.gl.savedState.CULL_FACE_MODE == material.gl.BACK  || 
				// 		material.gl.savedState.CULL_FACE_MODE == material.gl.FRONT
				// 	){
				// 		material.gl.cullFace(material.gl.savedState.CULL_FACE_MODE);
				// 		material.gl.enable(material.gl.CULL_FACE);
				// 	}
				// }
			// }

			if (this.options?.afterRender) {
				this.options?.afterRender() ;
			}

		}

	}

}

class Renderer {
  
  constructor(options) {

    this.canvas = (options && options.canvas) || document.createElement('canvas');
  
    this.contextAttributes = Object.assign({},{
      alpha:                        false,
      depth:                        true,
      stencil:                      true,
      antialias:                    false,
      premultipliedAlpha:           true,
      preserveDrawingBuffer:        false,
      failIfMajorPerformanceCaveat: false,
    }, (options || {}) );
  
    this._pixelRatio = 1;
  
    let gl;
  
    try { 
      gl = this.canvas.getContext("webgl2", this.contextAttributes); 
    } catch (x) { 
      try { 
        gl = this.canvas.getContext("webgl", this.contextAttributes); 
      } catch (x) { 
        gl = null; 
      }
    }
  
    this.gl = gl;
    this.supportWebgl = gl !== null;
    if (!this.supportWebgl) {
      console.warn('no Webgl support');
      return;
    }
  
    this.handleContextLost =  this.handleContextLost.bind(this);
    this.handleContextRestored =  this.handleContextRestored.bind(this);
    this.canvas.addEventListener('webglcontextlost', this.handleContextLost, false);
    this.canvas.addEventListener('webglcontextrestored', this.handleContextRestored, false);
  }

  handleContextLost(event){
    event.preventDefault();
  }

  handleContextRestored(){
    
  }

  handleContextRestored() {

  }

  render(container, camera, frameBuffer, options = {}) {

    if (!this.gl) {
      return;
    }

    // if (!preventCameraUpdate) {
    //   // camera && camera.update();
    // }
    
    if (frameBuffer){ 
      frameBuffer.bindFrame(options?.bindOnly); 
      container.render( camera );
      frameBuffer.unbind();
    }
    else {
      if (options?.skipViewport) ;
      else {
        this.gl.viewport(0, 0, this._width* this._pixelRatio , this._height* this._pixelRatio );
      }
      container && container.render( camera );
    }

  }

  resize(width, height) {
    if (!this.gl) {
      return;
    }
    this._width  = width;
    this._height = height;
    this.canvas.width  = this._width * this._pixelRatio;
    this.canvas.height = this._height * this._pixelRatio;
    this.gl.viewport(0, 0, this._width* this._pixelRatio , this._height* this._pixelRatio );
  }

  clearColor(r, g, b, alpha) {
    if (!this.gl) {
      return;
    }
    this.gl.clearColor(r, g, b, alpha);
  }

  clear(color, depth, stencil) {
    if (!this.gl) {
      return;
    }
    var bits = 0;
    if ( color === void 0 || color ) bits |= this.gl.COLOR_BUFFER_BIT;
    if ( depth === void 0 || depth ) bits |= this.gl.DEPTH_BUFFER_BIT;
    if ( stencil === void 0 || stencil ) bits |= this.gl.STENCIL_BUFFER_BIT;
    this.gl.clear( bits );
  }

  setPixelRatio(ratio) {
    this._pixelRatio = ratio;
    this.resize(this._width, this._height);
  }

}

let _vector = create$5();

class Plane {
	constructor() {
		this.normal = create$5();
		this.w      = 0;
	}
	distanceToPoint( p ) {
		return dot$3(this.normal, p ) + this.w;
	}
	setComponents(x,y,z,w) {
		set$5(this.normal, x,y,z);
		this.w = w;
		return this;
	}
	normalize(){
		let inverseNormalLength = 1.0 / length$3(this.normal);
		scale$5( this.normal, this.normal, inverseNormalLength );
		this.w *= inverseNormalLength;
		return this;
	}
}

class Frustum {
	constructor() {
		this.planes = [];
		for ( var i = 0; i < 6; i ++ ) {
			this.planes.push( new Plane() );
		}
    }
    intersectsSphere( sphere ) {
        for ( let i = 0; i < 6; i ++ ) {
            let dist = this.planes[ i ].distanceToPoint( sphere.center );
            if ( dist < -sphere.radius ) {
                return false;
            }
        }
        return true;
    }
	intersectsBox( box ) {
		var planes = this.planes;
		for ( var i = 0; i < 6; i ++ ) {
			var plane = planes[ i ];
			_vector[0] = plane.normal[0] > 0 ? box.max[0] : box.min[0];
			_vector[1] = plane.normal[1] > 0 ? box.max[1] : box.min[1];
			_vector[2] = plane.normal[2] > 0 ? box.max[2] : box.min[2];
			if ( plane.distanceToPoint( _vector ) < 0 ) {
				return false;
			}
		}
		return true;
	}
	setFromProjectionMatrix( m ) {
		this.planes[ 0 ].setComponents( m[3] - m[ 0 ], m[7] - m[4], m[11] - m[8], m[15] - m[12] ).normalize();
		this.planes[ 1 ].setComponents( m[3] + m[ 0 ], m[7] + m[4], m[11] + m[8], m[15] + m[12] ).normalize();
		this.planes[ 2 ].setComponents( m[3] + m[1], m[7] + m[5], m[11] + m[9], m[15] + m[13] ).normalize();
		this.planes[ 3 ].setComponents( m[3] - m[1], m[7] - m[5], m[11] - m[9], m[15] - m[13] ).normalize();
		this.planes[ 4 ].setComponents( m[3] - m[2], m[7] - m[6], m[11] - m[10], m[15] - m[14] ).normalize();
        this.planes[ 5 ].setComponents( m[3] + m[2], m[7] + m[6], m[11] + m[10], m[15] + m[14] ).normalize();
	}
}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */
function create$2() {
  let out = new ARRAY_TYPE(2);
  out[0] = 0;
  out[1] = 0;
  return out;
}

/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {vec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */
function clone$2(a) {
  let out = new ARRAY_TYPE(2);
  out[0] = a[0];
  out[1] = a[1];
  return out;
}

/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */
function fromValues$2(x, y) {
  let out = new ARRAY_TYPE(2);
  out[0] = x;
  out[1] = y;
  return out;
}

/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the source vector
 * @returns {vec2} out
 */
function copy$2(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  return out;
}

/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */
function set$2(out, x, y) {
  out[0] = x;
  out[1] = y;
  return out;
}

/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function add$2(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  return out;
}

/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function subtract$2(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  return out;
}

/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function multiply$2(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to ceil
 * @returns {vec2} out
 */
function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to floor
 * @returns {vec2} out
 */
function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to round
 * @returns {vec2} out
 */
function round (out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */
function scale$2(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */
function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} distance between a and b
 */
function distance(a, b) {
  var x = b[0] - a[0],
    y = b[1] - a[1];
  return Math.sqrt(x*x + y*y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} squared distance between a and b
 */
function squaredDistance(a, b) {
  var x = b[0] - a[0],
    y = b[1] - a[1];
  return x*x + y*y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {vec2} a vector to calculate length of
 * @returns {Number} length of a
 */
function length(a) {
  var x = a[0],
    y = a[1];
  return Math.sqrt(x*x + y*y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {vec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
function squaredLength (a) {
  var x = a[0],
    y = a[1];
  return x*x + y*y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */
function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to invert
 * @returns {vec2} out
 */
function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */
function normalize(out, a) {
  var x = a[0],
    y = a[1];
  var len = x*x + y*y;
  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
  }
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */
function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec3} out
 */
function cross(out, a, b) {
  var z = a[0] * b[1] - a[1] * b[0];
  out[0] = out[1] = 0;
  out[2] = z;
  return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec2} out
 */
function lerp(out, a, b, t) {
  var ax = a[0],
    ay = a[1];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */
function random(out, scale) {
  scale = scale || 1.0;
  var r = RANDOM() * 2.0 * Math.PI;
  out[0] = Math.cos(r) * scale;
  out[1] = Math.sin(r) * scale;
  return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat2(out, a, m) {
  var x = a[0],
    y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2d} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat2d(out, a, m) {
  var x = a[0],
    y = a[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat3} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat3(out, a, m) {
  var x = a[0],
    y = a[1];
  out[0] = m[0] * x + m[3] * y + m[6];
  out[1] = m[1] * x + m[4] * y + m[7];
  return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec2} out
 */
function transformMat4(out, a, m) {
  let x = a[0];
  let y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}

/**
 * Returns a string representation of a vector
 *
 * @param {vec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */
function str$2(a) {
  return 'vec2(' + a[0] + ', ' + a[1] + ')';
}

/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function exactEquals$2(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
function equals$2(a, b) {
  let a0 = a[0], a1 = a[1];
  let b0 = b[0], b1 = b[1];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)));
}

/**
 * Alias for {@link vec2.length}
 * @function
 */
const len = length;

/**
 * Alias for {@link vec2.subtract}
 * @function
 */
const sub$2 = subtract$2;

/**
 * Alias for {@link vec2.multiply}
 * @function
 */
const mul$2 = multiply$2;

/**
 * Alias for {@link vec2.divide}
 * @function
 */
const div = divide;

/**
 * Alias for {@link vec2.distance}
 * @function
 */
const dist = distance;

/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */
const sqrDist = squaredDistance;

/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */
const sqrLen = squaredLength;

/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
const forEach = (function() {
  let vec = create$2();

  return function(a, stride, offset, count, fn, arg) {
    let i, l;
    if(!stride) {
      stride = 2;
    }

    if(!offset) {
      offset = 0;
    }

    if(count) {
      l = Math.min((count * stride) + offset, a.length);
    } else {
      l = a.length;
    }

    for(i = offset; i < l; i += stride) {
      vec[0] = a[i]; vec[1] = a[i+1];
      fn(vec, vec, arg);
      a[i] = vec[0]; a[i+1] = vec[1];
    }

    return a;
  };
})();

var vec2 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$2,
   clone: clone$2,
   fromValues: fromValues$2,
   copy: copy$2,
   set: set$2,
   add: add$2,
   subtract: subtract$2,
   multiply: multiply$2,
   divide: divide,
   ceil: ceil,
   floor: floor,
   min: min,
   max: max,
   round: round,
   scale: scale$2,
   scaleAndAdd: scaleAndAdd,
   distance: distance,
   squaredDistance: squaredDistance,
   length: length,
   squaredLength: squaredLength,
   negate: negate,
   inverse: inverse,
   normalize: normalize,
   dot: dot,
   cross: cross,
   lerp: lerp,
   random: random,
   transformMat2: transformMat2,
   transformMat2d: transformMat2d,
   transformMat3: transformMat3,
   transformMat4: transformMat4,
   str: str$2,
   exactEquals: exactEquals$2,
   equals: equals$2,
   len: len,
   sub: sub$2,
   mul: mul$2,
   div: div,
   dist: dist,
   sqrDist: sqrDist,
   sqrLen: sqrLen,
   forEach: forEach
});

const TOUCH      = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0);
const POINTER    = !!window.navigator.pointerEnabled;
const MS_POINTER = !!window.navigator.msPointerEnabled;

const POINTER_DOWN = TOUCH ? 'touchstart' : (POINTER ? 'pointerdown' : (MS_POINTER ? 'MSPointerDown' : 'mousedown' ) ); 
const POINTER_MOVE   = TOUCH ? 'touchmove'  : (POINTER ? 'pointermove' : (MS_POINTER ? 'MSPointerMove' : 'mousemove' ) ); 
const POINTER_UP = TOUCH ? 'touchend'   : (POINTER ? 'pointerup'   : (MS_POINTER ? 'MSPointerUp'   : 'mouseup'   ) ); 

// var objects = []


function applyMat4(v,e) {
  const w = 1 / ( e[ 3 ] * v[0] + e[ 7 ] * v[1] + e[ 11 ] * v[2] + e[ 15 ] );
  return [
      ( e[ 0 ] * v[0] + e[ 4 ] * v[1] + e[ 8 ]  * v[2] + e[ 12 ] )  * w,
      ( e[ 1 ] * v[0] + e[ 5 ] * v[1] + e[ 9 ]  * v[2] + e[ 13 ] )  * w,
      ( e[ 2 ] * v[0] + e[ 6 ] * v[1] + e[ 10 ] * v[2] + e[ 14 ] )  * w
  ]
}


class Camera extends Object3d {

  constructor(options) {
    
    super();

    this.touchEventPageX = 0;
    this.touchEventPageY = 0;

    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp   = this._onPointerUp.bind(this);
    this._onMouseWheel  = this._onMouseWheel.bind(this);
    this.onContextMenu  = this.onContextMenu.bind(this);
    this._handleOrientation   = this._handleOrientation.bind(this);

    this._projScreenMatrix = create$7();


    options = Object.assign({},{
      fov:    45,
      aspect: window.innerWidth / window.innerHeight,
      near:   10,
      far:    1000,
      type:  'perspective',
      left:   0,
      right:  0,
      top:    0,
      bottom: 0,
      orbitControl: false,
      wheel: true,
      lookAt: null,
      pointerParent: document,
      firstPerson: false,
      lookAround: false,
      playerCamera: false,
      tilt: false,
      moveSpeed: 1,
      wheelSpeed: 1,
      distance: 20,
      position: [0,0,0],
      frustum: false,
      cameraDistance: 100,
      theta: 0,
      phi:   0,
      minTheta: -Math.PI,
      maxTheta: Math.PI,
      minPhi:   -Math.PI,
      maxPhi:   Math.PI ,
      minCameraDistance: 0,
      maxCameraDistance: 10000,
      offset: [0,0,0],
      drag: false,
      heightMap: null,
      landscapeSize: [0,0],
      useCameraRotationEase: true,
      reverseCameraRotation: true,
      cameraTiltTheta: 0.1,
      cameraTiltPhi: 0.05,
      useTilt: false,
      useRail: false,
      followTerrain: false,
      useCollision: false,
      minPolarAngle:  Math.PI * -1,
      maxPolarAngle:  Math.PI * 1 ,
      skipGlobalSettings: false,

      thetaSmoothing: 0.1,
      phiSmoothing: 0.8,

    }, options);

    
    this.useTilt       = options.useTilt;
    this.useRail       = options.useRail;
    this.followTerrain = options.followTerrain;
    this.useCollision = options.useCollision;

    this.skipGlobalSettings = options.skipGlobalSettings;

    this.extraTheta = 0;
    this.extraPhi = 0;
    
    this._cameraTiltTheta = options.cameraTiltTheta;// 0.1
    this._cameraTiltPhi   = options.cameraTiltPhi;//0.05
    
    this.heightMap = options.heightMap;
    this.landscapeSize = options.landscapeSize;

    this.playerCamera = options.playerCamera;

    this.drag = options.drag;
    this.dragDirX = create$2();
    this.dragDirY = create$2();

    this.offset = options.offset;

    this.minCameraDistance = options.minCameraDistance;
    this.maxCameraDistance = options.maxCameraDistance;


    this.minPolarAngle = options.minPolarAngle;//Math.PI * -1 
    this.maxPolarAngle = options.maxPolarAngle;// Math.PI * 1 


    this.theta = options.theta;
    this.phi   = options.phi;

    this.currTheta = this.theta;
    this.currPhi = this.phi;  


    this.pointerTheta = 0;
    this.pointerPhi   = 0;
    this.currPointerPhi = 0;
    this.currPointerTheta = 0;

    this.useCameraRotationEase = options.useCameraRotationEase;
    this.reverseCameraRotation = options.reverseCameraRotation;


    this.minTheta= options.minTheta;
    this.maxTheta= options.maxTheta;
    this.minPhi= options.minPhi;
    this.maxPhi= options.maxPhi;

    this.frustum = options.frustum ? new Frustum() : null;

    this.lookAt = options.lookAt;
    this.fov    = options.fov;
    this.aspect = options.aspect;
    this.near   = options.near;
    this.far    = options.far;
    this.type   = options.type;
    this.left   = options.left;
    this.right  = options.right;
    this.top    = options.top;
    this.bottom = options.bottom;
    this.orbitControl = options.orbitControl;
    this.tilt = options.tilt; 
    this.firstPerson = options.firstPerson;
    this.lookAround = options.lookAround;
    this.wheel = options.wheel;

    this.thetaSmoothing = options.thetaSmoothing;
    this.phiSmoothing = options.phiSmoothing;

    this.projectionMatrix = create$7();
    this.inverseProjectionMatrix = create$7();
    this.updateProjectionMatrix();

    if ( this.orbitControl || this.tilt || this.firstPerson || this.lookAround ) {
      if (!this.lookAt) {
        this.lookAt = create$5();
        set$5(this.lookAt, 0,0,0 );
      }

      this.originalLookAt = create$5();
      copy$5(this.originalLookAt, this.lookAt);

      this._pointerParent = options.pointerParent;
      this._initPointerEvents();
      this._cameraDistance  = options.cameraDistance;
      // objects.push(this);
    }

    if (this.firstPerson) {
      document.addEventListener("contextmenu", this.onContextMenu.bind(this), false);
      document.addEventListener("keydown", this.onKeyDown.bind(this), false);
      document.addEventListener("keyup", this.onKeyUp.bind(this), false);
    }

    this.pitchObject = new Container();
    this.pitchObject.id = this.pitchObject.name = 'Camera__pitchObject';
    
    this.yawObject   = new Container();
    this.yawObject.id = this.yawObject.name = 'Camera__yawObject';
    
    this.yawObject.add( this.pitchObject );
    this.moveSpeed = options.moveSpeed;
    this.wheelSpeed = options.wheelSpeed;
    this.time = Date.now();
    this._velocity     = create$5();
    this._moveForward  = false;
    this._moveBackward = false;
    this._moveLeft     = false;
    this._moveRight    = false;
    this._moveUp       = false;
    this._camera = create$5();
    this._oldPosition = create$5();

    this.position[0]      = options.position[0];
    this.position[1]      = options.position[1];
    this.position[2]      = options.position[2];
    this._oldPosition[0]  = this.position[0];
    this._oldPosition[1]  = this.position[1];
    this._oldPosition[2]  = this.position[2];

    this.currPointerXMove = 0;
    this.currPointerYMove = 0;
  }

  updateProjectionMatrix() {
    if (this.type == 'perspective') {
      perspective(this.projectionMatrix, this.fov * Math.PI/180.0, this.aspect, this.near, this.far);
    }
    else if(this.type == 'orthographic' || this.type == 'ortho'){
      ortho(this.projectionMatrix, this.left, this.right, this.bottom, this.top, this.near, this.far);
    }

    invert$4(this.inverseProjectionMatrix, this.projectionMatrix);


  }

  _initPointerEvents() {

    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    this._isPointerDown = false;
    this.isRightClick = false;

    this.pointerXMove    = 0;
    this.pointerYMove    = 0;


    this.pointerX = 0;
    this.pointerY = 0;
    this.pointerZ = 0;
    this.lastPointerX = 0;
    this.lastPointerY = 0;
    this.lastPointerZ = 0;

  
    this.thetaDown = this.theta;
    this.phiDown   = this.phi;


    this._pointerParent.addEventListener(POINTER_DOWN, this._onPointerDown, {passive:false});
    document.addEventListener(POINTER_MOVE, this._onPointerMove, {passive:false});
    document.addEventListener(POINTER_UP, this._onPointerUp,false);

    // if (window.DeviceMotionEvent && typeof window.DeviceMotionEvent.requestPermission === 'function') {
    //   document.addEventListener('click', function () {
    //       DeviceOrientationEvent.requestPermission().then(response => {
    //         if (response == 'granted') {
    //           window.addEventListener("deviceorientation", this._handleOrientation, true);
    //         }
    //       }).catch(console.error)
    //   });
    // }
    // else {
    //   window.addEventListener("deviceorientation", this._handleOrientation, true);
    // }

    
    this._pointerParent.addEventListener( "contextmenu", this.onContextMenu, false);
    if (this.wheel) {  
      this._pointerParent.addEventListener( 'DOMMouseScroll', this._onMouseWheel);//,  {passive:false} );
      this._pointerParent.addEventListener( 'mousewheel',     this._onMouseWheel);//,  {passive:false} );
    }
  }

  delete() {
    this._pointerParent.removeEventListener(POINTER_DOWN, this._onPointerDown, false);
    document.removeEventListener(POINTER_MOVE, this._onPointerMove, false);
    document.removeEventListener(POINTER_UP, this._onPointerUp, false);
    this._pointerParent.removeEventListener( "contextmenu", this.onContextMenu, false);
    if (this.wheel) {
      this._pointerParent.removeEventListener( 'DOMMouseScroll', this._onMouseWheel);//,  {passive:false} );
      this._pointerParent.removeEventListener( 'mousewheel',     this._onMouseWheel);//,  {passive:false} );
    }
    document.removeEventListener("keydown", this.onKeyDown, false);
    document.removeEventListener("keyup", this.onKeyUp, false);
  }

  destroy() {
    this.delete();
  }
  
  onContextMenu(e) {
    if (this.disabled) {
      return;
    }
    event.preventDefault();
  }
 
  onKeyDown(event) {
    if (this.disabled) {
      return;
    }
    switch ( event.keyCode ) {
      // case 38: // up
      case 87: // w
        this._moveForward = true;
        break;
      // case 37: // left
      case 65: // a
        this._moveLeft = true; 
        break;
      // case 40: // down
      case 83: // s
        this._moveBackward = true;
        break;
      // case 39: // right
      case 68: // d
        this._moveRight = true;
        break;
      case 32: // space
        this._velocity[1] += 5;
        break;
    }
  }
  onKeyUp(event) {
    if (this.disabled) {
      return;
    }
    switch( event.keyCode ) {
      case 38: // up
      case 87: // w
        this._moveForward = false;
        break;
      case 37: // left
      case 65: // a
        this._moveLeft = false;
        break;
      case 40: // down
      case 83: // s
        this._moveBackward = false;
        break;
      case 39: // right
      case 68: // d
        this._moveRight = false;
        break;
    }
  }

  _onMouseWheel(e) {
    if (this.disabled) {
      return;
    }
    // e.preventDefault();
    // e.stopPropagation();
    var wheelDeltaY;
    if ( e.wheelDelta ){
        wheelDeltaY = e.wheelDelta; //6 or 12
    } else if ( e.detail ){
        wheelDeltaY = -e.detail * 40; // *3
    } else if ( e.wheelDeltaX ) {
        wheelDeltaY = e.wheelDeltaY/12;
        -1 * e.wheelDeltaX/12; 
    } else if ( e.axis !== undefined && e.axis === e.HORIZONTAL_AXIS ) {
        wheelDeltaY = 0;
    } else {
        wheelDeltaY = 0;
    }
    this._cameraDistance += wheelDeltaY * -1 * this.wheelSpeed;//0.001;
    this._cameraDistance = Math.min(this.maxCameraDistance, Math.max(this.minCameraDistance, this._cameraDistance));
  }

  disable() {
    this.disabled = true;
  }
  enable() {
    this.disabled = false;
  }

  _onPointerDown(event) {

    if (this.disabled) {
      return;
    }

    if (event.which == 3) {
      this.isRightClick = true;
    }

      document.body.classList.add("is-dragging");
    this._isPointerDown = true;


    this.touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
    
    // if (!this.lookAround) {
      this.touchEventPageX = this.touchEvent.pageX;
      this.touchEventPageY = this.touchEvent.pageY;
      this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
      this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
      this.pointerXDown     = this.touchEventPageX;
      this.pointerYDown     = this.touchEventPageY;

      this.startPointerX    = this.pointerXMove;
      this.startPointerY    = this.pointerYMove;

      if (this.drag) {
        set$2( this.dragDirY, this.position[0], this.position[2] );
        subtract$2( this.dragDirY, this.dragDirY, [this.lookAt[0], this.lookAt[2]] );
        normalize( this.dragDirY, this.dragDirY );
        set$2( this.dragDirX, this.dragDirY[1], -this.dragDirY[0] );
      }

      if (!this.tilt) {
        this.thetaDown = this.theta;
        this.phiDown   = this.phi;

      }


    // }

  }

  _handleOrientation() {
    // if (this._isPointerDown) {
    //   return
    // }
    // if (this.playerCamera) {
    //   this.pointerRatio[0] = (event.gamma) / 25
    //   this.pointerRatio[1] = (event.beta-45) / 25
    //   this.pointerTheta = (  (event.gamma) / 25  * 0.1 * -1  );
    //   this.pointerPhi   = ( (event.beta-45) / 25 * 0.05 * -1);
    // }
  }

  _onPointerMove(event) {

    if( (!this._isPointerDown && !document.pointerLockElement && (!this.lookAround && !this.tilt  )) || this.disabled){
      return;
    }
    
    
    if (this._isPointerDown) {
      event.preventDefault();
      if (TOUCH) event.stopPropagation();
    }

    if (/*this.isRightClick || */
        this._isPointerDown && this.drag
        ) {
      let touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
      let touchEventPageX = touchEvent.pageX;
      let touchEventPageY = touchEvent.pageY;
      touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
      this.pointerXMove = this.startPointerX 
                        + (this.dragDirY[0] * (touchEventPageY - this.pointerYDown) * -1 ) 
                        + (this.dragDirX[0] * (touchEventPageX - this.pointerXDown) * -1 * 0.5);
      this.pointerYMove = this.startPointerY 
                        + (this.dragDirY[1] * (touchEventPageY - this.pointerYDown) * -1 ) 
                        + (this.dragDirX[1] * (touchEventPageX - this.pointerXDown) * -1 * 0.5);
      return
    }


      if (!!document.pointerLockElement) {
        this.touchEvent  = event;
        this.touchEventPageX += this.touchEvent.movementX;
        this.touchEventPageY += this.touchEvent.movementY;
        this.touchEventPageY = Math.max(0, Math.min(window.innerHeight, this.touchEventPageY));
        this.pointerXOrbiter = (this.touchEventPageX);
        this.pointerYOrbiter = (this.touchEventPageY);
        this.theta = ( ((this.pointerXOrbiter / window.innerWidth)-0.5) * Math.PI) * -1;
        this.phi   = ( ((this.pointerYOrbiter / window.innerHeight)-0.5) * Math.PI );
      }
      else {
        
        this.touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
        this.touchEventPageX = this.touchEvent.pageX;
        this.touchEventPageY = this.touchEvent.pageY;
        // this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
        this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;

        if (this.lookAround || this.tilt  ) {
          if (this.tilt ){
            this.pointerXOrbiter = this.touchEventPageX;
            this.pointerYOrbiter = this.touchEventPageY;
            this.theta = this.thetaDown + ( ((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI/(20/2)  *-1  );//20
            this.phi   = this.phiDown   + ( ((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI/30   );//30
            this.phi   = Math.max( this.minPhi, Math.min( this.maxPhi, this.phi ) );
            this.theta = Math.max( this.minTheta, Math.min( this.maxTheta, this.theta ) );
          }
          else {
           
            if (this.playerCamera) {

              if (this._isPointerDown) {
                this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
                this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
                this.theta = this.thetaDown + ( ((this.pointerXOrbiter / window.innerWidth ) * 2)  * Math.PI/4 * -1 );
                this.phi   = this.phiDown   + ( ((this.pointerYOrbiter / window.innerHeight ) * 2) * Math.PI/8 * -1 );
              }
              
              this.pointerTheta = ( ((this.touchEventPageX / window.innerWidth - .5) * 2)  * this._cameraTiltTheta * -1  );
              this.pointerPhi   = ( ((this.touchEventPageY / window.innerHeight - .5) * 2) * this._cameraTiltPhi * -1 ) ;

            }
            else {
              this.pointerXOrbiter = this.touchEventPageX;
              this.pointerYOrbiter = this.touchEventPageY;
              this.theta = ( ((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI*0.4 *-1);
              this.phi   = ( ((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI*0.125 *-1);
            }
            
            this.phi   = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this.phi ) );

            // this.phi   = Math.max( this.minPhi, Math.min( this.maxPhi, this.phi ) );
            this.theta = Math.max( this.minTheta, Math.min( this.maxTheta, this.theta ) );

          }
        }

        else if (this.firstPerson && this.reverseCameraRotation) {
          this.pointerXMove = this.startPointerX + (this.touchEventPageX - this.pointerXDown);
          this.pointerYMove = this.startPointerY + (this.touchEventPageY - this.pointerYDown);
          this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
          this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
          this.theta = this.thetaDown + ( this.pointerXOrbiter / window.innerWidth * 2 * Math.PI*0.5  * -1 );
          this.phi   = this.phiDown   + ( this.pointerYOrbiter / window.innerHeight * 2 * Math.PI*0.2 );
          this.phi   = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this.phi ) );
        }

        else {
          this.pointerXMove = this.startPointerX + (this.touchEventPageX - this.pointerXDown);
          this.pointerYMove = this.startPointerY + (this.touchEventPageY - this.pointerYDown);
          this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
          this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
          this.theta = this.thetaDown + ( this.pointerXOrbiter / window.innerWidth * 2 * Math.PI);
          this.phi   = this.phiDown   + ( this.pointerYOrbiter / window.innerHeight * 2 * Math.PI * -1);
          this.phi   = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this.phi ) );
        }
        
      }

  }

  _onPointerUp() {



    this._isPointerDown = false;
    this.isRightClick = false;
    document.body.classList.remove("is-dragging");
  }


  freeze() {
    this.isFrozen = true;
  }
  unfreeze() {
    this.isFrozen = false;
  }

  update(skipRotation) {

    if (this.isFrozen || this.disabled) {
      return;
    }

    if (this.orbitControl) {

        this.currTheta += (this.theta - this.currTheta) * this.thetaSmoothing;
        this.currPhi   += (this.phi - this.currPhi)     * 0.8;
        this.position[0] = this.offset[0] +  Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.position[1] = this.offset[1] + Math.sin(this.currPhi)   * this._cameraDistance;
        this.position[2] = this.offset[2] +  Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.lookAt[0] = this.offset[0];//0.000000001//this.pointerXMove / -100;
        this.lookAt[1] = this.offset[1];//0.000000001//this.pointerYMove / 100; 
        this.lookAt[2] = this.offset[2];//0.000000001
        super.render(true);
    }
    else if (this.tilt) {
        this.currTheta += (this.theta - this.currTheta) * 0.05;
        this.currPhi   += (this.phi - this.currPhi) * 0.05;
        

        let dragY = create$5();
        copy$5( dragY, this.position );
        subtract$4( dragY, dragY, this.lookAt );
        normalize$3( dragY, dragY  );
        
          // this.pointerYMove

        this.currPointerXMove += (this.pointerXMove - this.currPointerXMove) * 0.15;
        this.currPointerYMove += (this.pointerYMove - this.currPointerYMove) * 0.15;

        this.position[0] = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.position[1] = this.offset[1] + Math.sin(this.currPhi) * this._cameraDistance;
        this.position[2] = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        
        this.lookAt[0]  = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1;
        this.lookAt[1]  = this.offset[1] + Math.sin(this.currPhi)   * this._cameraDistance * -1;
        this.lookAt[2]  = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1;
        super.render(true);
    }
 
    else if (this.lookAround)
    {

      if (!skipRotation) {
        let time = Date.now();
        this.lastTiltTime = this.lastTiltTime  || Date.now();
        let dd = ( time - this.lastTiltTime ) / 1000;
        this.lastTiltTime = time;
        const easSpeed  = 0.07 * (dd / 0.016);
        const easSpeed2 = 0.05 * (dd / 0.016);

        // this.currTheta += (this.theta - this.currTheta) * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;
        // this.currPhi   += (this.phi   - this.currPhi)     * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;

        this.currTheta        += ((this.theta)- this.currTheta) * easSpeed;
        this.currPhi          += ((this.phi ) - this.currPhi)   * easSpeed;
        this.currPointerTheta += ((this.pointerTheta)- this.currPointerTheta) * easSpeed2;
        this.currPointerPhi   += ((this.pointerPhi ) - this.currPointerPhi)  * easSpeed2;
      }
      
        this.lookAt[0]   = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100; 
        this.lookAt[1]   = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi + (this.extraPhi||0) ) * 100;
        this.lookAt[2]   = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100; 

        // if (this.playerCamera) {
        //   this.position[0] = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
        //   this.position[1] = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi ) * 70 * -1
        //   this.position[2] = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
        // }
        // else {
          this.position[0] = this.offset[0]; //+ Math.sin(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
          this.position[1] = this.offset[1]; //+ Math.sin(this.currPhi + this.currPointerTheta ) * -1
          this.position[2] = this.offset[2]; //+ Math.cos(this.currTheta + this.currPointerTheta + (this.extraTheta||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
        // }
        super.render();
        
    }
    else if (this.firstPerson){

      let time = Date.now();
      let delta = ( time - this.time ) / 1000;
      this.prevTime = time;

      delta = Math.min(1000/30, delta);

      // use delta to accomodate for 120fps mode
      // update phi and theta easing
      if (!skipRotation) {
        let time = Date.now();
        this.lastTiltTime = this.lastTiltTime  || Date.now();
        let tiltDelta = ( time - this.lastTiltTime ) / 1000;
        this.lastTiltTime = time;
        const easSpeed = 0.1 * (tiltDelta / 0.016);
        this.currTheta += (this.theta - this.currTheta) * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;
        this.currPhi   += (this.phi   - this.currPhi)     * (this.useCameraRotationEase ? easSpeed : 0.5);//0.2//0.1;
      }

      /* first we reset position to only rotate the camera and get a worldmatrix without the translation */
      this._oldPosition[0] = this.position[0] + this.offset[0] ;
      this._oldPosition[1] = this.position[1] + this.offset[1] ;
      this._oldPosition[2] = this.position[2] + this.offset[2] ;
      this.position[0] = 0;
      this.position[1] = 0;
      this.position[2] = 0;
      this.lookAt[0] = Math.sin(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 ;
      this.lookAt[1] = Math.sin(this.currPhi + (this.extraPhi||0))  * 100 * -1 ;
      this.lookAt[2] = Math.cos(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 ;
      this.updateMatrix();
      /* get the rotation matrix now */ 
      var _matrix = create$7();
      copy$7(_matrix, this.matrix);

      let velocityTowardDir = create$5();
      if (this._moveForward) {
        add$5( velocityTowardDir, velocityTowardDir, [0, 0, -1] );
      }
      if (this._moveBackward) {
        add$5( velocityTowardDir, velocityTowardDir, [0, 0, 1] );
      }
      if (this._moveLeft) {
        add$5( velocityTowardDir, velocityTowardDir, [-1, 0, 0] );
      }
      if (this._moveRight) {
        add$5( velocityTowardDir, velocityTowardDir, [1, 0, 0] );
      }
      normalize$3(velocityTowardDir, velocityTowardDir);
      /* rotate the direction vector to align with camera rotation */ 
      velocityTowardDir = applyMat4(velocityTowardDir, _matrix);
      normalize$3(velocityTowardDir, velocityTowardDir);
      /* now scale it to the required speed */ 
      scale$5(velocityTowardDir, velocityTowardDir, this.moveSpeed * 20 );
      /* then scale to delta for euler integration */ 
      scale$5(velocityTowardDir, velocityTowardDir, delta );
      /* now add it to velocity */ 
      add$5(this._velocity, this._velocity, velocityTowardDir );

      /*  now integrate move position with velocity */
      this.position[0] = this._oldPosition[0] + this._velocity[0] * delta;
      this.position[1] = this._oldPosition[1] + this._velocity[1] * delta;
      this.position[2] = this._oldPosition[2] + this._velocity[2] * delta;

      /* friction/damping */ 
      this._velocity[0] *= 0.9;
      this._velocity[1] *= 0.9;
      this._velocity[2] *= 0.9;

      this.time = time;

      /*  update the lookAt to integrate the new position */
      this.lookAt[0] = Math.sin(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 + this.position[0];
      this.lookAt[1] = Math.sin(this.currPhi + (this.extraPhi||0)) * 100 * -1 + this.position[1];
      this.lookAt[2] = Math.cos(this.currTheta + this.extraTheta) * Math.cos(this.currPhi) * 100 + this.position[2];
      this.updateMatrix();
      this.updateWorldMatrix();

    }
    else {
      super.render(true);
    }

    if (this.frustum) {
      multiply$7(this._projScreenMatrix, this.projectionMatrix, this.inverseWorldMatrix );
      this.frustum && this.frustum.setFromProjectionMatrix( this._projScreenMatrix );
    }

  }

}

class DepthTexture {

  constructor(gl, options) {

    let supportsDepthTexture = gl.getExtension("WEBGL_depth_texture");
    
    if (!supportsDepthTexture) {
      throw("FrameBuffer useDepthTexture:true => Cannot render depth to texture, the browser doesnt support WEBKIT_WEBGL_depth_texture extension")
    }

    options = Object.assign({}, {
      width: 1,
      height: 1,
      type: gl.UNSIGNED_SHORT
    }, options);

    this.gl = gl;
    this.width = options.width;
    this.height = options.height;
    this.type = options.type;

    var floatTextures = gl.getExtension('OES_texture_float');
    gl.getExtension('OES_texture_float_linear');

    if (!floatTextures && this.type == gl.FLOAT) {
        throw('trying to create a DepthTexture of gl.FLOAT type but there\s no floating point texture support');
    }

    this._texture = this.gl.createTexture();
    MemoryManager.trackTexture( this._texture );
    this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.type, null);
    gl.bindTexture( gl.TEXTURE_2D, null);

  }

  bind(unit) {
    if (unit !== void 0) {
      this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
    }
    this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
  }

  delete() {
    this.gl.deleteTexture( this._texture );
    MemoryManager.untrackTexture( this._texture );
    this._texture = null;
    this.gl = null;
  }

  resize(w, h) {
    this.width  = w;
    this.height = h;
    this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
    this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.type, null);
    gl.bindTexture( gl.TEXTURE_2D, null);
  }

}

const extensions = {};

function getType(gl, type) {
  if (extensions['EXT_color_buffer_float'] === void 0) {
    extensions['EXT_color_buffer_float'] = gl.getExtension('EXT_color_buffer_float');
  } 
  if (extensions['OES_texture_float_linear'] === void 0) {
    extensions['OES_texture_float_linear'] = gl.getExtension('OES_texture_float_linear');
  } 
  if (extensions['EXT_color_buffer_float'] === void 0) {
    extensions['EXT_color_buffer_float'] = gl.getExtension('EXT_color_buffer_float');
  } 
  if (extensions['OES_texture_half_float_linear'] === void 0) {
    extensions['OES_texture_half_float_linear'] = gl.getExtension('OES_texture_half_float_linear');
  }   
  if (type === gl.FLOAT) {
    if (!extensions['EXT_color_buffer_float']) { 
      console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
      type = gl.HALF_FLOAT;
    }
  }
  if (type === gl.HALF_FLOAT) {
    if (!extensions['EXT_color_buffer_float']) {
      console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
      type = gl.UNSIGNED_BYTE;
    }
  }
  return type;
}

class FrameBuffer {

  constructor ( gl, options ) {

    this.options = Object.assign({},{
      format:           gl.RGBA,
      type:             gl.UNSIGNED_BYTE,
      linear:           true,
      mipmap:           false,
      mipmapLinear:     false,
      wrapS:            gl.CLAMP_TO_EDGE,
      wrapT:            gl.CLAMP_TO_EDGE,
      depthTexture:     null,
      skipViewport:     false,
      numRenderTargets: 1,
      renderTargets:    [],
      depthOnly:        false,
    }, options);

    this.gl = gl;
 
    this.type             = getType(gl, this.options.type);
    this.skipViewport     = this.options.skipViewport;
    this.width            = this.options.width;
    this.height           = this.options.height;
    this.format           = this.options.format;
    this.linear           = this.options.linear;
    this.mipmap           = this.options.mipmap;
    this.mipmapLinear     = this.options.mipmapLinear;
 
    this.renderTargets = [];
    if ( this.options.numRenderTargets > 1) {
      for (let i=0; i<this.options.numRenderTargets; i++) {
        this.renderTargets.push({
          type: this.type,
        });
      }
    }
    if ( this.options.renderTargets.length > 0) {
      for (let i=0; i<this.options.renderTargets.length; i++) {
        this.renderTargets.push({
          type: getType(gl, this.options.renderTargets[i].type),
        });
      }
    }

    if (this.options.depthOnly) {
      
      this.fbo = gl.createFramebuffer();
      this.fbo.name = this.name;
      MemoryManager.trackFrameBuffer( this.fbo );

      gl.bindFramebuffer(gl.FRAMEBUFFER, this.fbo);

      this.depthTexture = gl.createTexture();
      MemoryManager.trackTexture( this.depthTexture );

      gl.bindTexture(gl.TEXTURE_2D, this.depthTexture);
      
      {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.DEPTH_COMPONENT32F, this.width, this.height, 0, gl.DEPTH_COMPONENT, gl.FLOAT, null);
      }

      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.TEXTURE_2D, this.depthTexture, 0);

      
    }
    else {

      if (this.renderTargets.length > 0) {

        this._textures = [];
        
        for (let i=0; i<this.renderTargets.length; i++) {
        
          const texture = this.gl.createTexture();
          MemoryManager.trackTexture( texture );

          // since we didnt create a beam texture but a webgl texture, there is n ot .bind method on it to be used as uniform
          texture.bind = unit => {
            if (!this.gl) {
              return;
            }
            if (unit !== void 0) {
              this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
            }
            this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
          };
  
          this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
          if (this.renderTargets[i].type == this.gl.FLOAT) {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null);// new Float32Array( new Array(this.width * this.height * 4) ));
          }
          else if (this.renderTargets[i].type == this.gl.HALF_FLOAT) {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
          }
          else {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.renderTargets[i].type, new Uint8Array( new Array(this.width * this.height * 4) ));
          }
          this._textures.push(texture);
        }

      }
      else {
        this._texture = this.gl.createTexture();
        MemoryManager.trackTexture( this._texture );

        this._texture.__is_framebuffer_texture__ = true;


        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
        if (this.type == this.gl.FLOAT) {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, this.gl.RGBA, this.gl.FLOAT, null);// new Float32Array( new Array(this.width * this.height * 4) ));
        }
        else if (this.type == this.gl.HALF_FLOAT) {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
        }
        else {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);//new Uint8Array( new Array(this.width * this.height * 4) ));
        }
      }
  
      
      this.wrapS = this.options.wrapS;
      this.wrapT = this.options.wrapT;
      var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
      if (!isPOT) {
        //not POT textures can't repeat & cant use mipmap
        this.wrapS = gl.CLAMP_TO_EDGE;
        this.wrapT = gl.CLAMP_TO_EDGE;
        this.mipmap       = false;
        this.mipmapLinear = false;
      }
  
      if (this._textures) {
        for (let i=0; i<this._textures.length; i++) {
          this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
          this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS );
          this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT );
        }
      }
      else {
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
        this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.wrapS );
        this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.wrapT );
      }
  
      //nPOT texture cannot mipmap
      this.setFilter( this.linear, this.mipmap, this.mipmapLinear );
  
      if (!this.options.depthTexture) {
        this.renderbuffer = this.gl.createRenderbuffer();
        this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
        {
          this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT32F, this.width, this.height);
        }
      }
      
      this.fbo = this.gl.createFramebuffer();
      MemoryManager.trackFrameBuffer( this.fbo );

      this.gl.bindFramebuffer( this.gl.FRAMEBUFFER, this.fbo );
  
      if (this._textures) {
        const buffers = [];
        for (let i=0; i<this._textures.length; i++) {
          this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT'+i], this.gl.TEXTURE_2D, this._textures[i], 0);
          buffers.push(this.gl['COLOR_ATTACHMENT'+i]);
        }
        // console.log('DRAW_BUFFERS', this.options.name);
        this.gl.drawBuffers( buffers ); 
      }
      else {
        this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
      }
  
      // if (this.options.depthTexture) {
      //   this.depthTexture = this.options.depthTexture._texture;
      //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.options.depthTexture._texture, 0);
      // }
      // else {
      
        this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
      // }

    }

    this.unbind();

  } 

  /**
   * [setFilter description]
   * @param {[type]} linear       [description]
   * @param {[type]} mipmap       [description]
   * @param {[type]} mipmapLinear [description]
   */
  setFilter(linear, mipmap, mipmapLinear) {
    var gl = this.gl;
    var filter = getFilter$1( !!linear, !!mipmap, !!mipmapLinear);

    if (this._textures) {
      for (let i=0; i<this._textures.length; i++) {
        gl.bindTexture(   gl.TEXTURE_2D, this._textures[i]);
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter$1( !!linear, false, false ) );
        gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter );
      }
    }
    else {
      gl.bindTexture(   gl.TEXTURE_2D, this._texture);
      gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter$1( !!linear, false, false ) );
      gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter );
    }
  }

  resize(w, h) {

    if( this.width !== w || this.height !== h ) {
      this.width  = w|0;
      this.height = h|0;
    }

    if (this.options.depthOnly) {
       // Bind the framebuffer and the depth texture
       this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
       this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
       // Resize the depth texture
       {
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT32F, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.FLOAT, null);
       }
       // Re-attach the depth texture to the framebuffer
       this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
    }
    else {

      var isPOT = isPowerOf2(this.width) && isPowerOf2(this.height);
      if (!isPOT) {
        this.wrapS  = this.gl.CLAMP_TO_EDGE;
        this.wrapT  = this.gl.CLAMP_TO_EDGE;
        this.mipmap = false;
        this.mipmapLinear = false;
        this.setFilter( this.linear, this.mipmap, this.mipmapLinear );
      }
      
      if (this._textures) {
        const buffers = [];
        for (let i=0; i<this._textures.length; i++) {
          this.gl.bindTexture(this.gl.TEXTURE_2D, this._textures[i]);
          if (this.type == this.gl.FLOAT) {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, ( this.format),  (this.type), null);
          }
          else if (this.type == this.gl.HALF_FLOAT) {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
          }
          else {
            this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
          }
          this.gl.bindFramebuffer( this.gl.FRAMEBUFFER, this.fbo );
          this.gl.framebufferTexture2D(this.gl.DRAW_FRAMEBUFFER, this.gl['COLOR_ATTACHMENT'+i], this.gl.TEXTURE_2D, this._textures[i], 0);
           buffers.push(this.gl['COLOR_ATTACHMENT'+i]);
        }
        this.gl.drawBuffers( buffers ); 
      }
      else {
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
        if (this.type == this.gl.FLOAT) {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA32F, this.width, this.height, 0, ( this.format),  (this.type), null);
        }
        else if (this.type == this.gl.HALF_FLOAT) {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA16F, this.width, this.height, 0, this.gl.RGBA, this.gl.HALF_FLOAT, null);
        }
        else {
          this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA, this.width, this.height, 0, this.gl.RGBA, this.type, null);
        }
        this.gl.bindFramebuffer( this.gl.FRAMEBUFFER, this.fbo );
        this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.COLOR_ATTACHMENT0, this.gl.TEXTURE_2D, this._texture, 0);
      }
      
      // if (this.options.depthTexture) {
      //   this.depthTexture.resize(this.width, this.height);
      //   // this.gl.bindTexture(this.gl.TEXTURE_2D, this._depthTexture);
      //   // this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.DEPTH_COMPONENT, this.width, this.height, 0, this.gl.DEPTH_COMPONENT, this.gl.UNSIGNED_SHORT, null);
      // }
  
      // if (this.options.depthTexture) {
      //   this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture._texture, 0);
      // }
      // else {
        this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
        {
          this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT32F, this.width, this.height);
        }
        this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
      // }
    }

    
    
    this.unbind();
  }


  bindFrame(bindOnly) {

    if (bindOnly) {
      this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
      return;
    }
    if (!this.skipViewport) {
      this.gl.viewport( 0, 0, this.width, this.height );
    }
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, this.fbo);
    if (this.options.depthOnly) {
      this.gl.bindTexture(this.gl.TEXTURE_2D, this.depthTexture);
      this.gl.framebufferTexture2D(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.TEXTURE_2D, this.depthTexture, 0);
      this.gl.drawBuffers([this.gl.NONE]);
      this.gl.readBuffer(this.gl.NONE);
    }
    else {
      if (!this.options.depthTexture) {
        this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
      }
      else {
        this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, this.renderbuffer);
        {
          this.gl.renderbufferStorage(this.gl.RENDERBUFFER, this.gl.DEPTH_COMPONENT32F, this.width, this.height);
        }
        this.gl.framebufferRenderbuffer(this.gl.FRAMEBUFFER, this.gl.DEPTH_ATTACHMENT, this.gl.RENDERBUFFER, this.renderbuffer);
      }
      this.clear();
    }
  }
  
  bind(unit) {
    this.gl.activeTexture(this.gl.TEXTURE0 + (0 | unit));
    this.gl.bindTexture(this.gl.TEXTURE_2D, this.options.depthOnly ? this.depthTexture : this._texture);
  }

  unbind() {
    this.gl.bindTexture(this.gl.TEXTURE_2D, null);
    this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, null);
    if (!this.options.depthTexture) {
      this.gl.bindRenderbuffer(this.gl.RENDERBUFFER, null);
    }
  }

  clear(color, depth, stencil) {
    // if (this.options.depthOnly) {
    //   this.gl.clear( this.gl.DEPTH_BUFFER_BIT );
    // }
    // else {
      var bits = 0;
      if ( color === void 0 || color ) bits |= this.gl.COLOR_BUFFER_BIT;
      if ( depth === void 0 || depth ) bits |= this.gl.DEPTH_BUFFER_BIT;
      if ( stencil === void 0 || stencil ) bits |= this.gl.STENCIL_BUFFER_BIT;
      this.gl.clear( bits );
    // }
  }

  dispose() {
    MemoryManager.untrackFrameBuffer( this.fbo );
    this.gl.deleteFramebuffer( this.fbo );
    this.fbo   = null;
    this.gl    = null;
  }

}

var particleVertexShader = "\nattribute vec2 uv;\nattribute vec3 color;\nattribute vec3 position;\nattribute float vertexIndex;\nattribute float particleIndex;\n\n\nuniform mat4 uMVMatrix;\nuniform mat4 uPMatrix;\n// uniform float pointSize;\n\nvarying vec2 vUv;\n\nvoid main() {\n\nvUv = uv;\n\nvec3 newPosition = position;\n\nif (vertexIndex == 0.0) {\nnewPosition += vec3(-1.,1.,0.);\n}\nelse if (vertexIndex == 1.0) {\nnewPosition += vec3(1.,1.,0.);\n}\nelse if (vertexIndex == 2.0) {\nnewPosition += vec3(-1.,-1.,0.);\n}\nelse if (vertexIndex == 3.0) {\nnewPosition += vec3(1.,-1.,0.);\n}\n\nnewPosition *= 10.;\n\ngl_Position = uPMatrix * uMVMatrix * vec4( newPosition, 1.0 );\n\n}"; // eslint-disable-line

var particleFragmentShader = "precision highp float;\n\n\nvarying vec2 vUv;\n\nvoid main(void) {\n\nvec4 outColor = vec4(1., 0., 0., 1.0);\ngl_FragColor = outColor;\n\n}"; // eslint-disable-line

class ParticleSystem extends Mesh {

	constructor(gl, options) {

		super();

		this.gl = gl;

		options = Object.assign({}, {
			width:  10,
			height: 10,
			depth: 10,
			map: null,
			count: 100
		}, options);

		this.count  = options.count;
		this.width  = options.width;
		this.heigth = options.heigth;
		this.depth  = options.depth;

		this.material  = new Material(this.gl, {
			blend: true,
			map: options.map,
			vertexShader: particleVertexShader,
			fragmentShader: particleFragmentShader,
		});

		// this.material.map = this.texture;


		this.indices  = [];
		this.vertices = [];
		this.normals  = [];
		this.colors   = [];
		this.uvs      = [];
        this.vertexIndices = [];
        this.particleIndices = [];
    

        var index = 0;
        var particleIndex = 0;
       
        for ( var i = 0, l = this.count; i<l; i++) {

            this.vertices.push( Math.random() * this.width - (this.width/2) );
            this.vertices.push( Math.random() * this.heigth - (this.heigth/2) );
            this.vertices.push( Math.random() * this.depth - (this.depth/2) );

            this.normals.push(0);
            this.normals.push(1);
            this.normals.push(1);

            this.colors.push(1);
            this.colors.push(1);
            this.colors.push(1);

            this.vertexIndices.push(index);

            this.particleIndices.push(particleIndex);

            index++;
            if(index > 3){
                index = 0;
                particleIndex++;
            }

        }

        for (let n=0;n<this.count;n+=4) {

            this.indices.push(n+0);
            this.indices.push(n+2);
            this.indices.push(n+1);
            this.indices.push(n+2);
            this.indices.push(n+3);
            this.indices.push(n+1);

            this.uvs.push(0);
            this.uvs.push(1);
            this.uvs.push(1);
            this.uvs.push(1);
            this.uvs.push(0);
            this.uvs.push(0);
            this.uvs.push(1);
            this.uvs.push(0);
        }

		this.geometry = new GeometryBuffer(this.gl, this.count);

		this.geometry.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		this.geometry.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		this.geometry.addAttribute( 'color',    new Float32Array( this.colors   ), 3 );
		this.geometry.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		this.geometry.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2,'ParticleSystem' );
		this.geometry.addAttribute( 'particleIndex',       new Float32Array( this.particleIndices ), 1 );
		this.geometry.addAttribute( 'vertexIndex',       new Float32Array( this.vertexIndices      ), 1 );

        this.geometry.length = this.vertexIndices.length;
        

    }

    
}

class Light extends Object3d {

	constructor(options={}) {

		options = Object.assign({},{
			type:                'spotlight',// || arealight [TODO: pointlight && directionalLight]
			size:                1,
			color:               [1,1,1],
			direction:           [-1,-1,0],
			position:            [1,1,1],
			intensity:           1,
			near:                1,
			distance:            100,
			decay:               2,//new default to 2 for inverse square law
			angle:               Math.PI/4,
			exponent:            1,
			castShadow:          false,
			penumbra:            0,
			// lookAt:              vec3.create(),
			shadowMap:           true,
			useShadows:          true,
			shadowMapResolution: 256,
			
			width:  0,
			height: 0,
			
			left:   1000,
			right:  1000,
			top:    1000,
			bottom: 1000,

			shadowCamera: null,

			temperature: -1,
			useTemperature: false,

			/** 
			 * maxCameraAngle:
			 * avoid using too large angle for shadow map to avoid perspective aliasing
			 * (very low precision on object near the light)
			 */
			maxCameraAngle: 0.9 * Math.PI/2,

			shadowMode: 'linear', // sharp | linear | pcf | pcss
			 
		}, options);

		super(options);

		
		this.__is_light__ = true;


		this.shadowMode      = options.shadowMode;
		this.useShadows 	 = options.useShadows;
		
		this.static          = true;//dont re-update light after first call
		this.maxCameraAngle  = options.maxCameraAngle;
		this.type            = options.type;
		this.size            = 1;
		this.color           = options.color;
		this.intensity       = options.intensity;
		this.position        = options.position;
		this.distance        = options.distance;
		this.decay           = options.decay;
		this.angle           = options.angle;
		this.exponent        = options.exponent;
		this.penumbra        = options.penumbra;
		this.castShadow      = options.castShadow;
		this.left            = options.left; 
		this.right           = options.right; 
		this.top             = options.top; 
		this.bottom          = options.bottom; 
		this.near            = options.near ;
		this.width           = options.width;
		this.height          = options.height;
		this.useTemperature  = options.useTemperature;
		this.temperature     = options.temperature;

		if (options.lookAt) {
			this.lookAt      = options.lookAt;
		}

		if (options.shadowMap || this.castShadow) {

			this.shadowMapResolution = options.shadowMapResolution;
			this.shadowMap           = true;
			// this._cachedAngle        = this.angle;
			// this._cachedDistance     = this.distance

			const cameraOption = {
				near:         options?.shadowCamera?.near || this.near,
				far:          options?.shadowCamera?.far  || this.distance,
				type:         options?.shadowCamera?.type || (this.type == 'directionallight' ? 'orthographic' : 'perspective'),
				orbitControl: false,
				firstPerson:  false,
			};
			
			if (cameraOption.type === 'perspective') {
				cameraOption.fov     = ( 2 * Math.min(this.maxCameraAngle, this.angle) ) * 180 / Math.PI;
				cameraOption.aspect  = 1;
				cameraOption.frustum = true;
			}

			if (cameraOption.type === 'orthographic') {
				cameraOption.left    = options?.shadowCamera?.left   || this.left;
				cameraOption.right   = options?.shadowCamera?.right  || this.right;
				cameraOption.top     = options?.shadowCamera?.top    || this.top;
				cameraOption.bottom  = options?.shadowCamera?.bottom || this.bottom;
				cameraOption.frustum = false;
			}
			
			this.shadowMapCamera = new Camera(cameraOption);

			if (this.lookAt) {
				this.shadowMapCamera.lookAt = create$5();
				copy$5(this.shadowMapCamera.lookAt, this.lookAt);
			}

			// // CENTER CAMERA
			// if (this.type != 'directionallight') {
			// 	this.shadowMapCenterCamera = new Camera({
			// 		near:         1,
			// 		far:          1500,
			// 		type:         'perspective',
			// 		fov:          ( 2 * Math.PI/2 * 0.6 ) * 180 / Math.PI,
			// 		aspect:       1,
			// 		orbitControl: false,
			// 		firstPerson:  false,
			// 		frustum:      true,
			// 	});
			// 	if (this.lookAt) {
			// 		this.shadowMapCenterCamera.lookAt = vec3.create()
			// 		vec3.copy(this.shadowMapCenterCamera.lookAt, this.lookAt);
			// 	}
			// }
		}

	}

	update() {

		// stats.updateLights = stats.updateLights || 0;
		// stats.updateLights++;
		// if (!this.static || !this.hasUpdatedOnce) {
			// this.updateMatrix();
			// this.updateWorldMatrix();
		// }

		this.render();

		if (this.shadowMap) {
				
			// if (this._cachedAngle !== this.angle) {
				// this._cachedAngle = this.angle;
				this.shadowMapCamera.fov =  ( 2 * Math.min(this.maxCameraAngle, this.angle) ) * 180 / Math.PI;
				this.shadowMapCamera.updateProjectionMatrix();
				// if (this.shadowMapCenterCamera) {
				// 	this.shadowMapCenterCamera.updateProjectionMatrix()
				// }
			// }
			// if (this._cachedDistance !== this.distance) {
				// this._cachedDistance = this.distance;
				// this.shadowMapCamera.far       = this.distance;
				// this.shadowMapCamera.left =    -this.distance/3;
				// this.shadowMapCamera.right =   this.distance/3;
				// this.shadowMapCamera.top =     this.distance/3;
				// this.shadowMapCamera.bottom =     -this.distance/2;
				// this.shadowMapCamera.updateProjectionMatrix()
				// if (this.shadowMapCenterCamera) {
				// 	this.shadowMapCenterCamera.far = this.distance;
				// 	this.shadowMapCenterCamera.updateProjectionMatrix()
				// }
			// }
			
			//TODO: make the camera a child of the light object
			//      instead of copy all props
			this.shadowMapCamera.position[0] = this.worldMatrix[12];
			this.shadowMapCamera.position[1] = this.worldMatrix[13];
			this.shadowMapCamera.position[2] = this.worldMatrix[14];

			// if (this.type != 'directionallight') {
			this.shadowMapCamera.rotation[0] = this.rotation[0];
			this.shadowMapCamera.rotation[1] = this.rotation[1];
			this.shadowMapCamera.rotation[2] = this.rotation[2];
			// }
			
			if (this.lookAt) {
				// this.shadowMapCamera.lookAt = this.shadowMapCamera.lookAt || vec3.create()
				set$5(this.shadowMapCamera.lookAt, this.lookAt[0], this.lookAt[1], this.lookAt[2]);
			}
			
			// if (!this.static || !this.hasUpdatedOnce) {
				this.shadowMapCamera.update();
				this.shadowMapCamera.updateMatrix();
				this.shadowMapCamera.updateWorldMatrix();
			// }

			// if (this.shadowMapCenterCamera) {
			// 	this.shadowMapCenterCamera.position[0] = this.worldMatrix[12];
			// 	this.shadowMapCenterCamera.position[1] = this.worldMatrix[13];
			// 	this.shadowMapCenterCamera.position[2] = this.worldMatrix[14];
			// 	if (this.type != 'directionallight') {
			// 		this.shadowMapCenterCamera.rotation[0] = this.rotation[0];
			// 		this.shadowMapCenterCamera.rotation[1] = this.rotation[1];
			// 		this.shadowMapCenterCamera.rotation[2] = this.rotation[2];
			// 	}
			// 	if (!this.static || !this.hasUpdatedOnce) {
			// 		this.shadowMapCenterCamera.update()
			// 		this.shadowMapCenterCamera.updateMatrix()
			// 		this.shadowMapCenterCamera.updateWorldMatrix()
			// 	}
			// }

			this.hasUpdatedOnce = true;

			// stats.updateShadowCameras = stats.updateShadowCameras || 0;
			// stats.updateShadowCameras++;
		
		}

	}


}

class AmbientLight extends Light {
    constructor(options={}) {
        
        options.type = 'ambientlight';
        
        options = Object.assign({},{
			color:           [1,1,1],
			intensity:       1,
			temperature:     -1,
			useTemperature: false,
		}, options);

        super(options);
 
		this.__is_light__ = true;
 
		this.type            = options.type;
 
		this.color           = options.color;
		this.intensity       = options.intensity;
 
		this.useTemperature  = options.useTemperature;
		this.temperature     = options.temperature;
        
    }
}

class RectLight extends Light {
    constructor(options={}) {
        options.type = 'rectlight';
        super(options);
    }
}

class SpotLight extends Light {
    constructor(options={}) {
        options.type = 'spotlight';
        super(options);
    }
}

class DirectionalLight extends Light {
    constructor(options={}) {
        options.type = 'directionallight';
        super(options);
    }
}

class PointLight extends Light {
    constructor(options={}) {
        options.type = 'pointlight';
        super(options);
    }
}

const LIGHT_TYPES = {
	'spotlight':        0,
	'rectlight':        1,
	'directionallight': 2,
	'pointlight':       3,
	'ambientlight':     4,
};
const SHADOW_MODES = {
    'sharp':   0,
    'linear':  1,
    'pcf':     2,
    'pcss':    3,
};
 


class Scene extends Container {
 
	constructor(options={}) {
		super();
		this.defines          = {};
		this.lights           = [];
        this.ambientLights    = [];
		this.reflectors       = [];
		this.overrideMaterial = null;
		this.overrides        = {};
        this.uniforms         = {};
		this.inverseViewProjectionMatrix = create$7();
        this.lightInvVPMatrix            = create$7();
		this.viewProjectionwMatrix       = create$7();
		this.cameraDirection             = create$5();
        this.cameraPosition              = create$5();
        this.lastViewProjectionMatrix    = create$7();
        this.lastInvViewProjectionMatrix = create$7();
        this.autoUpdateCameraUniforms = options.autoUpdateCameraUniforms ? options.autoUpdateCameraUniforms : false;
	}

	add(obj) {
        if (obj instanceof Light) {
            this.lights.push(obj);
            super.add(obj);
        }
        else {
            super.add(obj);
        }
	}

    
	updateLights() {
        
        this.ambientLights     = this.lights.filter(l => l instanceof AmbientLight);
        this.rectLights        = this.lights.filter(l => l instanceof RectLight);
        this.spotLights        = this.lights.filter(l => l instanceof SpotLight);
        this.directionalLights = this.lights.filter(l => l instanceof DirectionalLight);
        this.pointLights       = this.lights.filter(l => l instanceof PointLight);
        
        this.shadowMaps = [];

        // Rect Area LIGHTS
        if (this?.rectLights) {
            let lightInvVPMatrix         = [];
            let lightCastShadow         = [];
            let lightPMatrix             = [];
            let lightMMatrix             = [];
            let lightPMMatrix            = [];
            let lightColor               = [];
            let lightDistance            = [];
            let lightPosition            = [];
            let lightAngleCos            = [];
            let lightTempertures         = [];
            let lightUseTemperture       = [];
            let lightDirections          = [];
            let ligthRotation            = [];
            let lightType                = [];
            let lightHalfHeight          = [];
            let lightHalfWidth           = [];
            let lightShadowMapResolution = [];
            let lightShadowCameraType    = [];
            let lightShadowMode          = [];
            let lightSize                = [];
            for (var i = 0; i < this.rectLights.length; i++) {
                const currL = this.rectLights[i];
                currL.static = false;
                currL.update();
                let d = create$5();
                set$5(d, 0,0, -1);
                transformMat4$2( d, d, currL._normalMatrix );
                normalize$3( d, d );
                lightDirections.push( d[0], d[1], d[2] );
                /* UPDATING LIGHT UNifORMS */  
                lightMMatrix.push.apply(lightMMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMatrix.push.apply(lightPMatrix, currL.shadowMapCamera.projectionMatrix);    
                let lmp = create$7();
                multiply$7(lmp, currL.shadowMapCamera.projectionMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMMatrix.push.apply(lightPMMatrix, lmp);
                copy$7(this.lightInvVPMatrix, currL.shadowMapCamera.projectionMatrix);
                multiply$7(this.lightInvVPMatrix, this.lightInvVPMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                invert$4(this.lightInvVPMatrix, this.lightInvVPMatrix);
                lightInvVPMatrix.push.apply(lightInvVPMatrix, this.lightInvVPMatrix);
                lightShadowMapResolution.push( currL.shadowMapResolution );
                ligthRotation.push.apply(ligthRotation, currL._normalMatrix);
                lightPosition.push( currL.worldMatrix[12],  currL.worldMatrix[13],  currL.worldMatrix[14] );
                lightAngleCos.push( Math.cos( currL.angle ) );
                lightTempertures.push( currL.temperature );
                lightUseTemperture.push( currL.useTemperature ? 1 : 0 );
                lightColor.push.apply(lightColor,[ 
                    currL.color[0] * currL.intensity, 
                    currL.color[1] * currL.intensity, 
                    currL.color[2] * currL.intensity  
                ]);
                lightDistance.push(currL.distance);
                lightType.push( LIGHT_TYPES[currL.type.toLowerCase()]   );
                lightShadowCameraType.push( 
                    !currL.shadowMapCamera 
                        ? -1 
                        : (currL.shadowMapCamera.type == 'perspective' ? 1 : 0)  
                );
                lightShadowMode.push( SHADOW_MODES[ currL.shadowMode ]  );
                lightSize.push.apply( lightSize, [currL.width, currL.height] );
                //compute 4 points position in world space for each rect area light
                let halfWidth = create$5();
                let halfHeight = create$5();
                set$5( 
                    halfWidth,  
                    currL.width * 0.5, 
                    0.0,
                    0.0 
                );
                set$5(
                    halfHeight, 
                    0.0,
                    currL.height * 0.5, 
                    0.0
                );
                let matrix4 = create$7();
                let q = create$3();
                copy$7( matrix4, currL.worldMatrix );
                getRotation(q, matrix4); 
                transformQuat$1( halfWidth, halfWidth, q );
                transformQuat$1( halfHeight, halfHeight, q );
                lightHalfWidth.push.apply( lightHalfWidth, halfWidth );
                lightHalfHeight.push.apply( lightHalfHeight, halfHeight );
                lightCastShadow.push( currL.castShadow ? 1 : 0 );
            }
            if (this.rectLights.length > 0) {
                this.uniforms.rectLightType             = lightType;
                this.uniforms.rectLightColor            = lightColor;
                this.uniforms.rectLightDistance         = lightDistance;
                this.uniforms.rectLightPosition         = lightPosition;
                this.uniforms.rectLightDirection        = lightDirections;
                this.uniforms.rectLightAngleCos         = lightAngleCos;
                this.uniforms.rectLightRotation         = ligthRotation;
                this.uniforms.rectLightPMMatrix         = lightPMMatrix;
                this.uniforms.rectLightMMatrix          = lightMMatrix;
                this.uniforms.rectLightCastShadow      = lightCastShadow;
                this.uniforms.rectLightTemperture       = lightTempertures;
                this.uniforms.rectLightUseTemperture    = lightUseTemperture;
                this.uniforms.rectLightHalfWidth        = lightHalfWidth;
                this.uniforms.rectLightHalfHeight       = lightHalfHeight;
                this.uniforms.rectLightShadowCameraType = lightShadowCameraType;
                this.uniforms.rectLightShadowMode       = lightShadowMode;
                this.uniforms.rectLightSize             = lightSize;
                
                this.defines.NUM_RECT_LIGHTS       = this.rectLights.length;
            
            }
            else {
                delete this.defines.NUM_RECT_LIGHTS ;
            }

        }

        if (this.spotLights) {
            const lightInvVPMatrix         = [];
            const lightCastShadow          = [];
            const lightPMatrix             = [];
            const lightMMatrix             = [];
            const lightPMMatrix            = [];
            const lightColor               = [];
            const lightDistance            = [];
            const lightPosition            = [];
            const lightAngleCos            = [];
            const lightTempertures         = [];
            const lightUseTemperture       = [];
            const lightDirections          = [];
            const ligthRotation            = [];
            const lightType                = [];
            const lightShadowMapResolution = [];
            const lightShadowCameraType    = [];
            const lightShadowMode          = [];
            const lightSize                = [];
            const lightDecay                = [];
            for (var i = 0; i < this.spotLights.length; i++) {
                const currL = this.spotLights[i];
                currL.static = false;
                currL.update();
                let d = create$5();
                set$5(d, 0,0, -1);
                transformMat4$2( d, d, currL._normalMatrix );
                normalize$3( d, d );
                lightDirections.push( d[0], d[1], d[2] );
                /* UPDATING LIGHT UNifORMS */  
                lightMMatrix.push.apply(lightMMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMatrix.push.apply(lightPMatrix, currL.shadowMapCamera.projectionMatrix);    
                let lmp = create$7();
                multiply$7(lmp, currL.shadowMapCamera.projectionMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMMatrix.push.apply(lightPMMatrix, lmp);
                copy$7(this.lightInvVPMatrix, currL.shadowMapCamera.projectionMatrix);
                multiply$7(this.lightInvVPMatrix, this.lightInvVPMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                invert$4(this.lightInvVPMatrix, this.lightInvVPMatrix);
                lightInvVPMatrix.push.apply(lightInvVPMatrix, this.lightInvVPMatrix);
                lightShadowMapResolution.push( currL.shadowMapResolution );
                ligthRotation.push.apply(ligthRotation, currL._normalMatrix);
                lightPosition.push( currL.worldMatrix[12],  currL.worldMatrix[13],  currL.worldMatrix[14] );
                lightAngleCos.push( Math.cos( currL.angle ) );
                lightTempertures.push( currL.temperature );
                lightUseTemperture.push( currL.useTemperature ? 1 : 0 );
                lightColor.push.apply(lightColor,[ 
                    currL.color[0] * currL.intensity, 
                    currL.color[1] * currL.intensity, 
                    currL.color[2] * currL.intensity  
                ]);
                lightDistance.push(currL.distance);
                lightType.push( LIGHT_TYPES[currL.type.toLowerCase()]   );
                lightShadowCameraType.push( 
                    !currL.shadowMapCamera 
                        ? -1 
                        : (currL.shadowMapCamera.type == 'perspective' ? 1 : 0)  
                );
                lightShadowMode.push( SHADOW_MODES[ currL.shadowMode ]  );
                lightSize.push.apply( lightSize, [currL.width, currL.height] );
                lightCastShadow.push( currL.castShadow ? 1 : 0 );
                lightDecay.push( currL.decay  );
            }
            if (this.spotLights.length > 0) {
                this.uniforms.spotLightType             = lightType;
                this.uniforms.spotLightColor            = lightColor;
                this.uniforms.spotLightDistance         = lightDistance;
                this.uniforms.spotLightPosition         = lightPosition;
                this.uniforms.spotLightDirection        = lightDirections;
                this.uniforms.spotLightAngleCos         = lightAngleCos;
                this.uniforms.spotLigthRotation         = ligthRotation;
                this.uniforms.spotLightPMMatrix         = lightPMMatrix;
                this.uniforms.spotLightMMatrix          = lightMMatrix;
                this.uniforms.spotLightTemperture       = lightTempertures;
                this.uniforms.spotLightUseTemperture    = lightUseTemperture;
                this.uniforms.spotLightShadowCameraType = lightShadowCameraType;
                this.uniforms.spotLightShadowMode       = lightShadowMode;
                this.uniforms.spotLightSize             = lightSize;
                this.uniforms.spotLightCastShadow       = lightCastShadow;
                this.uniforms.spotLightDecay            = lightDecay;
                this.defines.NUM_SPOT_LIGHTS            = this.spotLights.length;
            }
            else {
                delete this.defines.NUM_SPOT_LIGHTS ;
            }
        }


        if (this.pointLights) {
            const lightColor               = [];
            const lightDistance            = [];
            const lightPosition            = [];
            const lightTempertures         = [];
            const lightUseTemperture       = [];
            const lightType                = [];
            const lightSize                = [];
            const lightDecay               = [];
            for (var i = 0; i < this.pointLights.length; i++) {
                const currL = this.pointLights[i];
                currL.static = false;
                currL.update();
                lightPosition.push( currL.worldMatrix[12],  currL.worldMatrix[13],  currL.worldMatrix[14] );
                lightTempertures.push( currL.temperature );
                lightUseTemperture.push( currL.useTemperature ? 1 : 0 );
                lightColor.push.apply(lightColor,[ 
                    currL.color[0] * currL.intensity, 
                    currL.color[1] * currL.intensity, 
                    currL.color[2] * currL.intensity  
                ]);
                lightDistance.push(currL.distance);
                lightType.push( LIGHT_TYPES[currL.type.toLowerCase()]   );
                lightSize.push.apply( lightSize, [currL.width, currL.height] );
                lightDecay.push(currL.decay);
            }
            if (this.pointLights.length > 0) {
                this.uniforms.pointLightType          = lightType;
                this.uniforms.pointLightColor         = lightColor;
                this.uniforms.pointLightDistance      = lightDistance;
                this.uniforms.pointLightPosition      = lightPosition;
                this.uniforms.pointLightTemperture    = lightTempertures;
                this.uniforms.pointLightUseTemperture = lightUseTemperture;
                this.uniforms.pointLightDecay         = lightDecay;
                this.defines.NUM_POINT_LIGHTS         = this.pointLights.length;
            }
            else {
                delete this.defines.NUM_POINT_LIGHTS ;
            }
        }


        // DIRECT LIGHTS
        if (this.directionalLights) {
            const lightInvVPMatrix         = [];
            const lightCastShadow         = [];
            const lightPMatrix             = [];
            const lightMMatrix             = [];
            const lightPMMatrix            = [];
            const lightColor               = [];
            const lightDistance            = [];
            const lightPosition            = [];
            const lightAngleCos            = [];
            const lightTempertures         = [];
            const lightUseTemperture       = [];
            const lightDirections          = [];
            const ligthRotation            = [];
            const lightType                = [];
            const lightShadowMapResolution = [];
            const lightShadowCameraType    = [];
            const lightShadowMode          = [];
            const lightSize                = [];
            for (var i = 0; i < this.directionalLights.length; i++) {
                const currL = this.directionalLights[i];
                currL.static = false;
                currL.update();
                let d = create$5();
                set$5(d, 0,0, -1);
                transformMat4$2( d, d, currL._normalMatrix );
                normalize$3( d, d );
                lightDirections.push( d[0], d[1], d[2] );
                /* UPDATING LIGHT UNifORMS */  
                lightMMatrix.push.apply(lightMMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMatrix.push.apply(lightPMatrix, currL.shadowMapCamera.projectionMatrix);    
                let lmp = create$7();
                multiply$7(lmp, currL.shadowMapCamera.projectionMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                lightPMMatrix.push.apply(lightPMMatrix, lmp);
                copy$7(this.lightInvVPMatrix, currL.shadowMapCamera.projectionMatrix);
                multiply$7(this.lightInvVPMatrix, this.lightInvVPMatrix, currL.shadowMapCamera.inverseWorldMatrix);
                invert$4(this.lightInvVPMatrix, this.lightInvVPMatrix);
                lightInvVPMatrix.push.apply(lightInvVPMatrix, this.lightInvVPMatrix);
                lightShadowMapResolution.push( currL.shadowMapResolution );
                ligthRotation.push.apply(ligthRotation, currL._normalMatrix);
                lightPosition.push( currL.worldMatrix[12],  currL.worldMatrix[13],  currL.worldMatrix[14] );
                lightAngleCos.push( Math.cos( currL.angle ) );
                lightTempertures.push( currL.temperature );
                lightUseTemperture.push( currL.useTemperature ? 1 : 0 );
                lightColor.push.apply(lightColor,[ 
                    currL.color[0] * currL.intensity, 
                    currL.color[1] * currL.intensity, 
                    currL.color[2] * currL.intensity  
                ]);
                lightDistance.push(currL.distance);
                lightType.push( LIGHT_TYPES[currL.type.toLowerCase()]   );
                lightShadowCameraType.push( 
                    !currL.shadowMapCamera 
                        ? -1 
                        : (currL.shadowMapCamera.type == 'perspective' ? 1 : 0)  
                );
                lightShadowMode.push( SHADOW_MODES[ currL.shadowMode ]  );
                lightSize.push.apply( lightSize, [currL.width, currL.height] );
                lightCastShadow.push( currL.castShadow ? 1 : 0 );
            }
            if (this.directionalLights.length > 0) {
                this.uniforms.directionalLightType             = lightType;
                this.uniforms.directionalLightColor            = lightColor;
                this.uniforms.directionalLightDistance         = lightDistance;
                this.uniforms.directionalLightPosition         = lightPosition;
                this.uniforms.directionalLightDirection        = lightDirections;
                this.uniforms.directionalLightAngleCos         = lightAngleCos;
                this.uniforms.directionalLigthRotation         = ligthRotation;
                this.uniforms.directionalLightPMMatrix         = lightPMMatrix;
                this.uniforms.directionalLightMMatrix          = lightMMatrix;
                this.uniforms.directionalLightCastShadow      = lightCastShadow;
                this.uniforms.directionalLightTemperture       = lightTempertures;
                this.uniforms.directionalLightUseTemperture    = lightUseTemperture;
                this.uniforms.directionalLightShadowCameraType = lightShadowCameraType;
                this.uniforms.directionalLightShadowMode       = lightShadowMode;
                this.uniforms.directionalLightSize             = lightSize;
                this.defines.NUM_DIRECTIONAL_LIGHTS            = this.directionalLights.length;
            }
            else {
                delete this.defines.NUM_DIRECTIONAL_LIGHTS ;
            }
        }

        // AMBIENT LIGHTS
        const ambientLightColor = [];
        if (this?.ambientLights) {
            for (var i = 0; i < this.ambientLights.length; i++) {
                const currL = this.ambientLights[i];
                ambientLightColor.push( ...(currL.color.map(c => c * currL.intensity)) );
            }
        }
        if (this.ambientLights.length > 0) {
            this.defines.NUM_AMBIENT_LIGHTS = this.ambientLights.length;
            this.uniforms.ambientLightColor = ambientLightColor;
        }
        else {
            delete this.defines.NUM_AMBIENT_LIGHTS ;
        }

	}

    updateCameraUniforms(camera) {
        
        set$5(this.cameraPosition, camera.worldMatrix[12], camera.worldMatrix[13], camera.worldMatrix[14]);
        if (camera.lookAt) {
            copy$5(this.cameraDirection, camera.lookAt);
            subtract$4(this.cameraDirection, this.cameraDirection, this.cameraPosition);
            normalize$3(this.cameraDirection, this.cameraDirection);
        }
        else if (camera.forwardVector) {
            copy$5(this.cameraDirection, camera.forwardVector);
        }
        copy$7(this.viewProjectionwMatrix, camera.projectionMatrix);
        multiply$7(this.viewProjectionwMatrix, this.viewProjectionwMatrix, camera.inverseWorldMatrix );
        invert$4(this.inverseViewProjectionMatrix, this.viewProjectionwMatrix);

        this.uniforms.uInverseViewProjectionMatrix = this.inverseViewProjectionMatrix;
        this.uniforms.uProjViewMatrix              = this.viewProjectionwMatrix;
        this.uniforms.uCameraPosition              = this.cameraPosition;
        this.uniforms.uEyePosition                 = this.cameraPosition;
        this.uniforms.uEyeDirection                = this.cameraDirection;
        this.uniforms.uInverseViewMatrix           = this.uniforms.uInverseViewMatrix       || create$7();
        this.uniforms.uViewMatrix                  = camera.inverseWorldMatrix;
        this.uniforms.uProjectionMatrix            = camera.projectionMatrix;
        this.uniforms.uInverseProjectionMatrix     = this.uniforms.uInverseProjectionMatrix || create$7();

        copy$7(this.uniforms.uInverseViewMatrix, camera.inverseWorldMatrix);
        invert$4(this.uniforms.uInverseViewMatrix, this.uniforms.uInverseViewMatrix);
        invert$4(this.uniforms.uInverseProjectionMatrix, camera.projectionMatrix);
        
        this.uniforms.uCameraNear = camera.near;
        this.uniforms.uCameraFar  = camera.far;
    }

    setCamera(camera) {
        this.camera = camera; 
    }

	render(camera) {

        this.updateLights(); 

        // We need to tell the scene thatw e want to update global camera uniforms using given camera
        // TODO: should really the scene mange this ?...
        // TODO2: use different scene for buffer scene render so we use the correct camera
        if (this.autoUpdateCameraUniforms && camera) {
            this.updateCameraUniforms(camera);
        }

		super.render(camera, this);
    }
	
}

function setUniform(uniforms, u, value) {
    if(uniforms[u]) uniforms[u].value = value;
}

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 2x2 Matrix
 * @module mat2
 */

/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */
function create$1() {
  let out = new ARRAY_TYPE(4);
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}

/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {mat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */
function clone$1(a) {
  let out = new ARRAY_TYPE(4);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function copy$1(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  return out;
}

/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */
function identity$1(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}

/**
 * Create a new mat2 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out A new 2x2 matrix
 */
function fromValues$1(m00, m01, m10, m11) {
  let out = new ARRAY_TYPE(4);
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}

/**
 * Set the components of a mat2 to the given values
 *
 * @param {mat2} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out
 */
function set$1(out, m00, m01, m10, m11) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m10;
  out[3] = m11;
  return out;
}

/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache
  // some values
  if (out === a) {
    let a1 = a[1];
    out[1] = a[2];
    out[2] = a1;
  } else {
    out[0] = a[0];
    out[1] = a[2];
    out[2] = a[1];
    out[3] = a[3];
  }

  return out;
}

/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function invert$1(out, a) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];

  // Calculate the determinant
  let det = a0 * a3 - a2 * a1;

  if (!det) {
    return null;
  }
  det = 1.0 / det;

  out[0] =  a3 * det;
  out[1] = -a1 * det;
  out[2] = -a2 * det;
  out[3] =  a0 * det;

  return out;
}

/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
function adjoint(out, a) {
  // Caching this value is nessecary if out == a
  let a0 = a[0];
  out[0] =  a[3];
  out[1] = -a[1];
  out[2] = -a[2];
  out[3] =  a0;

  return out;
}

/**
 * Calculates the determinant of a mat2
 *
 * @param {mat2} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant$1(a) {
  return a[0] * a[3] - a[2] * a[1];
}

/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function multiply$1(out, a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  return out;
}

/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
function rotate$1(out, a, rad) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  out[0] = a0 *  c + a2 * s;
  out[1] = a1 *  c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  return out;
}

/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/
function scale$1(out, a, v) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let v0 = v[0], v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  return out;
}

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.rotate(dest, dest, rad);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
function fromRotation$1(out, rad) {
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.scale(dest, dest, vec);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat2} out
 */
function fromScaling$1(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  return out;
}

/**
 * Returns a string representation of a mat2
 *
 * @param {mat2} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str$1(a) {
  return 'mat2(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
}

/**
 * Returns Frobenius norm of a mat2
 *
 * @param {mat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob$1(a) {
  return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2)))
}

/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {mat2} L the lower triangular matrix
 * @param {mat2} D the diagonal matrix
 * @param {mat2} U the upper triangular matrix
 * @param {mat2} a the input matrix to factorize
 */

function LDU(L, D, U, a) {
  L[2] = a[2]/a[0];
  U[0] = a[0];
  U[1] = a[1];
  U[3] = a[3] - L[2] * U[1];
  return [L, D, U];
}

/**
 * Adds two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function add$1(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  return out;
}

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
function subtract$1(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  return out;
}

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals$1(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals$1(a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
          Math.abs(a3 - b3) <= EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
}

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2} out
 */
function multiplyScalar$1(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  return out;
}

/**
 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2} out the receiving vector
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2} out
 */
function multiplyScalarAndAdd$1(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  out[3] = a[3] + (b[3] * scale);
  return out;
}

/**
 * Alias for {@link mat2.multiply}
 * @function
 */
const mul$1 = multiply$1;

/**
 * Alias for {@link mat2.subtract}
 * @function
 */
const sub$1 = subtract$1;

var mat2 = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create$1,
   clone: clone$1,
   copy: copy$1,
   identity: identity$1,
   fromValues: fromValues$1,
   set: set$1,
   transpose: transpose,
   invert: invert$1,
   adjoint: adjoint,
   determinant: determinant$1,
   multiply: multiply$1,
   rotate: rotate$1,
   scale: scale$1,
   fromRotation: fromRotation$1,
   fromScaling: fromScaling$1,
   str: str$1,
   frob: frob$1,
   LDU: LDU,
   add: add$1,
   subtract: subtract$1,
   exactEquals: exactEquals$1,
   equals: equals$1,
   multiplyScalar: multiplyScalar$1,
   multiplyScalarAndAdd: multiplyScalarAndAdd$1,
   mul: mul$1,
   sub: sub$1
});

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * 2x3 Matrix
 * @module mat2d
 *
 * @description
 * A mat2d contains six elements defined as:
 * <pre>
 * [a, c, tx,
 *  b, d, ty]
 * </pre>
 * This is a short form for the 3x3 matrix:
 * <pre>
 * [a, c, tx,
 *  b, d, ty,
 *  0, 0, 1]
 * </pre>
 * The last row is ignored so the array is shorter and operations are faster.
 */

/**
 * Creates a new identity mat2d
 *
 * @returns {mat2d} a new 2x3 matrix
 */
function create() {
  let out = new ARRAY_TYPE(6);
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}

/**
 * Creates a new mat2d initialized with values from an existing matrix
 *
 * @param {mat2d} a matrix to clone
 * @returns {mat2d} a new 2x3 matrix
 */
function clone(a) {
  let out = new ARRAY_TYPE(6);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}

/**
 * Copy the values from one mat2d to another
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */
function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  return out;
}

/**
 * Set a mat2d to the identity matrix
 *
 * @param {mat2d} out the receiving matrix
 * @returns {mat2d} out
 */
function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = 0;
  out[5] = 0;
  return out;
}

/**
 * Create a new mat2d with the given values
 *
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} A new mat2d
 */
function fromValues(a, b, c, d, tx, ty) {
  let out = new ARRAY_TYPE(6);
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}

/**
 * Set the components of a mat2d to the given values
 *
 * @param {mat2d} out the receiving matrix
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} out
 */
function set(out, a, b, c, d, tx, ty) {
  out[0] = a;
  out[1] = b;
  out[2] = c;
  out[3] = d;
  out[4] = tx;
  out[5] = ty;
  return out;
}

/**
 * Inverts a mat2d
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */
function invert(out, a) {
  let aa = a[0], ab = a[1], ac = a[2], ad = a[3];
  let atx = a[4], aty = a[5];

  let det = aa * ad - ab * ac;
  if(!det){
    return null;
  }
  det = 1.0 / det;

  out[0] = ad * det;
  out[1] = -ab * det;
  out[2] = -ac * det;
  out[3] = aa * det;
  out[4] = (ac * aty - ad * atx) * det;
  out[5] = (ab * atx - aa * aty) * det;
  return out;
}

/**
 * Calculates the determinant of a mat2d
 *
 * @param {mat2d} a the source matrix
 * @returns {Number} determinant of a
 */
function determinant(a) {
  return a[0] * a[3] - a[1] * a[2];
}

/**
 * Multiplies two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
function multiply(out, a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
  out[0] = a0 * b0 + a2 * b1;
  out[1] = a1 * b0 + a3 * b1;
  out[2] = a0 * b2 + a2 * b3;
  out[3] = a1 * b2 + a3 * b3;
  out[4] = a0 * b4 + a2 * b5 + a4;
  out[5] = a1 * b4 + a3 * b5 + a5;
  return out;
}

/**
 * Rotates a mat2d by the given angle
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */
function rotate(out, a, rad) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
  let s = Math.sin(rad);
  let c = Math.cos(rad);
  out[0] = a0 *  c + a2 * s;
  out[1] = a1 *  c + a3 * s;
  out[2] = a0 * -s + a2 * c;
  out[3] = a1 * -s + a3 * c;
  out[4] = a4;
  out[5] = a5;
  return out;
}

/**
 * Scales the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2d} out
 **/
function scale(out, a, v) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
  let v0 = v[0], v1 = v[1];
  out[0] = a0 * v0;
  out[1] = a1 * v0;
  out[2] = a2 * v1;
  out[3] = a3 * v1;
  out[4] = a4;
  out[5] = a5;
  return out;
}

/**
 * Translates the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to translate the matrix by
 * @returns {mat2d} out
 **/
function translate(out, a, v) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
  let v0 = v[0], v1 = v[1];
  out[0] = a0;
  out[1] = a1;
  out[2] = a2;
  out[3] = a3;
  out[4] = a0 * v0 + a2 * v1 + a4;
  out[5] = a1 * v0 + a3 * v1 + a5;
  return out;
}

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.rotate(dest, dest, rad);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */
function fromRotation(out, rad) {
  let s = Math.sin(rad), c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = -s;
  out[3] = c;
  out[4] = 0;
  out[5] = 0;
  return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.scale(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat2d} out
 */
function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = v[1];
  out[4] = 0;
  out[5] = 0;
  return out;
}

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.translate(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {vec2} v Translation vector
 * @returns {mat2d} out
 */
function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  out[4] = v[0];
  out[5] = v[1];
  return out;
}

/**
 * Returns a string representation of a mat2d
 *
 * @param {mat2d} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
function str(a) {
  return 'mat2d(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' +
          a[3] + ', ' + a[4] + ', ' + a[5] + ')';
}

/**
 * Returns Frobenius norm of a mat2d
 *
 * @param {mat2d} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
function frob(a) {
  return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + 1))
}

/**
 * Adds two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  return out;
}

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  return out;
}

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2d} out
 */
function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  return out;
}

/**
 * Adds two mat2d's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2d} out the receiving vector
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2d} out
 */
function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + (b[0] * scale);
  out[1] = a[1] + (b[1] * scale);
  out[2] = a[2] + (b[2] * scale);
  out[3] = a[3] + (b[3] * scale);
  out[4] = a[4] + (b[4] * scale);
  out[5] = a[5] + (b[5] * scale);
  return out;
}

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat2d} a The first matrix.
 * @param {mat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
}

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat2d} a The first matrix.
 * @param {mat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
function equals(a, b) {
  let a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
  let b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
  return (Math.abs(a0 - b0) <= EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
          Math.abs(a1 - b1) <= EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
          Math.abs(a2 - b2) <= EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
          Math.abs(a3 - b3) <= EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
          Math.abs(a4 - b4) <= EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
          Math.abs(a5 - b5) <= EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)));
}

/**
 * Alias for {@link mat2d.multiply}
 * @function
 */
const mul = multiply;

/**
 * Alias for {@link mat2d.subtract}
 * @function
 */
const sub = subtract;

var mat2d = /*#__PURE__*/Object.freeze({
   __proto__: null,
   create: create,
   clone: clone,
   copy: copy,
   identity: identity,
   fromValues: fromValues,
   set: set,
   invert: invert,
   determinant: determinant,
   multiply: multiply,
   rotate: rotate,
   scale: scale,
   translate: translate,
   fromRotation: fromRotation,
   fromScaling: fromScaling,
   fromTranslation: fromTranslation,
   str: str,
   frob: frob,
   add: add,
   subtract: subtract,
   multiplyScalar: multiplyScalar,
   multiplyScalarAndAdd: multiplyScalarAndAdd,
   exactEquals: exactEquals,
   equals: equals,
   mul: mul,
   sub: sub
});

class TriangleGeometryBuffer extends GeometryBuffer {
	
	constructor(gl) {

		super(gl, 3.);

		this.addAttribute('position', new Float32Array([
		    -1.0, -1.0,  0.0,
		     0.0,  1.0,  0.0,
		     1.0, -1.0,  0.0
		]), 3);

		this.addAttribute('uv', new Float32Array([
		     0.0, 0.0,
		     0.5, 1.0,
		     1.0, 0.0,
		]), 2, 'triangle');

		this.addAttribute('color', new Float32Array([
		    1.0, 1.0, 1.0,
		    1.0, 1.0, 1.0,
		    1.0, 1.0, 1.0
		]), 3);


	}

}

class PlaneGeometryBuffer$1 extends GeometryBuffer {
	
	constructor(gl, options) {

		super(gl, 4.);

		options = Object.assign({}, {
			width:          1000,
			height:         1000,
			widthSegments:  1,
			heightSegments: 1,
			debug:          false,
		}, options);

	    if (!gl) {
	      return;
	    }

		this.width          = options.width;
		this.height         = options.height;
		this.widthSegments  = options.widthSegments;
		this.heightSegments = options.heightSegments;

		this._build();
		this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
		this.addAttribute( 'color',    new Float32Array( this.colors   ), 3 );
	}

	update() {
		this._build();
		this.attributes['index'].update(    new Uint16Array(this.indices),   1 );
		this.attributes['position'].update( new Float32Array(this.vertices), 3 );
		this.attributes['normal'].update(   new Float32Array(this.normals),  3 );
		this.attributes['uv'].update(       new Float32Array(this.uvs),      2 );
		this.attributes['color'].update(    new Float32Array(this.colors),   3 );
		this.computeBoudingBox();
	}

	_build() {

		// buffers
		this.indices  = [];
		this.vertices = [];
		this.normals  = [];
		this.uvs      = [];
		this.colors   = [];	

		var width_half     = this.width  * 0.5;
		var height_half    = this.height * 0.5;
		var gridX          = this.widthSegments >> 0;
		var gridY          = this.heightSegments >> 0;
		var gridX1         = gridX + 1;
		var gridY1         = gridY + 1;
		var segment_width  = this.width  / gridX;
		var segment_height = this.height / gridY;

		var ix, iy;

		// generate vertices, normals and uvs
		for ( iy = 0; iy < gridY1; iy ++ ) {
			var y = iy * segment_height - height_half;
			for ( ix = 0; ix < gridX1; ix ++ ) {
				var x = ix * segment_width - width_half;
				this.vertices.push( x, - y, 0 );
				this.normals.push( 0, 0, 1 );
				this.uvs.push( ix / gridX,  1 - ( iy / gridY ) );
				this.colors.push( 1, 1, 1 );
			}
		}

		// indices
		for ( iy = 0; iy < gridY; iy ++ ) {
			for ( ix = 0; ix < gridX; ix ++ ) {
				var a = ix + gridX1 * iy;
				var b = ix + gridX1 * ( iy + 1 );
				var c = ( ix + 1 ) + gridX1 * ( iy + 1 );
				var d = ( ix + 1 ) + gridX1 * iy;
				// faces
				this.indices.push( a, b, d );
				this.indices.push( b, c, d );
			}
		}

		this.length = this.vertices.length/3;

	}


}

class PlaneGeometryBuffer extends GeometryBuffer {
	
	constructor(gl, options) {

		super(gl, 4.);

		options = Object.assign({}, {
			width:          1000,
			height:         1000,
			widthSegments:  1,
			heightSegments: 1,
			debug:          false,
		}, options);

	    if (!gl) {
	      return;
	    }

		this.width          = options.width;
		this.height         = options.height;
		this.widthSegments  = options.widthSegments;
		this.heightSegments = options.heightSegments;

		this._build();
		this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
		this.addAttribute( 'color',    new Float32Array( this.colors   ), 3 );
	}

	update() {
		this._build();
		this.attributes['index'].update(    new Uint16Array(this.indices),   1 );
		this.attributes['position'].update( new Float32Array(this.vertices), 3 );
		this.attributes['normal'].update(   new Float32Array(this.normals),  3 );
		this.attributes['uv'].update(       new Float32Array(this.uvs),      2 );
		this.attributes['color'].update(    new Float32Array(this.colors),   3 );
		this.computeBoudingBox();
	}

	_build() {

        this.indices  = [];
        this.vertices = [];
        this.normals  = [];
        this.uvs      = [];
        this.colors   = [];
    
        const width_half     = this.width * 0.5;
        const height_half    = this.height * 0.5;
        const gridX          = this.widthSegments >> 0;
        const gridY          = this.heightSegments >> 0;
        const gridX1         = gridX + 1;
        const gridY1         = gridY + 1;
        const segment_width  = this.width / gridX;
        const segment_height = this.height / gridY;
    
        let ix, iy;
    
        // generate vertices, normals, uvs
        for (iy = 0; iy < gridY1; iy++) {
            const y = iy * segment_height - height_half;
            for (ix = 0; ix < gridX1; ix++) {
                const x = ix * segment_width - width_half;
                this.vertices.push(x, -y, 0);
                this.normals.push(0, 0, 1);
                this.uvs.push(ix / gridX, 1 - (iy / gridY));
                this.colors.push(1, 1, 1);
            }
        }
    
        // generate line indices for horizontal and vertical lines (no diagonals)
        for (iy = 0; iy < gridY1; iy++) {
            for (ix = 0; ix < gridX1; ix++) {
                const current = ix + gridX1 * iy;
    
                // horizontal line to the right
                if (ix < gridX) {
                    const right = (ix + 1) + gridX1 * iy;
                    this.indices.push(current, right);
                }
    
                // vertical line downwards
                if (iy < gridY) {
                    const below = ix + gridX1 * (iy + 1);
                    this.indices.push(current, below);
                }
            }
        }
    
        this.length = this.vertices.length / 3;
    }

}

class BoxGeometryBuffer extends GeometryBuffer {
	
	constructor(gl, options) {

		super(gl, 4.);

		options = Object.assign({},{
			width:  1,
			height: 1,
			depth:  1,
			widthSegments:  1,
			heightSegments: 1,
			depthSegments:  1,
			skipDiagonals: false,
		}, options);

		// buffers
		var indices  = [];
		var vertices = [];
		var normals  = [];
		var uvs      = [];
		var colors   = [];

		var numberOfVertices = 0;
		var vertexCounter = 0;

		// function buildPlane( u, v, w, udir, vdir, width, height, depth, gridX, gridY ) {

		// 	vertexCounter = 0;

		// 	var segmentWidth  = width / gridX;
		// 	var segmentHeight = height / gridY;
		// 	var widthHalf     = width / 2;
		// 	var heightHalf    = height / 2;
		// 	var depthHalf     = depth / 2;
		// 	var gridX1        = gridX + 1;
		// 	var gridY1        = gridY + 1;
		// 	var ix, iy;

		// 	var vector = vec3.create();

		// 	// generate vertices, normals and uvs

		// 	for ( iy = 0; iy < gridY1; iy ++ ) {

		// 		var y = iy * segmentHeight - heightHalf;

		// 		for ( ix = 0; ix < gridX1; ix ++ ) {

		// 			var x = ix * segmentWidth - widthHalf;

		// 			vector[ u ] = x * udir;
		// 			vector[ v ] = y * vdir;
		// 			vector[ w ] = depthHalf;
		// 			vertices.push( vector[0], vector[1], vector[2] );

		// 			vector[ u ] = 1.;
		// 			vector[ v ] = 1.;
		// 			vector[ w ] = 1.;

		// 			vector[ u ] = 0;
		// 			vector[ v ] = 0;
		// 			vector[ w ] = depth > 0 ? 1 : -1;
		// 			normals.push( vector[0], vector[1], vector[2] );

		// 			uvs.push( ix / gridX, 1 - ( iy / gridY ) );
					
		// 			colors.push( 1, 1, 1 );

		// 			vertexCounter += 1;

		// 		}

		// 	}

		// 	for ( iy = 0; iy < gridY; iy ++ ) {
		// 		for ( ix = 0; ix < gridX; ix ++ ) {
		// 			var a = numberOfVertices + ix + gridX1 * iy;
		// 			var b = numberOfVertices + ix + gridX1 * ( iy + 1 );
		// 			var c = numberOfVertices + ( ix + 1 ) + gridX1 * ( iy + 1 );
		// 			var d = numberOfVertices + ( ix + 1 ) + gridX1 * iy;
		// 			if (options.skipDiagonals) {
		// 				// outer lines of faces only
		// 				indices.push(a, b);
		// 				indices.push(b, c);
		// 				indices.push(c, d);
		// 				indices.push(d, a);
		// 			}
		// 			else {
		// 				// faces
		// 				indices.push( a, b, d );
		// 				indices.push( b, c, d );
		// 			}
		// 		}
		// 	}




			
		// 	numberOfVertices += vertexCounter;
		// }

		function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY) {
			vertexCounter = 0;
		
			var segmentWidth = width / gridX;
			var segmentHeight = height / gridY;
			var widthHalf = width / 2;
			var heightHalf = height / 2;
			var depthHalf = depth / 2;
			var gridX1 = gridX + 1;
			var gridY1 = gridY + 1;
			var ix, iy;
		
			var vector = create$5();
		
			// Generate vertices, normals, uvs, and colors
			for (iy = 0; iy < gridY1; iy++) {
				var y = iy * segmentHeight - heightHalf;
				for (ix = 0; ix < gridX1; ix++) {
					var x = ix * segmentWidth - widthHalf;
					vector[u] = x * udir;
					vector[v] = y * vdir;
					vector[w] = depthHalf;
					vertices.push(vector[0], vector[1], vector[2]);
		
					vector[u] = 0;
					vector[v] = 0;
					vector[w] = depth > 0 ? 1 : -1;
					normals.push(vector[0], vector[1], vector[2]);
		
					uvs.push(ix / gridX, 1 - (iy / gridY));
					colors.push(1, 1, 1);
		
					vertexCounter++;
				}
			}
		
			// Define edges for the perimeter of each face in a consistent order
			for (iy = 0; iy < gridY; iy++) {
				for (ix = 0; ix < gridX; ix++) {
					var a = numberOfVertices + ix + gridX1 * iy;
					var b = numberOfVertices + ix + gridX1 * (iy + 1);
					var c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
					var d = numberOfVertices + (ix + 1) + gridX1 * iy;
		
					// // Add only perimeter edges explicitly
					// indices.push(a, b); // Left edge
					// indices.push(b, c); // Top edge
					// indices.push(c, d); // Right edge
					// indices.push(d, a); // Bottom edge
					// // Optionally add diagonals if skipDiagonals is false
					// if (!options.skipDiagonals) {
					// 	indices.push(a, c); // First diagonal
					// 	indices.push(b, d); // Second diagonal
					// }

					if (options.skipDiagonals) {
						indices.push(a, b);
						indices.push(b, c);
						indices.push(c, d);
						indices.push(d, a);
					} else {
						indices.push(a, b, d);
						indices.push(b, c, d);
					}

					
				}
			}
		
			numberOfVertices += vertexCounter;
		}
		

		buildPlane(2, 1, 0, -1, -1, options.depth, options.height, options.width, Math.floor(options.depthSegments), Math.floor(options.heightSegments)); // Front face (positive X)
		buildPlane(2, 1, 0, 1, -1, options.depth, options.height, -options.width, Math.floor(options.depthSegments), Math.floor(options.heightSegments)); // Back face (negative X)
		buildPlane(0, 2, 1, 1, 1, options.width, options.depth, options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments)); // Top face (positive Y)
		buildPlane(0, 2, 1, 1, -1, options.width, options.depth, -options.height, Math.floor(options.widthSegments), Math.floor(options.depthSegments)); // Bottom face (negative Y)
		buildPlane(0, 1, 2, 1, -1, options.width, options.height, options.depth, Math.floor(options.widthSegments), Math.floor(options.heightSegments)); // Right face (positive Z)
		buildPlane(0, 1, 2, -1, -1, options.width, options.height, -options.depth, Math.floor(options.widthSegments), Math.floor(options.heightSegments)); // Left face (negative Z)
 

		// build geometry
		this.length = numberOfVertices;

		this.addAttribute( 'index',    new Uint16Array(  indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( uvs      ), 2 );
		this.addAttribute( 'color',   new Float32Array( colors   ), 3 );

		this.indices = indices;
		this.vertices = vertices;
		this.normals = normals;
		this.uvs = uvs;
		this.colors = colors;

		this.computeBoudingBox();
		
	}

}

class SphereGeometryBuffer extends GeometryBuffer {
	
	constructor(gl, options) {

		super(gl, 0.);

		options = Object.assign({},{
			radius: 50,
			widthSegments: 8,
			heightSegments: 6,
			phiStart: 0,
			phiLength: Math.PI * 2,
			thetaStart: 0,
			thetaLength: Math.PI
		}, options);


    if (!gl) {
		console.warn('missing gl');
      return;
    }
    
		var radius = options.radius || 50;
		var widthSegments = Math.max( 3, Math.floor( options.widthSegments ) || 8 );
		var heightSegments = Math.max( 2, Math.floor( options.heightSegments ) || 6 );
		var phiStart = phiStart !== undefined ? options.phiStart : 0;
		var phiLength = phiLength !== undefined ? options.phiLength : Math.PI * 2;
		var thetaStart = thetaStart !== undefined ? options.thetaStart : 0;
		var thetaLength = thetaLength !== undefined ? options.thetaLength : Math.PI;

		var thetaEnd = thetaStart + thetaLength;

		var ix, iy;

		var index = 0;
		var grid = [];

		var vertex = create$5();
		var normal = create$5();

		// buffers

		var indices  = [];
		var vertices = [];
		var normals  = [];
		var uvs      = [];
		var colors   = [];

		// generate vertices, normals and uvs

		for ( iy = 0; iy <= heightSegments; iy ++ ) {

			var verticesRow = [];

			var v = iy / heightSegments;

			for ( ix = 0; ix <= widthSegments; ix ++ ) {

				var u = ix / widthSegments;

				vertex[0] = - radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertex[1] = radius * Math.cos( thetaStart + v * thetaLength );
				vertex[2] = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
				vertices.push( vertex[0], vertex[1], vertex[2] );

				set$5(normal, vertex[0], vertex[1], vertex[2] );
				normalize$3(normal, normal);
				normals.push( normal[0], normal[1], normal[2] );

				uvs.push( u, 1 - v );
				verticesRow.push( index ++ );
				colors.push( 1,1,1 );

			}

			grid.push( verticesRow );

		}


		// indices
		for ( iy = 0; iy < heightSegments; iy ++ ) {
			for ( ix = 0; ix < widthSegments; ix ++ ) {
				var a = grid[ iy ][ ix + 1 ];
				var b = grid[ iy ][ ix ];
				var c = grid[ iy + 1 ][ ix ];
				var d = grid[ iy + 1 ][ ix + 1 ];
				if ( iy !== 0 || thetaStart > 0 ) indices.push( a, b, d );
				if ( iy !== heightSegments - 1 || thetaEnd < Math.PI ) indices.push( b, c, d );
			}
		}

		// build geometry
		this.length = vertices.length/3;

		this.addAttribute( 'index',    new Uint16Array(  indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( normals  ), 3 );
		this.addAttribute( 'color',    new Float32Array( colors  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( uvs      ), 2, 'Sphere' );

	}

}

class CylinderGeometryBuffer extends GeometryBuffer {
    constructor(gl, options) {
        super(gl, 0.);

        options = Object.assign({}, {
            radiusTop: 50,
            radiusBottom: 50,
            height: 100,
            radialSegments: 8,
            heightSegments: 1,
            openEnded: false,
            thetaStart: 0,
            thetaLength: Math.PI * 2
        }, options);

        if (!gl) {
            console.warn('missing gl');
            return;
        }

        var radiusTop = options.radiusTop,
            radiusBottom = options.radiusBottom,
            height = options.height,
            radialSegments = Math.max(3, Math.floor(options.radialSegments)),
            heightSegments = Math.max(1, Math.floor(options.heightSegments)),
            openEnded = options.openEnded,
            thetaStart = options.thetaStart,
            thetaLength = options.thetaLength;

        var index = 0,
            indexArray = [],
            vertices = [],
            normals = [],
            colors = [],
            uvs = [],
            indices = [];

        // Generate vertices, normals, and uvs
        for (var y = 0; y <= heightSegments; y++) {
            var verticesRow = [];
            var v = y / heightSegments;
            var radius = v * (radiusBottom - radiusTop) + radiusTop;

            for (var x = 0; x <= radialSegments; x++) {
                var u = x / radialSegments;
                var theta = thetaStart + u * thetaLength;
                var sinTheta = Math.sin(theta);
                var cosTheta = Math.cos(theta);

                var vertex = fromValues$5(
                    radius * sinTheta,
                    -v * height + height / 2,
                    radius * cosTheta
                );

                var normal = fromValues$5(sinTheta, 0, cosTheta);
                normalize$3(normal, normal);

                vertices.push(vertex[0], vertex[1], vertex[2]);
                normals.push(normal[0], normal[1], normal[2]);
                colors.push(1, 1, 1);
                uvs.push(u, 1 - v);
                verticesRow.push(index++);
            }

            indexArray.push(verticesRow);
        }

        // Indices
        for (var i = 0; i < heightSegments; i++) {
            for (var j = 0; j < radialSegments; j++) {
                var a = indexArray[i][j];
                var b = indexArray[i + 1][j];
                var c = indexArray[i + 1][j + 1];
                var d = indexArray[i][j + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }


        // Caps
        if (!openEnded) {
            // --- Top cap ---
            if (radiusTop > 0) {
                var centerIndexTop = index++;
                vertices.push(0, height / 2, 0);
                normals.push(0, 1, 0);
                colors.push(1, 1, 1);
                uvs.push(0.5, 0.5);
                for (var x = 0; x < radialSegments; x++) {
                    var i1 = indexArray[0][x];
                    var i2 = indexArray[0][x + 1];
                    indices.push(centerIndexTop, i1, i2); // triangle fan
                }
            }
            // --- Bottom cap ---
            if (radiusBottom > 0) {
                var centerIndexBottom = index++;
                vertices.push(0, -height / 2, 0);
                normals.push(0, -1, 0);
                colors.push(1, 1, 1);
                uvs.push(0.5, 0.5);
                var row = indexArray[heightSegments]; // bottom row
                for (var x = 0; x < radialSegments; x++) {
                    var i1 = row[x];
                    var i2 = row[x + 1];
                    indices.push(centerIndexBottom, i2, i1); // triangle fan
                }
            }
        }


        // Build geometry
        this.length = vertices.length / 3;

        this.addAttribute('index', new Uint16Array(indices), 1);
        this.addAttribute('position', new Float32Array(vertices), 3);
        this.addAttribute('normal', new Float32Array(normals), 3);
        this.addAttribute('color', new Float32Array(colors), 3);
        
        this.addAttribute('uv', new Float32Array(uvs), 2);
    }
}

class CircleGeometryBuffer extends GeometryBuffer {
	
	constructor(gl, options) {

        super(gl, 0.);
        
        if (!gl) {
            return;
        }
    
		options = Object.assign({},{
			radius: 1,
			segments: 40,
			lineWidth: 1,
			thetaStart: 0,
			thetaLength:  Math.PI * 2
		}, options);

		var radius = options.radius;

		var vertices = [];
		var normals  = [];
		var uvs      = [];
		var colors   = [];
		var indices  = [];
		var colors   = [];

		var i, s;
		var vertex = create$5();
		var uv     = create$2();

		// center point
		vertices.push( 0, 0, 0 );
		normals.push( 0, 0, 1 );
		colors.push( 1, 1, 1 );
		uvs.push( 0.5, 0.5 );


		for ( s = 0, i = 3; s <= options.segments; s ++, i += 3 )
		{
			var segment = Math.PI/-2 + options.thetaStart + s / options.segments * options.thetaLength;
			// vertex
			vertex[0] = radius * Math.cos( segment );
			vertex[1] = radius * Math.sin( segment );
			vertices.push( vertex[0], vertex[1], vertex[2]);
			// normal
			normals.push( 0, 0, 1 );
			//colors
			colors.push( 1, 1, 1 );
			// uvs
			uv[0] = ( vertices[ i ] / radius + 1 ) / 2;
			uv[1] = ( vertices[ i + 1 ] / radius + 1 ) / 2;
			uvs.push( uv[0], uv[1] );
		}

		// indices
		for ( i = 1; i <= options.segments; i ++ ) {
			indices.push( i, i + 1, 0 );
		}

		// build geometry
		this.length = vertices.length/3;

		this.addAttribute( 'index',    new Uint16Array(  indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( normals  ), 3 );
		this.addAttribute( 'color',    new Float32Array( colors   ), 3 );
		this.addAttribute( 'uv',       new Float32Array( uvs      ), 2 );

	}

}

/*
Copyright (c) 2013 Aaron Boman and aaronboman.com
Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

var OBJ = {};

/**
 * The main Mesh class. The constructor will parse through the OBJ file data
 * and collect the vertex, vertex normal, texture, and face information. This
 * information can then be used later on when creating your VBOs. See
 * OBJ.initMeshBuffers for an example of how to use the newly created Mesh
 *
 * @class Mesh
 * @constructor
 *
 * @param {String} objectData a string representation of an OBJ file with newlines preserved.
 */
OBJ.Mesh = function (objectData) {


  /*
   The OBJ file format does a sort of compression when saving a model in a
   program like Blender. There are at least 3 sections (4 including textures)
   within the file. Each line in a section begins with the same string:
     * 'v': indicates vertex section
     * 'vn': indicates vertex normal section
     * 'f': indicates the faces section
     * 'vt': indicates vertex texture section (if textures were used on the model)
   Each of the above sections (except for the faces section) is a list/set of
   unique vertices.

   Each line of the faces section contains a list of
   (vertex, [texture], normal) groups
   Some examples:
       // the texture index is optional, both formats are possible for models
       // without a texture applied
       f 1/25 18/46 12/31
       f 1//25 18//46 12//31

       // A 3 vertex face with texture indices
       f 16/92/11 14/101/22 1/69/1

       // A 4 vertex face
       f 16/92/11 40/109/40 38/114/38 14/101/22

   The first two lines are examples of a 3 vertex face without a texture applied.
   The second is an example of a 3 vertex face with a texture applied.
   The third is an example of a 4 vertex face. Note: a face can contain N
   number of vertices.

   Each number that appears in one of the groups is a 1-based index
   corresponding to an item from the other sections (meaning that indexing
   starts at one and *not* zero).

   For example:
       `f 16/92/11` is saying to
         - take the 16th element from the [v] vertex array
         - take the 92nd element from the [vt] texture array
         - take the 11th element from the [vn] normal array
       and together they make a unique vertex.
   Using all 3+ unique Vertices from the face line will produce a polygon.

   Now, you could just go through the OBJ file and create a new vertex for
   each face line and WebGL will draw what appears to be the same model.
   However, vertices will be overlapped and duplicated all over the place.

   Consider a cube in 3D space centered about the origin and each side is
   2 units long. The front face (with the positive Z-axis pointing towards
   you) would have a Top Right vertex (looking orthogonal to its normal)
   mapped at (1,1,1) The right face would have a Top Left vertex (looking
   orthogonal to its normal) at (1,1,1) and the top face would have a Bottom
   Right vertex (looking orthogonal to its normal) at (1,1,1). Each face
   has a vertex at the same coordinates, however, three distinct vertices
   will be drawn at the same spot.

   To solve the issue of duplicate Vertices (the `(vertex, [texture], normal)`
   groups), while iterating through the face lines, when a group is encountered
   the whole group string ('16/92/11') is checked to see if it exists in the
   packed.hashindices object, and if it doesn't, the indices it specifies
   are used to look up each attribute in the corresponding attribute arrays
   already created. The values are then copied to the corresponding unpacked
   array (flattened to play nice with WebGL's ELEMENT_ARRAY_BUFFER indexing),
   the group string is added to the hashindices set and the current unpacked
   index is used as this hashindices value so that the group of elements can
   be reused. The unpacked index is incremented. If the group string already
   exists in the hashindices object, its corresponding value is the index of
   that group and is appended to the unpacked indices array.
   */
  var verts = [], vertNormals = [], textures = [], unpacked = {};
  // unpacking stuff
  unpacked.verts = [];
  unpacked.norms = [];
  unpacked.textures = [];
  unpacked.hashindices = {};
  unpacked.indices = [];
  unpacked.index = 0;
  // array of lines separated by the newline
  var lines = objectData.split('\n');
  
  var VERTEX_RE = /^v\s/;
  var NORMAL_RE = /^vn\s/;
  var TEXTURE_RE = /^vt\s/;
  var FACE_RE = /^f\s/;
  var WHITESPACE_RE = /\s+/;
  
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i].trim();
    var elements = line.split(WHITESPACE_RE);
    elements.shift();
    
    if (VERTEX_RE.test(line)) {
      // if this is a vertex
      verts.push.apply(verts, elements);
    } else if (NORMAL_RE.test(line)) {
      // if this is a vertex normal
      vertNormals.push.apply(vertNormals, elements);
    } else if (TEXTURE_RE.test(line)) {
      // if this is a texture
      textures.push.apply(textures, elements);
    } else if (FACE_RE.test(line)) {
      // if this is a face
      /*
      split this face into an array of vertex groups
      for example:
         f 16/92/11 14/101/22 1/69/1
      becomes:
        ['16/92/11', '14/101/22', '1/69/1'];
      */
      var quad = false;
      for (var j = 0, eleLen = elements.length; j < eleLen; j++){

          // Triangulating quads
          // quad: 'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2 v3/t3/vn3/'
          // corresponding triangles:
          //      'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2'
          //      'f v2/t2/vn2 v3/t3/vn3 v0/t0/vn0'
          if(j === 3 && !quad) {
              // add v2/t2/vn2 in again before continuing to 3
              j = 2;
              quad = true;
          }

          if (elements[j] in unpacked.hashindices) {
              unpacked.indices.push(unpacked.hashindices[elements[j]]);
          }
          else {

              //if no slah found in elemnt, it uses another syntax for faces:
              if ( !/\//.test(elements[ j ]) ) {

                unpacked.indices.push( elements[ j ] );

              }
              else {

                /*
                Each element of the face line array is a vertex which has its
                attributes delimited by a forward slash. This will separate
                each attribute into another array:
                    '19/92/11'
                becomes:
                    vertex = ['19', '92', '11'];
                where
                    vertex[0] is the vertex index
                    vertex[1] is the texture index
                    vertex[2] is the normal index
                 Think of faces having Vertices which are comprised of the
                 attributes location (v), texture (vt), and normal (vn).
                 */
                var vertex = elements[ j ].split( '/' );
                /*
                 The verts, textures, and vertNormals arrays each contain a
                 flattend array of coordinates.

                 Because it gets confusing by referring to vertex and then
                 vertex (both are different in my descriptions) I will explain
                 what's going on using the vertexNormals array:

                 vertex[2] will contain the one-based index of the vertexNormals
                 section (vn). One is subtracted from this index number to play
                 nice with javascript's zero-based array indexing.

                 Because vertexNormal is a flattened array of x, y, z values,
                 simple pointer arithmetic is used to skip to the start of the
                 vertexNormal, then the offset is added to get the correct
                 component: +0 is x, +1 is y, +2 is z.

                 This same process is repeated for verts and textures.
                 */
                // vertex position
                unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 0]);
                unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 1]);
                unpacked.verts.push(+verts[(vertex[0] - 1) * 3 + 2]);
                // vertex textures
                if (textures.length) {
                  unpacked.textures.push(+textures[(vertex[1] - 1) * 2 + 0]);
                  unpacked.textures.push(+textures[(vertex[1] - 1) * 2 + 1]);
                }
                // vertex normals
                unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 0]);
                unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 1]);
                unpacked.norms.push(+vertNormals[(vertex[2] - 1) * 3 + 2]);
                // add the newly created vertex to the list of indices
                unpacked.hashindices[elements[j]] = unpacked.index;
                unpacked.indices.push(unpacked.index);
                // increment the counter
                unpacked.index += 1;
              
              }

              
          }
          if(j === 3 && quad) {
              // add v0/t0/vn0 onto the second triangle
              unpacked.indices.push( unpacked.hashindices[elements[0]]);
          }
      }
    }
  }
  this.vertices = unpacked.verts;
  this.vertexNormals = unpacked.norms;
  this.textures = unpacked.textures;
  this.indices = unpacked.indices;
};

var Ajax$1 = function(){
  // this is just a helper class to ease ajax calls
  var _this = this;
  this.xmlhttp = new XMLHttpRequest();

  this.get = function(url, callback){
    _this.xmlhttp.onreadystatechange = function(){
      if(_this.xmlhttp.readyState === 4){
        callback(_this.xmlhttp.responseText, _this.xmlhttp.status);
      }
    };
    _this.xmlhttp.open('GET', url, true);
    _this.xmlhttp.send();
  };
};

/**
 * Takes in an object of `mesh_name`, `'/url/to/OBJ/file'` pairs and a callback
 * function. Each OBJ file will be ajaxed in and automatically converted to
 * an OBJ.Mesh. When all files have successfully downloaded the callback
 * function provided will be called and passed in an object containing
 * the newly created meshes.
 *
 * **Note:** In order to use this function as a way to download meshes, a
 * webserver of some sort must be used.
 *
 * @param {Object} nameAndURLs an object where the key is the name of the mesh and the value is the url to that mesh's OBJ file
 *
 * @param {Function} completionCallback should contain a function that will take one parameter: an object array where the keys will be the unique object name and the value will be a Mesh object
 *
 * @param {Object} meshes In case other meshes are loaded separately or if a previously declared variable is desired to be used, pass in a (possibly empty) json object of the pattern: { '<mesh_name>': OBJ.Mesh }
 *
 */
OBJ.downloadMeshes = function (nameAndURLs, completionCallback, meshes){

  // the total number of meshes. this is used to implement "blocking"
  var semaphore = Object.keys(nameAndURLs).length;
  // if error is true, an alert will given
  var error = false;
  // this is used to check if all meshes have been downloaded
  // if meshes is supplied, then it will be populated, otherwise
  // a new object is created. this will be passed into the completionCallback
  if(meshes === undefined) meshes = {};
  // loop over the mesh_name,url key,value pairs
  for(var mesh_name in nameAndURLs){
    if(nameAndURLs.hasOwnProperty(mesh_name)){
      new Ajax$1().get(nameAndURLs[mesh_name], (function(name) {
        return function (data, status) {
          if (status === 200) {
            meshes[name] = new OBJ.Mesh(data);
          }
          else {
            error = true;
            console.error('An error has occurred and the mesh "' +
            nameAndURLs + '" could not be downloaded.');
          }
          // the request has finished, decrement the counter
          semaphore--;
          if (semaphore === 0) {
            if (error) {
              // if an error has occurred, the user is notified here and the
              // callback is not called
              console.error('An error has occurred and one or meshes has not been ' +
                'downloaded. The execution of the script has terminated.');
              throw '';
            }
            // there haven't been any errors in retrieving the meshes
            // call the callback
            completionCallback(meshes);
          }
        }
      })(mesh_name));
    }
  }
};

var _buildBuffer = function( gl, type, data, itemSize ){
  var buffer = gl.createBuffer();


  var arrayView = type === gl.ARRAY_BUFFER ? Float32Array : Uint16Array;
  gl.bindBuffer(type, buffer);
  gl.bufferData(type, new arrayView(data), gl.STATIC_DRAW);
  buffer.itemSize = itemSize;
  buffer.numItems = data.length / itemSize;
  return buffer;
};

/**
 * Takes in the WebGL context and a Mesh, then creates and appends the buffers
 * to the mesh object as attributes.
 *
 * @param {WebGLRenderingContext} gl the `canvas.getContext('webgl')` context instance
 * @param {Mesh} mesh a single `OBJ.Mesh` instance
 *
 * The newly created mesh attributes are:
 *
 * Attrbute | Description
 * :--- | ---
 * **normalBuffer**       |contains the model&#39;s Vertex Normals
 * normalBuffer.itemSize  |set to 3 items
 * normalBuffer.numItems  |the total number of vertex normals
 * |
 * **textureBuffer**      |contains the model&#39;s Texture Coordinates
 * textureBuffer.itemSize |set to 2 items
 * textureBuffer.numItems |the number of texture coordinates
 * |
 * **vertexBuffer**       |contains the model&#39;s Vertex Position Coordinates (does not include w)
 * vertexBuffer.itemSize  |set to 3 items
 * vertexBuffer.numItems  |the total number of vertices
 * |
 * **indexBuffer**        |contains the indices of the faces
 * indexBuffer.itemSize   |is set to 1
 * indexBuffer.numItems   |the total number of indices
 *
 * A simple example (a lot of steps are missing, so don't copy and paste):
 *
 *     var gl   = canvas.getContext('webgl'),
 *         mesh = OBJ.Mesh(obj_file_data);
 *     // compile the shaders and create a shader program
 *     var shaderProgram = gl.createProgram();
 *     // compilation stuff here
 *     ...
 *     // make sure you have vertex, vertex normal, and texture coordinate
 *     // attributes located in your shaders and attach them to the shader program
 *     shaderProgram.vertexPositionAttribute = gl.getAttribLocation(shaderProgram, "aVertexPosition");
 *     gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);
 *
 *     shaderProgram.vertexNormalAttribute = gl.getAttribLocation(shaderProgram, "aVertexNormal");
 *     gl.enableVertexAttribArray(shaderProgram.vertexNormalAttribute);
 *
 *     shaderProgram.textureCoordAttribute = gl.getAttribLocation(shaderProgram, "aTextureCoord");
 *     gl.enableVertexAttribArray(shaderProgram.textureCoordAttribute);
 *
 *     // create and initialize the vertex, vertex normal, and texture coordinate buffers
 *     // and save on to the mesh object
 *     OBJ.initMeshBuffers(gl, mesh);
 *
 *     // now to render the mesh
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.vertexBuffer);
 *     gl.vertexAttribPointer(shaderProgram.vertexPositionAttribute, mesh.vertexBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.textureBuffer);
 *     gl.vertexAttribPointer(shaderProgram.textureCoordAttribute, mesh.textureBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.normalBuffer);
 *     gl.vertexAttribPointer(shaderProgram.vertexNormalAttribute, mesh.normalBuffer.itemSize, gl.FLOAT, false, 0, 0);
 *
 *     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, model.mesh.indexBuffer);
 *     gl.drawElements(gl.TRIANGLES, model.mesh.indexBuffer.numItems, gl.UNSIGNED_SHORT, 0);
 */
OBJ.initMeshBuffers = function( gl, mesh ){
  mesh.normalBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.vertexNormals, 3);
  mesh.textureBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.textures, 2);
  mesh.vertexBuffer = _buildBuffer(gl, gl.ARRAY_BUFFER, mesh.vertices, 3);
  mesh.indexBuffer = _buildBuffer(gl, gl.ELEMENT_ARRAY_BUFFER, mesh.indices, 1);
};

OBJ.deleteMeshBuffers = function( gl, mesh ){
  gl.deleteBuffer(mesh.normalBuffer);
  gl.deleteBuffer(mesh.textureBuffer);
  gl.deleteBuffer(mesh.vertexBuffer);
  gl.deleteBuffer(mesh.indexBuffer);
};

class ObjGeometryBuffer extends GeometryBuffer {
	constructor(gl, options) {
		super(gl, 4.);
		this.gl = gl;
		options = Object.assign({},{
			src:  null,
			data: null,
			onLoaded: ()=>{}
		}, options);
		this.options = options;
		// buffers
		this.indices  = [];
		this.vertices = [];
		this.normals  = [];
		this.uvs      = [];
		// build geometry
		this.length = 0;
		this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
		this.onObjLoaded = this.onObjLoaded.bind(this);
		this.computeBoudingBox();
		if (options.lod) {
			OBJ.downloadMeshes(options.lod, this.onObjLoaded);
		}
		else if (options.data) {
			this.onObjLoaded( [ new OBJ.Mesh(options.data) ] );
		}
		else {
			OBJ.downloadMeshes([options.src], this.onObjLoaded);
		}
	}

	onObjLoaded(meshes) {
		this.attributes = {};
		this.indices    = meshes[0].indices;
		this.vertices   = meshes[0].vertices;
		this.normals    = meshes[0].vertexNormals;
		this.uvs        = meshes[0].textures;
		let needsUvs, needsNormals;
		if (this.uvs.length == 0) {
			needsUvs = true;
		}
		if (this.normals.length == 0) {
			needsNormals = true;
		}
		for (let i=0; i<this.vertices.length/3;i++) {
			if (needsUvs) {
				this.uvs.push( 0,0 );
			}
			if (needsNormals) {
				this.normals.push( 0,1,0 );
			}
		}
		this.attributes['index']    = new ArrayBuffer$1(this.gl,  new Uint16Array(this.indices), 1, true);
		this.attributes['position'] = new ArrayBuffer$1(this.gl, new Float32Array(this.vertices), 3, false);
		this.attributes['normal']   = new ArrayBuffer$1(this.gl, new Float32Array(this.normals), 3, false);
		this.attributes['uv']       = new ArrayBuffer$1(this.gl, new Float32Array(this.uvs), 2, false);
		// this.computeBoundingSphere();
		this.computeBoudingBox('OBJ');
		this.options?.onLoaded();
	}


}

class Ajax {
	constructor() {
		this.xmlhttp = new XMLHttpRequest();
		this.get = (url, callback)=>{
			this.xmlhttp.onreadystatechange = ()=>{
				if(this.xmlhttp.readyState === 4){
					callback(this.xmlhttp.responseText, this.xmlhttp.status);
				}
			};
			this.xmlhttp.open('GET', url, true);
			this.xmlhttp.send();
		};
	}
}


class JSONGeometryBuffer extends GeometryBuffer {
	constructor(gl, options) {
		super(gl, 4.);
		this.gl = gl;
		options = Object.assign({},{
			src:  null,
			onLoaded: ()=>{}
		}, options);
		this.options = options;
		// buffers
		this.indices  = [];
		this.vertices = [];
		this.normals  = [];
		this.uvs      = [];
		// build geometry
		this.length = 0;
		this.addAttribute( 'index',    new Uint16Array(  this.indices  ), 1 );
		this.addAttribute( 'position', new Float32Array( this.vertices ), 3 );
		this.addAttribute( 'normal',   new Float32Array( this.normals  ), 3 );
		this.addAttribute( 'uv',       new Float32Array( this.uvs      ), 2 );
		this.computeBoudingBox();

        new Ajax().get(options.src, (data, status)=>{
			if (status !== 200) {
				console.error('An error has occurred while download JSON: ' + this.props.src);
				throw '';
			}
			else {
				this._onDataLoaded(JSON.parse(data));
			}
		});
	}

	_onDataLoaded(meshes) {
		this.attributes = {};
		this.indices    = meshes.indices;
		this.vertices   = meshes.vertices;
		this.normals    = meshes.vertexNormals;
		this.uvs        = meshes.textures;
		let needsUvs, needsNormals;
		if (this.uvs.length == 0) {
			needsUvs = true;
		}
		if (this.normals.length == 0) {
			needsNormals = true;
		}
		for (let i=0; i<this.vertices.length/3;i++) {
			if (needsUvs) {
				this.uvs.push( 0,0 );
			}
			if (needsNormals) {
				this.normals.push( 0,1,0 );
			}
		}
		this.attributes['index']    = new ArrayBuffer$1(this.gl,  new Uint16Array(this.indices), 1, true);
		this.attributes['position'] = new ArrayBuffer$1(this.gl, new Float32Array(this.vertices), 3, false);
		this.attributes['normal']   = new ArrayBuffer$1(this.gl, new Float32Array(this.normals), 3, false);
		this.attributes['uv']       = new ArrayBuffer$1(this.gl, new Float32Array(this.uvs), 2, false);
		// this.computeBoundingSphere();
		this.computeBoudingBox();
		this.options.onLoaded();
	}


}

// adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
function parse( buffer ) {

	var RGBE_RETURN_FAILURE = -1,

		/* default error routine.  change this to change error handling */
		rgbe_read_error   = 1,
		rgbe_write_error  = 2,
		rgbe_format_error = 3,
        rgbe_memory_error = 4,
        
		rgbe_error = function ( rgbe_error_code, msg ) {
			switch ( rgbe_error_code ) {
				case rgbe_read_error: console.error( "RGBELoader Read Error: " + ( msg || '' ) );
					break;
				case rgbe_write_error: console.error( "RGBELoader Write Error: " + ( msg || '' ) );
					break;
				case rgbe_format_error: console.error( "RGBELoader Bad File Format: " + ( msg || '' ) );
					break;
				default:
				case rgbe_memory_error: console.error( "RGBELoader: Error: " + ( msg || '' ) );

			}
			return RGBE_RETURN_FAILURE;
		},

		/* flags indicating which fields in an rgbe_header_info are valid */
		RGBE_VALID_PROGRAMTYPE = 1,
		RGBE_VALID_FORMAT = 2,
		RGBE_VALID_DIMENSIONS = 4,

		NEWLINE = "\n",

		fgets = function ( buffer, lineLimit, consume ) {

			lineLimit = ! lineLimit ? 1024 : lineLimit;
			var p = buffer.pos,
				i = - 1, len = 0, s = '', chunkSize = 128,
				chunk = String.fromCharCode.apply( null, new Uint16Array( buffer.subarray( p, p + chunkSize ) ) )
			;
			while ( ( 0 > ( i = chunk.indexOf( NEWLINE ) ) ) && ( len < lineLimit ) && ( p < buffer.byteLength ) ) {

				s += chunk; len += chunk.length;
				p += chunkSize;
				chunk += String.fromCharCode.apply( null, new Uint16Array( buffer.subarray( p, p + chunkSize ) ) );

			}

			if ( - 1 < i ) {

				/*for (i=l-1; i>=0; i--) {
					byteCode = m.charCodeAt(i);
					if (byteCode > 0x7f && byteCode <= 0x7ff) byteLen++;
					else if (byteCode > 0x7ff && byteCode <= 0xffff) byteLen += 2;
					if (byteCode >= 0xDC00 && byteCode <= 0xDFFF) i--; //trail surrogate
				}*/
				if ( false !== consume ) buffer.pos += len + i + 1;
				return s + chunk.slice( 0, i );

			}
			return false;

		},

		/* minimal header reading.  modify if you want to parse more information */
		RGBE_ReadHeader = function ( buffer ) {

			var line, match,

				// regexes to parse header info fields
				magic_token_re = /^#\?(\S+)$/,
				gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/,
				exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/,
				format_re = /^\s*FORMAT=(\S+)\s*$/,
				dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/,

				// RGBE format header struct
				header = {

					valid: 0, /* indicate which fields are valid */

					string: '', /* the actual header string */

					comments: '', /* comments found in header */

					programtype: 'RGBE', /* listed at beginning of file to identify it after "#?". defaults to "RGBE" */

					format: '', /* RGBE format, default 32-bit_rle_rgbe */

					gamma: 1.0, /* image has already been gamma corrected with given gamma. defaults to 1.0 (no correction) */

					exposure: 1.0, /* a value of 1.0 in an image corresponds to <exposure> watts/steradian/m^2. defaults to 1.0 */

					width: 0, height: 0 /* image dimensions, width/height */

				};

			if ( buffer.pos >= buffer.byteLength || ! ( line = fgets( buffer ) ) ) {

				return rgbe_error( rgbe_read_error, "no header found" );

			}
			/* if you want to require the magic token then uncomment the next line */
			if ( ! ( match = line.match( magic_token_re ) ) ) {

				return rgbe_error( rgbe_format_error, "bad initial token" );

			}
			header.valid |= RGBE_VALID_PROGRAMTYPE;
			header.programtype = match[ 1 ];
			header.string += line + "\n";

			while ( true ) {

				line = fgets( buffer );
				if ( false === line ) break;
				header.string += line + "\n";

				if ( '#' === line.charAt( 0 ) ) {

					header.comments += line + "\n";
					continue; // comment line

				}

				if ( match = line.match( gamma_re ) ) {

					header.gamma = parseFloat( match[ 1 ], 10 );

				}
				if ( match = line.match( exposure_re ) ) {

					header.exposure = parseFloat( match[ 1 ], 10 );

				}
				if ( match = line.match( format_re ) ) {

					header.valid |= RGBE_VALID_FORMAT;
					header.format = match[ 1 ];//'32-bit_rle_rgbe';

				}
				if ( match = line.match( dimensions_re ) ) {

					header.valid |= RGBE_VALID_DIMENSIONS;
					header.height = parseInt( match[ 1 ], 10 );
					header.width = parseInt( match[ 2 ], 10 );

				}

				if ( ( header.valid & RGBE_VALID_FORMAT ) && ( header.valid & RGBE_VALID_DIMENSIONS ) ) break;

			}

			if ( ! ( header.valid & RGBE_VALID_FORMAT ) ) {

				return rgbe_error( rgbe_format_error, "missing format specifier" );

			}
			if ( ! ( header.valid & RGBE_VALID_DIMENSIONS ) ) {

				return rgbe_error( rgbe_format_error, "missing image size specifier" );

			}

			return header;

		},

		RGBE_ReadPixels_RLE = function ( buffer, w, h ) {

			var data_rgba, offset, pos, count, byteValue,
				scanline_buffer, ptr, ptr_end, i, l, off, isEncodedRun,
				scanline_width = w, num_scanlines = h, rgbeStart
			;

			if (
				// run length encoding is not allowed so read flat
				( ( scanline_width < 8 ) || ( scanline_width > 0x7fff ) ) ||
				// this file is not run length encoded
				( ( 2 !== buffer[ 0 ] ) || ( 2 !== buffer[ 1 ] ) || ( buffer[ 2 ] & 0x80 ) )
			) {

				// return the flat buffer
				return new Uint8Array( buffer );

			}

			if ( scanline_width !== ( ( buffer[ 2 ] << 8 ) | buffer[ 3 ] ) ) {

				return rgbe_error( rgbe_format_error, "wrong scanline width" );

			}

			data_rgba = new Uint8Array( 4 * w * h );

			if ( ! data_rgba || ! data_rgba.length ) {

				return rgbe_error( rgbe_memory_error, "unable to allocate buffer space" );

			}

			offset = 0; pos = 0; ptr_end = 4 * scanline_width;
			rgbeStart = new Uint8Array( 4 );
			scanline_buffer = new Uint8Array( ptr_end );

			// read in each successive scanline
			while ( ( num_scanlines > 0 ) && ( pos < buffer.byteLength ) ) {

				if ( pos + 4 > buffer.byteLength ) {

					return rgbe_error( rgbe_read_error );

				}

				rgbeStart[ 0 ] = buffer[ pos ++ ];
				rgbeStart[ 1 ] = buffer[ pos ++ ];
				rgbeStart[ 2 ] = buffer[ pos ++ ];
				rgbeStart[ 3 ] = buffer[ pos ++ ];

				if ( ( 2 != rgbeStart[ 0 ] ) || ( 2 != rgbeStart[ 1 ] ) || ( ( ( rgbeStart[ 2 ] << 8 ) | rgbeStart[ 3 ] ) != scanline_width ) ) {

					return rgbe_error( rgbe_format_error, "bad rgbe scanline format" );

				}

				// read each of the four channels for the scanline into the buffer
				// first red, then green, then blue, then exponent
				ptr = 0;
				while ( ( ptr < ptr_end ) && ( pos < buffer.byteLength ) ) {

					count = buffer[ pos ++ ];
					isEncodedRun = count > 128;
					if ( isEncodedRun ) count -= 128;

					if ( ( 0 === count ) || ( ptr + count > ptr_end ) ) {

						return rgbe_error( rgbe_format_error, "bad scanline data" );

					}

					if ( isEncodedRun ) {

						// a (encoded) run of the same value
						byteValue = buffer[ pos ++ ];
						for ( i = 0; i < count; i ++ ) {

							scanline_buffer[ ptr ++ ] = byteValue;

						}
						//ptr += count;

					} else {

						// a literal-run
						scanline_buffer.set( buffer.subarray( pos, pos + count ), ptr );
						ptr += count; pos += count;

					}

				}


				// now convert data from buffer into rgba
				// first red, then green, then blue, then exponent (alpha)
				l = scanline_width; //scanline_buffer.byteLength;
				for ( i = 0; i < l; i ++ ) {

					off = 0;
					data_rgba[ offset ] = scanline_buffer[ i + off ];
					off += scanline_width; //1;
					data_rgba[ offset + 1 ] = scanline_buffer[ i + off ];
					off += scanline_width; //1;
					data_rgba[ offset + 2 ] = scanline_buffer[ i + off ];
					off += scanline_width; //1;
					data_rgba[ offset + 3 ] = scanline_buffer[ i + off ];
					offset += 4;

				}

				num_scanlines --;

			}

			return data_rgba;

		}
	;

	var byteArray = new Uint8Array( buffer );
		byteArray.byteLength;
	byteArray.pos = 0;
	var rgbe_header_info = RGBE_ReadHeader( byteArray );

	if ( RGBE_RETURN_FAILURE !== rgbe_header_info ) {

		var w = rgbe_header_info.width,
			h = rgbe_header_info.height,
			image_rgba_data = RGBE_ReadPixels_RLE( byteArray.subarray( byteArray.pos ), w, h )
		;
		if ( RGBE_RETURN_FAILURE !== image_rgba_data ) {

			return {
				width:  w, 
				height: h,
				data:     image_rgba_data,
				header:   rgbe_header_info.string,
				gamma:    rgbe_header_info.gamma,
				exposure: rgbe_header_info.exposure,
				format: 'RGBA', // handled as RGBAFormat in shaders
				type:   'UnsignedByteType'
			};

		}

	}
	return null;

}

function BinaryLoad(){
  // this is just a helper class to ease BinaryLoad calls
  var _this = this;
  this.xmlhttp = new XMLHttpRequest();
  this.get = function(url, callback){
    _this.xmlhttp.onreadystatechange = function(){
      if(_this.xmlhttp.readyState === 4){
        callback(_this.xmlhttp.response, _this.xmlhttp.status);
      }
    };
    _this.xmlhttp.open('GET', url, true);
    _this.xmlhttp.responseType = 'arraybuffer';
    _this.xmlhttp.send();
  };
}

class HDRTexture {

  constructor(gl, options) {

    options = Object.assign({}, {
      format: gl.RGBA,
      type:   gl.UNSIGNED_BYTE,
      width: 1,
      height: 1,
      linear: false,
      mipmap: false,
      miplinear: false,
      wrapS: gl.CLAMP_TO_EDGE,
      wrapT: gl.CLAMP_TO_EDGE,
      url: null,
      onReady:()=>{}
    }, options);

    this.options = options;

    this._uid   = generateUUID();//debug purpose
    this.gl     = gl;
    this.width  = options.width;
    this.height = options.height;
    this.format = options.format;
    this.type   = options.type;
    this.linear   = options.linear;

    if (this.type == gl.FLOAT) {
      gl.getExtension('EXT_color_buffer_float');
      gl.getExtension('OES_texture_float_linear');
    //   if (!floatTextures){//} || (window.innerWidth < 768)) {
    //       // console.warn('trying to create a FrameBuffer of with gl.FLOAT type but there\s no floating point texture support. trying HALF_FLOAT...');
    //       this.type = "HALF_FLOAT"
    //   }
    }

    if (this.type == "HALF_FLOAT") {
      gl.getExtension('EXT_color_buffer_float');
      gl.getExtension('OES_texture_half_float_linear');
    //   if (!halfFloatTexturesExt) {
    //     console.warn('trying to create a texture of with gl.HALF_FLOAT type but there\s no half floating point texture support; falling bck to UNSIGNED_BYTE type');
    //     this.type = gl.UNSIGNED_BYTE;
    //   }
    //   else {
    //     this.type = halfFloatTexturesExt.HALF_FLOAT_OES;
    //     this.isHalfFloat = true;
    //   }
    }

    
    this._texture = this.gl.createTexture();
    MemoryManager.trackTexture( this._texture );

    gl.bindTexture( gl.TEXTURE_2D, this._texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter$1( !!this.linear, false, false ) );
    gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, getFilter$1( !!this.linear, false, false ) );
    gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.width, this.height, 0, this.format, this.gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
    gl.bindTexture( gl.TEXTURE_2D, null);

    if (this.options.url) {
      this.load(this.options.url);
    }
    
  }


  load(url) {
    new BinaryLoad().get(url,  (data, status)=>{

      if (status === 200) {
        // var arrBuffer = toArrayBuffer(data);
        var texData = parse(data); 
    

        // if ( this.options.type === this.gl.FLOAT ) {
        //   var numElements = ( texData.data.length / 4 ) * 3;
        //   var floatdata = new Float32Array( numElements );
        //   for ( var j = 0; j < numElements; j ++ ) {
        //     RGBEByteToRGBFloat( texData.data, j * 4, floatdata, j * 3 );
        //   }
        //   texData.data = floatdata;
        // } else if ( this.options.type === this.gl.HALF_FLOAT ) {
        //   var numElements = ( texData.data.length / 4 ) * 3;
        //   var halfdata = new Uint16Array( numElements );
        //   for ( var j = 0; j < numElements; j ++ ) {
        //     RGBEByteToRGBHalf( texData.data, j * 4, halfdata, j * 3 );
        //   }
        //   texData.data = halfdata;
        // }
        this.gl.bindTexture( this.gl.TEXTURE_2D, this._texture);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
        this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, getFilter$1( !!this.linear, false, false ) );
        this.gl.texParameteri( this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, getFilter$1( !!this.linear, false, false ) );
        this.width  = texData.width;
        this.height = texData.height;
        this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.options.format, texData.width, texData.height, 0, this.options.format,  (this.options.type), texData.data);
        this.gl.bindTexture( this.gl.TEXTURE_2D, null);


        this.options.onReady();

      }
      else {
        error = true;
        console.error('An error has occurred and the HDR "' + url + '" could not be downloaded.');
      }
    });
  }

  bind(unit) {
    if (!this.gl) {
      return;
    }
    //unit is sent by the Program and defined by the unfirom order in the shaders; 
    if (unit !== void 0) {
      this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
    }
    this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
  }

  delete() {
    if (this.gl) {
      this.gl.deleteTexture( this._texture );
      MemoryManager.untrackTexture( this._texture );
    }
    this._texture = null;
    this.gl = null;
  }


}

/*
 * Copyright 2017 Sam Thorogood. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
(function (scope) {
    // fail early
    if (scope['TextEncoder'] && scope['TextDecoder']) {
        return false;
    }
    /**
     * @constructor
     * @param {string=} utfLabel
     */
    function FastTextEncoder(utfLabel = 'utf-8') {
        if (utfLabel !== 'utf-8') {
            throw new RangeError(`Failed to construct 'TextEncoder': The encoding label provided ('${utfLabel}') is invalid.`);
        }
    }
    Object.defineProperty(FastTextEncoder.prototype, 'encoding', {
        value: 'utf-8',
    });
    /**
     * @param {string} string
     * @param {{stream: boolean}=} options
     * @return {!Uint8Array}
     */
    FastTextEncoder.prototype.encode = function (string, options = { stream: false }) {
        if (options.stream) {
            throw new Error(`Failed to encode: the 'stream' option is unsupported.`);
        }
        let pos = 0;
        const len = string.length;
        let at = 0; // output position
        let tlen = Math.max(32, len + (len >> 1) + 7); // 1.5x size
        let target = new Uint8Array((tlen >> 3) << 3); // ... but at 8 byte offset
        while (pos < len) {
            let value = string.charCodeAt(pos++);
            if (value >= 0xd800 && value <= 0xdbff) {
                // high surrogate
                if (pos < len) {
                    const extra = string.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
                if (value >= 0xd800 && value <= 0xdbff) {
                    continue; // drop lone surrogate
                }
            }
            // expand the buffer if we couldn't write 4 bytes
            if (at + 4 > target.length) {
                tlen += 8; // minimum extra
                tlen *= 1.0 + (pos / string.length) * 2; // take 2x the remaining
                tlen = (tlen >> 3) << 3; // 8 byte offset
                const update = new Uint8Array(tlen);
                update.set(target);
                target = update;
            }
            if ((value & 0xffffff80) === 0) {
                // 1-byte
                target[at++] = value; // ASCII
                continue;
            }
            else if ((value & 0xfffff800) === 0) {
                // 2-byte
                target[at++] = ((value >> 6) & 0x1f) | 0xc0;
            }
            else if ((value & 0xffff0000) === 0) {
                // 3-byte
                target[at++] = ((value >> 12) & 0x0f) | 0xe0;
                target[at++] = ((value >> 6) & 0x3f) | 0x80;
            }
            else if ((value & 0xffe00000) === 0) {
                // 4-byte
                target[at++] = ((value >> 18) & 0x07) | 0xf0;
                target[at++] = ((value >> 12) & 0x3f) | 0x80;
                target[at++] = ((value >> 6) & 0x3f) | 0x80;
            }
            else {
                // FIXME: do we care
                continue;
            }
            target[at++] = (value & 0x3f) | 0x80;
        }
        return target.slice(0, at);
    };
    /**
     * @constructor
     * @param {string=} utfLabel
     * @param {{fatal: boolean}=} options
     */
    function FastTextDecoder(utfLabel = 'utf-8', options = { fatal: false }) {
        if (utfLabel !== 'utf-8') {
            throw new RangeError(`Failed to construct 'TextDecoder': The encoding label provided ('${utfLabel}') is invalid.`);
        }
        if (options.fatal) {
            throw new Error(`Failed to construct 'TextDecoder': the 'fatal' option is unsupported.`);
        }
    }
    Object.defineProperty(FastTextDecoder.prototype, 'encoding', {
        value: 'utf-8',
    });
    Object.defineProperty(FastTextDecoder.prototype, 'fatal', { value: false });
    Object.defineProperty(FastTextDecoder.prototype, 'ignoreBOM', {
        value: false,
    });
    /**
     * @param {(!ArrayBuffer|!ArrayBufferView)} buffer
     * @param {{stream: boolean}=} options
     */
    FastTextDecoder.prototype.decode = function (buffer, options = { stream: false }) {
        if (options['stream']) {
            throw new Error(`Failed to decode: the 'stream' option is unsupported.`);
        }
        const bytes = new Uint8Array(buffer);
        let pos = 0;
        const len = bytes.length;
        const out = [];
        while (pos < len) {
            const byte1 = bytes[pos++];
            if (byte1 === 0) {
                break; // NULL
            }
            if ((byte1 & 0x80) === 0) {
                // 1-byte
                out.push(byte1);
            }
            else if ((byte1 & 0xe0) === 0xc0) {
                // 2-byte
                const byte2 = bytes[pos++] & 0x3f;
                out.push(((byte1 & 0x1f) << 6) | byte2);
            }
            else if ((byte1 & 0xf0) === 0xe0) {
                const byte2 = bytes[pos++] & 0x3f;
                const byte3 = bytes[pos++] & 0x3f;
                out.push(((byte1 & 0x1f) << 12) | (byte2 << 6) | byte3);
            }
            else if ((byte1 & 0xf8) === 0xf0) {
                const byte2 = bytes[pos++] & 0x3f;
                const byte3 = bytes[pos++] & 0x3f;
                const byte4 = bytes[pos++] & 0x3f;
                // this can be > 0xffff, so possibly generate surrogates
                let codepoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0c) | (byte3 << 0x06) | byte4;
                if (codepoint > 0xffff) {
                    // codepoint &= ~0x10000;
                    codepoint -= 0x10000;
                    out.push(((codepoint >>> 10) & 0x3ff) | 0xd800);
                    codepoint = 0xdc00 | (codepoint & 0x3ff);
                }
                out.push(codepoint);
            }
            else ;
        }
        return String.fromCharCode.apply(null, out);
    };
    scope['TextEncoder'] = FastTextEncoder;
    scope['TextDecoder'] = FastTextDecoder;
})(typeof window !== 'undefined'
    ? window
    : typeof self !== 'undefined'
        ? self
        : undefined);

// eslint-disable-next-line import/no-unassigned-import
function decode(bytes, encoding = 'utf8') {
    const decoder = new TextDecoder(encoding);
    return decoder.decode(bytes);
}
const encoder = new TextEncoder();
function encode(str) {
    return encoder.encode(str);
}

const defaultByteLength = 1024 * 8;
const hostBigEndian = (() => {
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !((view[0] = 1) & array[0]);
})();
const typedArrays = {
    int8: globalThis.Int8Array,
    uint8: globalThis.Uint8Array,
    int16: globalThis.Int16Array,
    uint16: globalThis.Uint16Array,
    int32: globalThis.Int32Array,
    uint32: globalThis.Uint32Array,
    uint64: globalThis.BigUint64Array,
    int64: globalThis.BigInt64Array,
    float32: globalThis.Float32Array,
    float64: globalThis.Float64Array,
};
class IOBuffer {
    /**
     * @param data - The data to construct the IOBuffer with.
     * If data is a number, it will be the new buffer's length<br>
     * If data is `undefined`, the buffer will be initialized with a default length of 8Kb<br>
     * If data is an ArrayBuffer, SharedArrayBuffer, an ArrayBufferView (Typed Array), an IOBuffer instance,
     * or a Node.js Buffer, a view will be created over the underlying ArrayBuffer.
     * @param options
     */
    constructor(data = defaultByteLength, options = {}) {
        let dataIsGiven = false;
        if (typeof data === 'number') {
            data = new ArrayBuffer(data);
        }
        else {
            dataIsGiven = true;
            this.lastWrittenByte = data.byteLength;
        }
        const offset = options.offset ? options.offset >>> 0 : 0;
        const byteLength = data.byteLength - offset;
        let dvOffset = offset;
        if (ArrayBuffer.isView(data) || data instanceof IOBuffer) {
            if (data.byteLength !== data.buffer.byteLength) {
                dvOffset = data.byteOffset + offset;
            }
            data = data.buffer;
        }
        if (dataIsGiven) {
            this.lastWrittenByte = byteLength;
        }
        else {
            this.lastWrittenByte = 0;
        }
        this.buffer = data;
        this.length = byteLength;
        this.byteLength = byteLength;
        this.byteOffset = dvOffset;
        this.offset = 0;
        this.littleEndian = true;
        this._data = new DataView(this.buffer, dvOffset, byteLength);
        this._mark = 0;
        this._marks = [];
    }
    /**
     * Checks if the memory allocated to the buffer is sufficient to store more
     * bytes after the offset.
     * @param byteLength - The needed memory in bytes.
     * @returns `true` if there is sufficient space and `false` otherwise.
     */
    available(byteLength = 1) {
        return this.offset + byteLength <= this.length;
    }
    /**
     * Check if little-endian mode is used for reading and writing multi-byte
     * values.
     * @returns `true` if little-endian mode is used, `false` otherwise.
     */
    isLittleEndian() {
        return this.littleEndian;
    }
    /**
     * Set little-endian mode for reading and writing multi-byte values.
     */
    setLittleEndian() {
        this.littleEndian = true;
        return this;
    }
    /**
     * Check if big-endian mode is used for reading and writing multi-byte values.
     * @returns `true` if big-endian mode is used, `false` otherwise.
     */
    isBigEndian() {
        return !this.littleEndian;
    }
    /**
     * Switches to big-endian mode for reading and writing multi-byte values.
     */
    setBigEndian() {
        this.littleEndian = false;
        return this;
    }
    /**
     * Move the pointer n bytes forward.
     * @param n - Number of bytes to skip.
     */
    skip(n = 1) {
        this.offset += n;
        return this;
    }
    /**
     * Move the pointer n bytes backward.
     * @param n - Number of bytes to move back.
     */
    back(n = 1) {
        this.offset -= n;
        return this;
    }
    /**
     * Move the pointer to the given offset.
     * @param offset
     */
    seek(offset) {
        this.offset = offset;
        return this;
    }
    /**
     * Store the current pointer offset.
     * @see {@link IOBuffer#reset}
     */
    mark() {
        this._mark = this.offset;
        return this;
    }
    /**
     * Move the pointer back to the last pointer offset set by mark.
     * @see {@link IOBuffer#mark}
     */
    reset() {
        this.offset = this._mark;
        return this;
    }
    /**
     * Push the current pointer offset to the mark stack.
     * @see {@link IOBuffer#popMark}
     */
    pushMark() {
        this._marks.push(this.offset);
        return this;
    }
    /**
     * Pop the last pointer offset from the mark stack, and set the current
     * pointer offset to the popped value.
     * @see {@link IOBuffer#pushMark}
     */
    popMark() {
        const offset = this._marks.pop();
        if (offset === undefined) {
            throw new Error('Mark stack empty');
        }
        this.seek(offset);
        return this;
    }
    /**
     * Move the pointer offset back to 0.
     */
    rewind() {
        this.offset = 0;
        return this;
    }
    /**
     * Make sure the buffer has sufficient memory to write a given byteLength at
     * the current pointer offset.
     * If the buffer's memory is insufficient, this method will create a new
     * buffer (a copy) with a length that is twice (byteLength + current offset).
     * @param byteLength
     */
    ensureAvailable(byteLength = 1) {
        if (!this.available(byteLength)) {
            const lengthNeeded = this.offset + byteLength;
            const newLength = lengthNeeded * 2;
            const newArray = new Uint8Array(newLength);
            newArray.set(new Uint8Array(this.buffer));
            this.buffer = newArray.buffer;
            this.length = this.byteLength = newLength;
            this._data = new DataView(this.buffer);
        }
        return this;
    }
    /**
     * Read a byte and return false if the byte's value is 0, or true otherwise.
     * Moves pointer forward by one byte.
     */
    readBoolean() {
        return this.readUint8() !== 0;
    }
    /**
     * Read a signed 8-bit integer and move pointer forward by 1 byte.
     */
    readInt8() {
        return this._data.getInt8(this.offset++);
    }
    /**
     * Read an unsigned 8-bit integer and move pointer forward by 1 byte.
     */
    readUint8() {
        return this._data.getUint8(this.offset++);
    }
    /**
     * Alias for {@link IOBuffer#readUint8}.
     */
    readByte() {
        return this.readUint8();
    }
    /**
     * Read `n` bytes and move pointer forward by `n` bytes.
     */
    readBytes(n = 1) {
        return this.readArray(n, 'uint8');
    }
    /**
     * Creates an array of corresponding to the type `type` and size `size`.
     * For example type `uint8` will create a `Uint8Array`.
     * @param size - size of the resulting array
     * @param type - number type of elements to read
     */
    readArray(size, type) {
        const bytes = typedArrays[type].BYTES_PER_ELEMENT * size;
        const offset = this.byteOffset + this.offset;
        const slice = this.buffer.slice(offset, offset + bytes);
        if (this.littleEndian === hostBigEndian &&
            type !== 'uint8' &&
            type !== 'int8') {
            const slice = new Uint8Array(this.buffer.slice(offset, offset + bytes));
            slice.reverse();
            const returnArray = new typedArrays[type](slice.buffer);
            this.offset += bytes;
            returnArray.reverse();
            return returnArray;
        }
        const returnArray = new typedArrays[type](slice);
        this.offset += bytes;
        return returnArray;
    }
    /**
     * Read a 16-bit signed integer and move pointer forward by 2 bytes.
     */
    readInt16() {
        const value = this._data.getInt16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 16-bit unsigned integer and move pointer forward by 2 bytes.
     */
    readUint16() {
        const value = this._data.getUint16(this.offset, this.littleEndian);
        this.offset += 2;
        return value;
    }
    /**
     * Read a 32-bit signed integer and move pointer forward by 4 bytes.
     */
    readInt32() {
        const value = this._data.getInt32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit unsigned integer and move pointer forward by 4 bytes.
     */
    readUint32() {
        const value = this._data.getUint32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 32-bit floating number and move pointer forward by 4 bytes.
     */
    readFloat32() {
        const value = this._data.getFloat32(this.offset, this.littleEndian);
        this.offset += 4;
        return value;
    }
    /**
     * Read a 64-bit floating number and move pointer forward by 8 bytes.
     */
    readFloat64() {
        const value = this._data.getFloat64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit signed integer number and move pointer forward by 8 bytes.
     */
    readBigInt64() {
        const value = this._data.getBigInt64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 64-bit unsigned integer number and move pointer forward by 8 bytes.
     */
    readBigUint64() {
        const value = this._data.getBigUint64(this.offset, this.littleEndian);
        this.offset += 8;
        return value;
    }
    /**
     * Read a 1-byte ASCII character and move pointer forward by 1 byte.
     */
    readChar() {
        return String.fromCharCode(this.readInt8());
    }
    /**
     * Read `n` 1-byte ASCII characters and move pointer forward by `n` bytes.
     */
    readChars(n = 1) {
        let result = '';
        for (let i = 0; i < n; i++) {
            result += this.readChar();
        }
        return result;
    }
    /**
     * Read the next `n` bytes, return a UTF-8 decoded string and move pointer
     * forward by `n` bytes.
     */
    readUtf8(n = 1) {
        return decode(this.readBytes(n));
    }
    /**
     * Read the next `n` bytes, return a string decoded with `encoding` and move pointer
     * forward by `n` bytes.
     * If no encoding is passed, the function is equivalent to @see {@link IOBuffer#readUtf8}
     */
    decodeText(n = 1, encoding = 'utf-8') {
        return decode(this.readBytes(n), encoding);
    }
    /**
     * Write 0xff if the passed value is truthy, 0x00 otherwise and move pointer
     * forward by 1 byte.
     */
    writeBoolean(value) {
        this.writeUint8(value ? 0xff : 0x00);
        return this;
    }
    /**
     * Write `value` as an 8-bit signed integer and move pointer forward by 1 byte.
     */
    writeInt8(value) {
        this.ensureAvailable(1);
        this._data.setInt8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as an 8-bit unsigned integer and move pointer forward by 1
     * byte.
     */
    writeUint8(value) {
        this.ensureAvailable(1);
        this._data.setUint8(this.offset++, value);
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * An alias for {@link IOBuffer#writeUint8}.
     */
    writeByte(value) {
        return this.writeUint8(value);
    }
    /**
     * Write all elements of `bytes` as uint8 values and move pointer forward by
     * `bytes.length` bytes.
     */
    writeBytes(bytes) {
        this.ensureAvailable(bytes.length);
        for (let i = 0; i < bytes.length; i++) {
            this._data.setUint8(this.offset++, bytes[i]);
        }
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit signed integer and move pointer forward by 2
     * bytes.
     */
    writeInt16(value) {
        this.ensureAvailable(2);
        this._data.setInt16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 16-bit unsigned integer and move pointer forward by 2
     * bytes.
     */
    writeUint16(value) {
        this.ensureAvailable(2);
        this._data.setUint16(this.offset, value, this.littleEndian);
        this.offset += 2;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit signed integer and move pointer forward by 4
     * bytes.
     */
    writeInt32(value) {
        this.ensureAvailable(4);
        this._data.setInt32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit unsigned integer and move pointer forward by 4
     * bytes.
     */
    writeUint32(value) {
        this.ensureAvailable(4);
        this._data.setUint32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 32-bit floating number and move pointer forward by 4
     * bytes.
     */
    writeFloat32(value) {
        this.ensureAvailable(4);
        this._data.setFloat32(this.offset, value, this.littleEndian);
        this.offset += 4;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit floating number and move pointer forward by 8
     * bytes.
     */
    writeFloat64(value) {
        this.ensureAvailable(8);
        this._data.setFloat64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit signed bigint and move pointer forward by 8
     * bytes.
     */
    writeBigInt64(value) {
        this.ensureAvailable(8);
        this._data.setBigInt64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write `value` as a 64-bit unsigned bigint and move pointer forward by 8
     * bytes.
     */
    writeBigUint64(value) {
        this.ensureAvailable(8);
        this._data.setBigUint64(this.offset, value, this.littleEndian);
        this.offset += 8;
        this._updateLastWrittenByte();
        return this;
    }
    /**
     * Write the charCode of `str`'s first character as an 8-bit unsigned integer
     * and move pointer forward by 1 byte.
     */
    writeChar(str) {
        return this.writeUint8(str.charCodeAt(0));
    }
    /**
     * Write the charCodes of all `str`'s characters as 8-bit unsigned integers
     * and move pointer forward by `str.length` bytes.
     */
    writeChars(str) {
        for (let i = 0; i < str.length; i++) {
            this.writeUint8(str.charCodeAt(i));
        }
        return this;
    }
    /**
     * UTF-8 encode and write `str` to the current pointer offset and move pointer
     * forward according to the encoded length.
     */
    writeUtf8(str) {
        return this.writeBytes(encode(str));
    }
    /**
     * Export a Uint8Array view of the internal buffer.
     * The view starts at the byte offset and its length
     * is calculated to stop at the last written byte or the original length.
     */
    toArray() {
        return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
    }
    /**
     * Update the last written byte offset
     * @private
     */
    _updateLastWrittenByte() {
        if (this.offset > this.lastWrittenByte) {
            this.lastWrittenByte = this.offset;
        }
    }
}

/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

/* Public constants ==========================================================*/
/* ===========================================================================*/


//const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED$1               = 4;
//const Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
const Z_BINARY              = 0;
const Z_TEXT                = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$1(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES    = 2;
/* The three kinds of block type */

const MIN_MATCH$1    = 3;
const MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

const LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

const LITERALS$1      = 256;
/* number of literal bytes 0..255 */

const L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

const D_CODES$1       = 30;
/* number of distance codes */

const BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

const HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

const MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

const Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

const END_BLOCK   = 256;
/* end of block literal code */

const REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

const REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
const extra_lbits =   /* extra bits for each length code */
  new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

const extra_dbits =   /* extra bits for each distance code */
  new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

const extra_blbits =  /* extra bits for each bit length code */
  new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

const bl_order =
  new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

const static_dtree  = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

const _dist_code    = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

const _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

const base_length   = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

const base_dist     = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


let static_l_desc;
let static_d_desc;
let static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



const d_code = (dist) => {

  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
const put_short = (s, w) => {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
};


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
const send_bits = (s, value, length) => {

  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
};


const send_code = (s, c, tree) => {

  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
};


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
const bi_reverse = (code, len) => {

  let res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
};


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
const bi_flush = (s) => {

  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
};


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
const gen_bitlen = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */

  const tree            = desc.dyn_tree;
  const max_code        = desc.max_code;
  const stree           = desc.stat_desc.static_tree;
  const has_stree       = desc.stat_desc.has_stree;
  const extra           = desc.stat_desc.extra_bits;
  const base            = desc.stat_desc.extra_base;
  const max_length      = desc.stat_desc.max_length;
  let h;              /* heap index */
  let n, m;           /* iterate over the tree elements */
  let bits;           /* bit length */
  let xbits;          /* extra bits */
  let f;              /* frequency */
  let overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Tracev((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
};


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
const gen_codes = (tree, max_code, bl_count) => {
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */

  const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  let code = 0;              /* running code value */
  let bits;                  /* bit index */
  let n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    code = (code + bl_count[bits - 1]) << 1;
    next_code[bits] = code;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    let len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
};


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
const tr_static_init = () => {

  let n;        /* iterates over tree elements */
  let bits;     /* bit counter */
  let length;   /* length value */
  let code;     /* code value */
  let dist;     /* distance index */
  const bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
};


/* ===========================================================================
 * Initialize a new block.
 */
const init_block = (s) => {

  let n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.sym_next = s.matches = 0;
};


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
const bi_windup = (s) =>
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
};

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
const smaller = (tree, n, m, depth) => {

  const _n2 = n * 2;
  const _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
};

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
const pqdownheap = (s, tree, k) => {
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */

  const v = s.heap[k];
  let j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
};


// inlined manually
// const SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
const compress_block = (s, ltree, dtree) => {
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */

  let dist;           /* distance of matched string */
  let lc;             /* match length or unmatched char (if dist == 0) */
  let sx = 0;         /* running index in sym_buf */
  let code;           /* the code to send */
  let extra;          /* number of extra bits to send */

  if (s.sym_next !== 0) {
    do {
      dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
      dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
      lc = s.pending_buf[s.sym_buf + sx++];
      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and sym_buf is ok: */
      //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");

    } while (sx < s.sym_next);
  }

  send_code(s, END_BLOCK, ltree);
};


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
const build_tree = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */

  const tree     = desc.dyn_tree;
  const stree    = desc.stat_desc.static_tree;
  const has_stree = desc.stat_desc.has_stree;
  const elems    = desc.stat_desc.elems;
  let n, m;          /* iterate over heap elements */
  let max_code = -1; /* largest code with non zero frequency */
  let node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
};


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
const scan_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
const send_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
const build_bl_tree = (s) => {

  let max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
};


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
const send_all_trees = (s, lcodes, dcodes, blcodes) => {
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */

  let rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
const detect_data_type = (s) => {
  /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  let block_mask = 0xf3ffc07f;
  let n;

  /* Check for non-textual ("block-listed") bytes. */
  for (n = 0; n <= 31; n++, block_mask >>>= 1) {
    if ((block_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("allow-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
};


let static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
const _tr_init$1 = (s) =>
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
};


/* ===========================================================================
 * Send a stored block
 */
const _tr_stored_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  bi_windup(s);        /* align on byte boundary */
  put_short(s, stored_len);
  put_short(s, ~stored_len);
  if (stored_len) {
    s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
  }
  s.pending += stored_len;
};


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
const _tr_align$1 = (s) => {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
};


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */
const _tr_flush_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  let max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->sym_next / 3));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block$1(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
};

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
const _tr_tally$1 = (s, dist, lc) => {
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

  s.pending_buf[s.sym_buf + s.sym_next++] = dist;
  s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
  s.pending_buf[s.sym_buf + s.sym_next++] = lc;
  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

  return (s.sym_next === s.sym_end);
};

var _tr_init_1  = _tr_init$1;
var _tr_stored_block_1 = _tr_stored_block$1;
var _tr_flush_block_1  = _tr_flush_block$1;
var _tr_tally_1 = _tr_tally$1;
var _tr_align_1 = _tr_align$1;

var trees = {
	_tr_init: _tr_init_1,
	_tr_stored_block: _tr_stored_block_1,
	_tr_flush_block: _tr_flush_block_1,
	_tr_tally: _tr_tally_1,
	_tr_align: _tr_align_1
};

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32 = (adler, buf, len, pos) => {
  let s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
};


var adler32_1 = adler32;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
const makeTable = () => {
  let c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
};

// Create table on load. Just 255 signed longs. Not a problem.
const crcTable$1 = new Uint32Array(makeTable());


const crc32 = (crc, buf, len, pos) => {
  const t = crcTable$1;
  const end = pos + len;

  crc ^= -1;

  for (let i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
};


var crc32_1 = crc32;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$2 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  Z_MEM_ERROR:       -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;




/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$2;

/*============================================================================*/


const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
const MAX_WBITS$1 = 15;
/* 32K LZ77 window */
const DEF_MEM_LEVEL = 8;


const LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
const LITERALS      = 256;
/* number of literal bytes 0..255 */
const L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
const D_CODES       = 30;
/* number of distance codes */
const BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
const HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
const MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

const PRESET_DICT = 0x20;

const INIT_STATE    =  42;    /* zlib header -> BUSY_STATE */
//#ifdef GZIP
const GZIP_STATE    =  57;    /* gzip header -> BUSY_STATE | EXTRA_STATE */
//#endif
const EXTRA_STATE   =  69;    /* gzip extra block -> NAME_STATE */
const NAME_STATE    =  73;    /* gzip file name -> COMMENT_STATE */
const COMMENT_STATE =  91;    /* gzip comment -> HCRC_STATE */
const HCRC_STATE    = 103;    /* gzip header CRC -> BUSY_STATE */
const BUSY_STATE    = 113;    /* deflate -> FINISH_STATE */
const FINISH_STATE  = 666;    /* stream complete */

const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
const BS_BLOCK_DONE     = 2; /* block flush performed */
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

const err = (strm, errorCode) => {
  strm.msg = messages[errorCode];
  return errorCode;
};

const rank = (f) => {
  return ((f) * 2) - ((f) > 4 ? 9 : 0);
};

const zero = (buf) => {
  let len = buf.length; while (--len >= 0) { buf[len] = 0; }
};

/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */
const slide_hash = (s) => {
  let n, m;
  let p;
  let wsize = s.w_size;

  n = s.hash_size;
  p = n;
  do {
    m = s.head[--p];
    s.head[p] = (m >= wsize ? m - wsize : 0);
  } while (--n);
  n = wsize;
//#ifndef FASTEST
  p = n;
  do {
    m = s.prev[--p];
    s.prev[p] = (m >= wsize ? m - wsize : 0);
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */
  } while (--n);
//#endif
};

/* eslint-disable new-cap */
let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */
const flush_pending = (strm) => {
  const s = strm.state;

  //_tr_flush_bits(s);
  let len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
  strm.next_out  += len;
  s.pending_out  += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending      -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
};


const flush_block_only = (s, last) => {
  _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
};


const put_byte = (s, b) => {
  s.pending_buf[s.pending++] = b;
};


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
const putShortMSB = (s, b) => {

  //  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
};


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
const read_buf = (strm, buf, start, size) => {

  let len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32_1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32_1(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
};


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
const longest_match = (s, cur_match) => {

  let chain_length = s.max_chain_length;      /* max hash chain length */
  let scan = s.strstart; /* current string */
  let match;                       /* matched string */
  let len;                           /* length of current match */
  let best_len = s.prev_length;              /* best match length so far */
  let nice_match = s.nice_match;             /* stop if match long enough */
  const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  const _win = s.window; // shortcut

  const wmask = s.w_mask;
  const prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  const strend = s.strstart + MAX_MATCH;
  let scan_end1  = _win[scan + best_len - 1];
  let scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
};


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
const fill_window = (s) => {

  const _w_size = s.w_size;
  let n, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;
      if (s.insert > s.strstart) {
        s.insert = s.strstart;
      }
      slide_hash(s);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */
const deflate_stored = (s, flush) => {

  /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */
  let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;

  /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */
  let len, left, have, last = 0;
  let used = s.strm.avail_in;
  do {
    /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */
    len = 65535/* MAX_STORED */;     /* maximum deflate stored block length */
    have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    if (s.strm.avail_out < have) {         /* need room for header */
      break;
    }
      /* maximum stored block length that will fit in avail_out: */
    have = s.strm.avail_out - have;
    left = s.strstart - s.block_start;  /* bytes left in window */
    if (len > left + s.strm.avail_in) {
      len = left + s.strm.avail_in;   /* limit len to the input */
    }
    if (len > have) {
      len = have;             /* limit len to the output */
    }

    /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */
    if (len < min_block && ((len === 0 && flush !== Z_FINISH$3) ||
                        flush === Z_NO_FLUSH$2 ||
                        len !== left + s.strm.avail_in)) {
      break;
    }

    /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */
    last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
    _tr_stored_block(s, 0, 0, last);

    /* Replace the lengths in the dummy stored block with len. */
    s.pending_buf[s.pending - 4] = len;
    s.pending_buf[s.pending - 3] = len >> 8;
    s.pending_buf[s.pending - 2] = ~len;
    s.pending_buf[s.pending - 1] = ~len >> 8;

    /* Write the stored block header bytes. */
    flush_pending(s.strm);

//#ifdef ZLIB_DEBUG
//    /* Update debugging counts for the data about to be copied. */
//    s->compressed_len += len << 3;
//    s->bits_sent += len << 3;
//#endif

    /* Copy uncompressed bytes from the window to next_out. */
    if (left) {
      if (left > len) {
        left = len;
      }
      //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
      s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
      s.strm.next_out += left;
      s.strm.avail_out -= left;
      s.strm.total_out += left;
      s.block_start += left;
      len -= left;
    }

    /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */
    if (len) {
      read_buf(s.strm, s.strm.output, s.strm.next_out, len);
      s.strm.next_out += len;
      s.strm.avail_out -= len;
      s.strm.total_out += len;
    }
  } while (last === 0);

  /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */
  used -= s.strm.avail_in;    /* number of input bytes directly copied */
  if (used) {
    /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */
    if (used >= s.w_size) {  /* supplant the previous history */
      s.matches = 2;     /* clear hash */
      //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
      s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
      s.strstart = s.w_size;
      s.insert = s.strstart;
    }
    else {
      if (s.window_size - s.strstart <= used) {
        /* Slide the window down. */
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) {
          s.matches++;   /* add a pending slide_hash() */
        }
        if (s.insert > s.strstart) {
          s.insert = s.strstart;
        }
      }
      //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
      s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
      s.strstart += used;
      s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
    }
    s.block_start = s.strstart;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* If the last block was written to next_out, then done. */
  if (last) {
    return BS_FINISH_DONE;
  }

  /* If flushing and all input has been consumed, then done. */
  if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 &&
    s.strm.avail_in === 0 && s.strstart === s.block_start) {
    return BS_BLOCK_DONE;
  }

  /* Fill the window with any remaining input. */
  have = s.window_size - s.strstart;
  if (s.strm.avail_in > have && s.block_start >= s.w_size) {
    /* Slide the window down. */
    s.block_start -= s.w_size;
    s.strstart -= s.w_size;
    //zmemcpy(s->window, s->window + s->w_size, s->strstart);
    s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
    if (s.matches < 2) {
      s.matches++;       /* add a pending slide_hash() */
    }
    have += s.w_size;      /* more space now */
    if (s.insert > s.strstart) {
      s.insert = s.strstart;
    }
  }
  if (have > s.strm.avail_in) {
    have = s.strm.avail_in;
  }
  if (have) {
    read_buf(s.strm, s.window, s.strstart, have);
    s.strstart += have;
    s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */
  have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    /* maximum stored block length that will fit in pending: */
  have = s.pending_buf_size - have > 65535/* MAX_STORED */ ? 65535/* MAX_STORED */ : s.pending_buf_size - have;
  min_block = have > s.w_size ? s.w_size : have;
  left = s.strstart - s.block_start;
  if (left >= min_block ||
     ((left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 &&
     s.strm.avail_in === 0 && left <= have)) {
    len = left > have ? have : left;
    last = flush === Z_FINISH$3 && s.strm.avail_in === 0 &&
         len === left ? 1 : 0;
    _tr_stored_block(s, s.block_start, len, last);
    s.block_start += len;
    flush_pending(s.strm);
  }

  /* We've done all we can with the available input and output. */
  return last ? BS_FINISH_STARTED : BS_NEED_MORE;
};


/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
const deflate_fast = (s, flush) => {

  let hash_head;        /* head of the hash chain */
  let bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
const deflate_slow = (s, flush) => {

  let hash_head;          /* head of hash chain */
  let bflush;              /* set if current block must be flushed */

  let max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
};


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
const deflate_rle = (s, flush) => {

  let bflush;            /* set if current block must be flushed */
  let prev;              /* byte at distance one to match */
  let scan, strend;      /* scan goes up to strend for length of run */

  const _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
const deflate_huff = (s, flush) => {

  let bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$2) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {

  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
const lm_init = (s) => {

  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
};


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$2; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
  this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
  this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new Uint16Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.sym_buf = 0;        /* buffer for distances and literals/lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.sym_next = 0;      /* running index in sym_buf */
  this.sym_end = 0;       /* symbol table full when sym_next reaches this */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */
const deflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const s = strm.state;
  if (!s || s.strm !== strm || (s.status !== INIT_STATE &&
//#ifdef GZIP
                                s.status !== GZIP_STATE &&
//#endif
                                s.status !== EXTRA_STATE &&
                                s.status !== NAME_STATE &&
                                s.status !== COMMENT_STATE &&
                                s.status !== HCRC_STATE &&
                                s.status !== BUSY_STATE &&
                                s.status !== FINISH_STATE)) {
    return 1;
  }
  return 0;
};


const deflateResetKeep = (strm) => {

  if (deflateStateCheck(strm)) {
    return err(strm, Z_STREAM_ERROR$2);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  const s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status =
//#ifdef GZIP
    s.wrap === 2 ? GZIP_STATE :
//#endif
    s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = -2;
  _tr_init(s);
  return Z_OK$3;
};


const deflateReset = (strm) => {

  const ret = deflateResetKeep(strm);
  if (ret === Z_OK$3) {
    lm_init(strm.state);
  }
  return ret;
};


const deflateSetHeader = (strm, head) => {

  if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
    return Z_STREAM_ERROR$2;
  }
  strm.state.gzhead = head;
  return Z_OK$3;
};


const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR$2;
  }
  let wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED || (windowBits === 8 && wrap !== 1)) {
    return err(strm, Z_STREAM_ERROR$2);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  const s = new DeflateState();

  strm.state = s;
  s.strm = strm;
  s.status = INIT_STATE;     /* to pass state test in deflateReset() */

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new Uint8Array(s.w_size * 2);
  s.head = new Uint16Array(s.hash_size);
  s.prev = new Uint16Array(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new Uint8Array(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->sym_buf = s->pending_buf + s->lit_bufsize;
  s.sym_buf = s.lit_bufsize;

  //s->sym_end = (s->lit_bufsize - 1) * 3;
  s.sym_end = (s.lit_bufsize - 1) * 3;
  /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
};

const deflateInit = (strm, level) => {

  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};


/* ========================================================================= */
const deflate$2 = (strm, flush) => {

  if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  }

  const s = strm.state;

  if (!strm.output ||
      (strm.avail_in !== 0 && !strm.input) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$3)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  }

  const old_flush = s.last_flush;
  s.last_flush = flush;

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$3;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$3) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* Write the header */
  if (s.status === INIT_STATE && s.wrap === 0) {
    s.status = BUSY_STATE;
  }
  if (s.status === INIT_STATE) {
    /* zlib header */
    let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
    let level_flags = -1;

    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
      level_flags = 0;
    } else if (s.level < 6) {
      level_flags = 1;
    } else if (s.level === 6) {
      level_flags = 2;
    } else {
      level_flags = 3;
    }
    header |= (level_flags << 6);
    if (s.strstart !== 0) { header |= PRESET_DICT; }
    header += 31 - (header % 31);

    putShortMSB(s, header);

    /* Save the adler32 of the preset dictionary: */
    if (s.strstart !== 0) {
      putShortMSB(s, strm.adler >>> 16);
      putShortMSB(s, strm.adler & 0xffff);
    }
    strm.adler = 1; // adler32(0L, Z_NULL, 0);
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#ifdef GZIP
  if (s.status === GZIP_STATE) {
    /* gzip header */
    strm.adler = 0;  //crc32(0L, Z_NULL, 0);
    put_byte(s, 31);
    put_byte(s, 139);
    put_byte(s, 8);
    if (!s.gzhead) { // s->gzhead == Z_NULL
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, OS_CODE);
      s.status = BUSY_STATE;

      /* Compression must start with an empty pending buffer */
      flush_pending(strm);
      if (s.pending !== 0) {
        s.last_flush = -1;
        return Z_OK$3;
      }
    }
    else {
      put_byte(s, (s.gzhead.text ? 1 : 0) +
                  (s.gzhead.hcrc ? 2 : 0) +
                  (!s.gzhead.extra ? 0 : 4) +
                  (!s.gzhead.name ? 0 : 8) +
                  (!s.gzhead.comment ? 0 : 16)
      );
      put_byte(s, s.gzhead.time & 0xff);
      put_byte(s, (s.gzhead.time >> 8) & 0xff);
      put_byte(s, (s.gzhead.time >> 16) & 0xff);
      put_byte(s, (s.gzhead.time >> 24) & 0xff);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, s.gzhead.os & 0xff);
      if (s.gzhead.extra && s.gzhead.extra.length) {
        put_byte(s, s.gzhead.extra.length & 0xff);
        put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
      }
      if (s.gzhead.hcrc) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
      }
      s.gzindex = 0;
      s.status = EXTRA_STATE;
    }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
      while (s.pending + left > s.pending_buf_size) {
        let copy = s.pending_buf_size - s.pending;
        // zmemcpy(s.pending_buf + s.pending,
        //    s.gzhead.extra + s.gzindex, copy);
        s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
        s.pending = s.pending_buf_size;
        //--- HCRC_UPDATE(beg) ---//
        if (s.gzhead.hcrc && s.pending > beg) {
          strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        }
        //---//
        s.gzindex += copy;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
        beg = 0;
        left -= copy;
      }
      // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
      //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
      let gzhead_extra = new Uint8Array(s.gzhead.extra);
      // zmemcpy(s->pending_buf + s->pending,
      //     s->gzhead->extra + s->gzindex, left);
      s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
      s.pending += left;
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = NAME_STATE;
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = COMMENT_STATE;
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
    }
    s.status = HCRC_STATE;
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
      }
      put_byte(s, strm.adler & 0xff);
      put_byte(s, (strm.adler >> 8) & 0xff);
      strm.adler = 0; //crc32(0L, Z_NULL, 0);
    }
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#endif

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)) {
    let bstate = s.level === 0 ? deflate_stored(s, flush) :
                 s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) :
                 s.strategy === Z_RLE ? deflate_rle(s, flush) :
                 configuration_table[s.level].func(s, flush);

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$3;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        _tr_align(s);
      }
      else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

        _tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH$1) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$3;
      }
    }
  }

  if (flush !== Z_FINISH$3) { return Z_OK$3; }
  if (s.wrap <= 0) { return Z_STREAM_END$3; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
};


const deflateEnd = (strm) => {

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const status = strm.state.status;

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
};


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
const deflateSetDictionary = (strm, dictionary) => {

  let dictLength = dictionary.length;

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const s = strm.state;
  const wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR$2;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    let tmpDict = new Uint8Array(s.w_size);
    tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  const avail = strm.avail_in;
  const next = strm.next_in;
  const input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    let str = s.strstart;
    let n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$3;
};


var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2$1 = deflate$2;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/

var deflate_1$2 = {
	deflateInit: deflateInit_1,
	deflateInit2: deflateInit2_1,
	deflateReset: deflateReset_1,
	deflateResetKeep: deflateResetKeep_1,
	deflateSetHeader: deflateSetHeader_1,
	deflate: deflate_2$1,
	deflateEnd: deflateEnd_1,
	deflateSetDictionary: deflateSetDictionary_1,
	deflateInfo: deflateInfo
};

const _has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var assign = function (obj /*from1, from2, from3, ...*/) {
  const sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    const source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (const p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// Join array of chunks to single array.
var flattenChunks = (chunks) => {
  // calculate data length
  let len = 0;

  for (let i = 0, l = chunks.length; i < l; i++) {
    len += chunks[i].length;
  }

  // join chunks
  const result = new Uint8Array(len);

  for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
    let chunk = chunks[i];
    result.set(chunk, pos);
    pos += chunk.length;
  }

  return result;
};

var common = {
	assign: assign,
	flattenChunks: flattenChunks
};

// String encode/decode helpers


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for (let q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
var string2buf = (str) => {
  if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
    return new TextEncoder().encode(str);
  }

  let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new Uint8Array(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper
const buf2binstring = (buf, len) => {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK) {
      return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
  }

  let result = '';
  for (let i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
};


// convert array to string
var buf2string = (buf, max) => {
  const len = max || buf.length;

  if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) {
    return new TextDecoder().decode(buf.subarray(0, max));
  }

  let i, out;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  const utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    let c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    let c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = (buf, max) => {

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  let pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

var strings = {
	string2buf: string2buf,
	buf2string: buf2string,
	utf8border: utf8border
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream;

const toString$1 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$2;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate$1(options) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, options || {});

  let opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  let status = deflate_1$2.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK$2) {
    throw new Error(messages[status]);
  }

  if (opt.header) {
    deflate_1$2.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    let dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = deflate_1$2.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK$2) {
      throw new Error(messages[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  let status, _flush_mode;

  if (this.ended) { return false; }

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString$1.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    // Make sure avail_out > 6 to avoid repeating markers
    if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    status = deflate_1$2.deflate(strm, _flush_mode);

    // Ended => flush and finish
    if (status === Z_STREAM_END$2) {
      if (strm.next_out > 0) {
        this.onData(strm.output.subarray(0, strm.next_out));
      }
      status = deflate_1$2.deflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return status === Z_OK$2;
    }

    // Flush if out buffer full
    if (strm.avail_out === 0) {
      this.onData(strm.output);
      continue;
    }

    // Flush if requested and has data
    if (_flush_mode > 0 && strm.next_out > 0) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK$2) {
    this.result = common.flattenChunks(this.chunks);
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
const BAD$1 = 16209;       /* got a data error -- remain here until reset */
const TYPE$1 = 16191;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
var inffast = function inflate_fast(strm, start) {
  let _in;                    /* local strm.input */
  let last;                   /* have enough input while in < last */
  let _out;                   /* local strm.output */
  let beg;                    /* inflate()'s initial strm.output */
  let end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  let dmax;                   /* maximum distance from zlib header */
//#endif
  let wsize;                  /* window size or zero if not using window */
  let whave;                  /* valid bytes in the window */
  let wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  let s_window;               /* allocated sliding window, if wsize != 0 */
  let hold;                   /* local strm.hold */
  let bits;                   /* local strm.bits */
  let lcode;                  /* local strm.lencode */
  let dcode;                  /* local strm.distcode */
  let lmask;                  /* mask for first level of length codes */
  let dmask;                  /* mask for first level of distance codes */
  let here;                   /* retrieved table entry */
  let op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  let len;                    /* match length, unused bytes */
  let dist;                   /* match distance */
  let from;                   /* where to copy match from */
  let from_source;


  let input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  const state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE$1;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD$1;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const MAXBITS = 15;
const ENOUGH_LENS$1 = 852;
const ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

const CODES$1 = 0;
const LENS$1 = 1;
const DISTS$1 = 2;

const lbase = new Uint16Array([ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
]);

const lext = new Uint8Array([ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
]);

const dbase = new Uint16Array([ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
]);

const dext = new Uint8Array([ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
]);

const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts) =>
{
  const bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  let len = 0;               /* a code's length in bits */
  let sym = 0;               /* index of code symbols */
  let min = 0, max = 0;          /* minimum and maximum code lengths */
  let root = 0;              /* number of index bits for root table */
  let curr = 0;              /* number of index bits for current table */
  let drop = 0;              /* code bits to drop for sub-table */
  let left = 0;                   /* number of prefix codes available */
  let used = 0;              /* code entries in table used */
  let huff = 0;              /* Huffman code */
  let incr;              /* for incrementing code, index */
  let fill;              /* index for replicating entries */
  let low;               /* low bits for current root entry */
  let mask;              /* mask for low root bits */
  let next;             /* next available space in table */
  let base = null;     /* base value table to use */
//  let shoextra;    /* extra bits table to use */
  let match;                  /* use base and extra for symbol >= match */
  const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  let extra = null;

  let here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES$1 || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES$1) {
    base = extra = work;    /* dummy value--not used */
    match = 20;

  } else if (type === LENS$1) {
    base = lbase;
    extra = lext;
    match = 257;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    match = 0;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
    (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] + 1 < match) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] >= match) {
      here_op = extra[work[sym] - match];
      here_val = base[work[sym] - match];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
        (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


var inftrees = inflate_table;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.






const CODES = 0;
const LENS = 1;
const DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES,
  Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR,
  Z_DEFLATED
} = constants$2;


/* STATES ====================================================================*/
/* ===========================================================================*/


const    HEAD = 16180;       /* i: waiting for magic header */
const    FLAGS = 16181;      /* i: waiting for method and flags (gzip) */
const    TIME = 16182;       /* i: waiting for modification time (gzip) */
const    OS = 16183;         /* i: waiting for extra flags and operating system (gzip) */
const    EXLEN = 16184;      /* i: waiting for extra length (gzip) */
const    EXTRA = 16185;      /* i: waiting for extra bytes (gzip) */
const    NAME = 16186;       /* i: waiting for end of file name (gzip) */
const    COMMENT = 16187;    /* i: waiting for end of comment (gzip) */
const    HCRC = 16188;       /* i: waiting for header crc (gzip) */
const    DICTID = 16189;    /* i: waiting for dictionary check value */
const    DICT = 16190;      /* waiting for inflateSetDictionary() call */
const        TYPE = 16191;      /* i: waiting for type bits, including last-flag bit */
const        TYPEDO = 16192;    /* i: same, but skip check to exit inflate on new block */
const        STORED = 16193;    /* i: waiting for stored size (length and complement) */
const        COPY_ = 16194;     /* i/o: same as COPY below, but only first time in */
const        COPY = 16195;      /* i/o: waiting for input or output to copy stored block */
const        TABLE = 16196;     /* i: waiting for dynamic block table lengths */
const        LENLENS = 16197;   /* i: waiting for code length code lengths */
const        CODELENS = 16198;  /* i: waiting for length/lit and distance code lengths */
const            LEN_ = 16199;      /* i: same as LEN below, but only first time in */
const            LEN = 16200;       /* i: waiting for length/lit/eob code */
const            LENEXT = 16201;    /* i: waiting for length extra bits */
const            DIST = 16202;      /* i: waiting for distance code */
const            DISTEXT = 16203;   /* i: waiting for distance extra bits */
const            MATCH = 16204;     /* o: waiting for output space to copy string */
const            LIT = 16205;       /* o: waiting for output space to write literal */
const    CHECK = 16206;     /* i: waiting for 32-bit check value */
const    LENGTH = 16207;    /* i: waiting for 32-bit length (gzip) */
const    DONE = 16208;      /* finished check, done -- remain here until reset */
const    BAD = 16209;       /* got a data error -- remain here until reset */
const    MEM = 16210;       /* got an inflate() memory error -- remain here until reset */
const    SYNC = 16211;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

const MAX_WBITS = 15;
/* 32K LZ77 window */
const DEF_WBITS = MAX_WBITS;


const zswap32 = (q) => {

  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
};


function InflateState() {
  this.strm = null;           /* pointer back to this zlib stream */
  this.mode = 0;              /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new Uint16Array(320); /* temporary storage for code lengths */
  this.work = new Uint16Array(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}


const inflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const state = strm.state;
  if (!state || state.strm !== strm ||
    state.mode < HEAD || state.mode > SYNC) {
    return 1;
  }
  return 0;
};


const inflateResetKeep = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.flags = -1;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
  state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK$1;
};


const inflateReset = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

};


const inflateReset2 = (strm, windowBits) => {
  let wrap;

  /* get the state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 5;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR$1;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
};


const inflateInit2 = (strm, windowBits) => {

  if (!strm) { return Z_STREAM_ERROR$1; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  const state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.strm = strm;
  state.window = null/*Z_NULL*/;
  state.mode = HEAD;     /* to pass state test in inflateReset2() */
  const ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK$1) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
};


const inflateInit = (strm) => {

  return inflateInit2(strm, DEF_WBITS);
};


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
let virgin = true;

let lenfix, distfix; // We have no pointers in JS, so keep tables separate


const fixedtables = (state) => {

  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    lenfix = new Int32Array(512);
    distfix = new Int32Array(32);

    /* literal/length table */
    let sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inftrees(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inftrees(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
};


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
const updatewindow = (strm, src, end, copy) => {

  let dist;
  const state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new Uint8Array(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    state.window.set(src.subarray(end - state.wsize, end), 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      state.window.set(src.subarray(end - copy, end), 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
};


const inflate$2 = (strm, flush) => {

  let state;
  let input, output;          // input/output buffers
  let next;                   /* next input INDEX */
  let put;                    /* next output INDEX */
  let have, left;             /* available input and output */
  let hold;                   /* bit buffer */
  let bits;                   /* bits in bit buffer */
  let _in, _out;              /* save starting available input and output */
  let copy;                   /* number of stored or match bytes to copy */
  let from;                   /* where to copy match bytes from */
  let from_source;
  let here = 0;               /* current decoding table entry */
  let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //let last;                   /* parent table entry */
  let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  let len;                    /* length to copy for repeats, bits to drop */
  let ret;                    /* return code */
  const hbuf = new Uint8Array(4);    /* buffer for gzip header crc calculation */
  let opts;

  let n; // temporary variable for NEED_BITS

  const order = /* permutation of code lengths */
    new Uint8Array([ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ]);


  if (inflateStateCheck(strm) || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR$1;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK$1;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          if (state.wbits === 0) {
            state.wbits = 15;
          }
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        if (len > 15 || len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }

        // !!! pako patch. Force use `options.windowBits` if passed.
        // Required to always use max window size by default.
        state.dmax = 1 << state.wbits;
        //state.dmax = 1 << len;

        state.flags = 0;               /* indicate zlib header */
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32_1(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32_1(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Uint8Array(state.head.extra_len);
              }
              state.head.extra.set(
                input.subarray(
                  next,
                  // extra field is limited to 65536 bytes
                  // - no need for additional size check
                  next + copy
                ),
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              state.check = crc32_1(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT$1;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          output.set(input.subarray(next, next + copy), put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inffast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if ((state.wrap & 4) && _out) {
            strm.adler = state.check =
                /*UPDATE_CHECK(state.check, put - _out, _out);*/
                (state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.wrap & 4) && (state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END$1;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR$1;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR$1;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR$1;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH$1))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if ((state.wrap & 4) && _out) {
    strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH$1) && ret === Z_OK$1) {
    ret = Z_BUF_ERROR;
  }
  return ret;
};


const inflateEnd = (strm) => {

  if (inflateStateCheck(strm)) {
    return Z_STREAM_ERROR$1;
  }

  let state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK$1;
};


const inflateGetHeader = (strm, head) => {

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK$1;
};


const inflateSetDictionary = (strm, dictionary) => {
  const dictLength = dictionary.length;

  let state;
  let dictid;
  let ret;

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR$1;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32_1(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR$1;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR$1;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK$1;
};


var inflateReset_1 = inflateReset;
var inflateReset2_1 = inflateReset2;
var inflateResetKeep_1 = inflateResetKeep;
var inflateInit_1 = inflateInit;
var inflateInit2_1 = inflateInit2;
var inflate_2$1 = inflate$2;
var inflateEnd_1 = inflateEnd;
var inflateGetHeader_1 = inflateGetHeader;
var inflateSetDictionary_1 = inflateSetDictionary;
var inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/

var inflate_1$2 = {
	inflateReset: inflateReset_1,
	inflateReset2: inflateReset2_1,
	inflateResetKeep: inflateResetKeep_1,
	inflateInit: inflateInit_1,
	inflateInit2: inflateInit2_1,
	inflate: inflate_2$1,
	inflateEnd: inflateEnd_1,
	inflateGetHeader: inflateGetHeader_1,
	inflateSetDictionary: inflateSetDictionary_1,
	inflateInfo: inflateInfo
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

var gzheader = GZheader;

const toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH, Z_FINISH,
  Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR
} = constants$2;

/* ===========================================================================*/


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate$1(options) {
  this.options = common.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ''
  }, options || {});

  const opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  let status  = inflate_1$2.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== Z_OK) {
    throw new Error(messages[status]);
  }

  this.header = new gzheader();

  inflate_1$2.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== Z_OK) {
        throw new Error(messages[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  const dictionary = this.options.dictionary;
  let status, _flush_mode, last_avail_out;

  if (this.ended) return false;

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

  // Convert data if needed
  if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = inflate_1$2.inflate(strm, _flush_mode);

    if (status === Z_NEED_DICT && dictionary) {
      status = inflate_1$2.inflateSetDictionary(strm, dictionary);

      if (status === Z_OK) {
        status = inflate_1$2.inflate(strm, _flush_mode);
      } else if (status === Z_DATA_ERROR) {
        // Replace code with more verbose
        status = Z_NEED_DICT;
      }
    }

    // Skip snyc markers if more data follows and not raw mode
    while (strm.avail_in > 0 &&
           status === Z_STREAM_END &&
           strm.state.wrap > 0 &&
           data[strm.next_in] !== 0)
    {
      inflate_1$2.inflateReset(strm);
      status = inflate_1$2.inflate(strm, _flush_mode);
    }

    switch (status) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        this.onEnd(status);
        this.ended = true;
        return false;
    }

    // Remember real `avail_out` value, because we may patch out buffer content
    // to align utf8 strings boundaries.
    last_avail_out = strm.avail_out;

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === Z_STREAM_END) {

        if (this.options.to === 'string') {

          let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          let tail = strm.next_out - next_out_utf8;
          let utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail & realign counters
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);

          this.onData(utf8str);

        } else {
          this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
        }
      }
    }

    // Must repeat iteration if out buffer is full
    if (status === Z_OK && last_avail_out === 0) continue;

    // Finalize if end of stream reached.
    if (status === Z_STREAM_END) {
      status = inflate_1$2.inflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return true;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = common.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/
function inflate$1(input, options) {
  const inflator = new Inflate$1(options);

  inflator.push(input);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) throw inflator.msg || messages[inflator.err];

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return inflate$1(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


var Inflate_1$1 = Inflate$1;
var inflate_2 = inflate$1;
var inflateRaw_1$1 = inflateRaw$1;
var ungzip$1 = inflate$1;
var constants = constants$2;

var inflate_1$1 = {
	Inflate: Inflate_1$1,
	inflate: inflate_2,
	inflateRaw: inflateRaw_1$1,
	ungzip: ungzip$1,
	constants: constants
};

const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;
var Inflate_1 = Inflate;
var inflate_1 = inflate;

const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10];
const crcTable = [];
for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) {
        if (c & 1) {
            c = 0xedb88320 ^ (c >>> 1);
        }
        else {
            c = c >>> 1;
        }
    }
    crcTable[n] = c;
}
const initialCrc = 0xffffffff;
function updateCrc(currentCrc, data, length) {
    let c = currentCrc;
    for (let n = 0; n < length; n++) {
        c = crcTable[(c ^ data[n]) & 0xff] ^ (c >>> 8);
    }
    return c;
}
function crc(data, length) {
    return (updateCrc(initialCrc, data, length) ^ initialCrc) >>> 0;
}

var ColorType;
(function (ColorType) {
    ColorType[ColorType["UNKNOWN"] = -1] = "UNKNOWN";
    ColorType[ColorType["GREYSCALE"] = 0] = "GREYSCALE";
    ColorType[ColorType["TRUECOLOUR"] = 2] = "TRUECOLOUR";
    ColorType[ColorType["INDEXED_COLOUR"] = 3] = "INDEXED_COLOUR";
    ColorType[ColorType["GREYSCALE_ALPHA"] = 4] = "GREYSCALE_ALPHA";
    ColorType[ColorType["TRUECOLOUR_ALPHA"] = 6] = "TRUECOLOUR_ALPHA";
})(ColorType || (ColorType = {}));
var CompressionMethod;
(function (CompressionMethod) {
    CompressionMethod[CompressionMethod["UNKNOWN"] = -1] = "UNKNOWN";
    CompressionMethod[CompressionMethod["DEFLATE"] = 0] = "DEFLATE";
})(CompressionMethod || (CompressionMethod = {}));
var FilterMethod;
(function (FilterMethod) {
    FilterMethod[FilterMethod["UNKNOWN"] = -1] = "UNKNOWN";
    FilterMethod[FilterMethod["ADAPTIVE"] = 0] = "ADAPTIVE";
})(FilterMethod || (FilterMethod = {}));
var InterlaceMethod;
(function (InterlaceMethod) {
    InterlaceMethod[InterlaceMethod["UNKNOWN"] = -1] = "UNKNOWN";
    InterlaceMethod[InterlaceMethod["NO_INTERLACE"] = 0] = "NO_INTERLACE";
    InterlaceMethod[InterlaceMethod["ADAM7"] = 1] = "ADAM7";
})(InterlaceMethod || (InterlaceMethod = {}));

const empty = new Uint8Array(0);
const NULL = '\0';
const uint16 = new Uint16Array([0x00ff]);
const uint8 = new Uint8Array(uint16.buffer);
const osIsLittleEndian = uint8[0] === 0xff;
class PngDecoder extends IOBuffer {
    constructor(data, options = {}) {
        super(data);
        const { checkCrc = false } = options;
        this._checkCrc = checkCrc;
        this._inflator = new Inflate_1();
        this._png = {
            width: -1,
            height: -1,
            channels: -1,
            data: new Uint8Array(0),
            depth: 1,
            text: {},
        };
        this._end = false;
        this._hasPalette = false;
        this._palette = [];
        this._hasTransparency = false;
        this._transparency = new Uint16Array(0);
        this._compressionMethod = CompressionMethod.UNKNOWN;
        this._filterMethod = FilterMethod.UNKNOWN;
        this._interlaceMethod = InterlaceMethod.UNKNOWN;
        this._colorType = ColorType.UNKNOWN;
        // PNG is always big endian
        // https://www.w3.org/TR/PNG/#7Integers-and-byte-order
        this.setBigEndian();
    }
    decode() {
        this.decodeSignature();
        while (!this._end) {
            this.decodeChunk();
        }
        this.decodeImage();
        return this._png;
    }
    // https://www.w3.org/TR/PNG/#5PNG-file-signature
    decodeSignature() {
        for (let i = 0; i < pngSignature.length; i++) {
            if (this.readUint8() !== pngSignature[i]) {
                throw new Error(`wrong PNG signature. Byte at ${i} should be ${pngSignature[i]}.`);
            }
        }
    }
    // https://www.w3.org/TR/PNG/#5Chunk-layout
    decodeChunk() {
        const length = this.readUint32();
        const type = this.readChars(4);
        const offset = this.offset;
        switch (type) {
            // 11.2 Critical chunks
            case 'IHDR': // 11.2.2 IHDR Image header
                this.decodeIHDR();
                break;
            case 'PLTE': // 11.2.3 PLTE Palette
                this.decodePLTE(length);
                break;
            case 'IDAT': // 11.2.4 IDAT Image data
                this.decodeIDAT(length);
                break;
            case 'IEND': // 11.2.5 IEND Image trailer
                this._end = true;
                break;
            // 11.3 Ancillary chunks
            case 'tRNS': // 11.3.2.1 tRNS Transparency
                this.decodetRNS(length);
                break;
            case 'iCCP': // 11.3.3.3 iCCP Embedded ICC profile
                this.decodeiCCP(length);
                break;
            case 'tEXt': // 11.3.4.3 tEXt Textual data
                this.decodetEXt(length);
                break;
            case 'pHYs': // 11.3.5.3 pHYs Physical pixel dimensions
                this.decodepHYs();
                break;
            default:
                this.skip(length);
                break;
        }
        if (this.offset - offset !== length) {
            throw new Error(`Length mismatch while decoding chunk ${type}`);
        }
        if (this._checkCrc) {
            const expectedCrc = this.readUint32();
            const crcLength = length + 4; // includes type
            const actualCrc = crc(new Uint8Array(this.buffer, this.byteOffset + this.offset - crcLength - 4, crcLength), crcLength); // "- 4" because we already advanced by reading the CRC
            if (actualCrc !== expectedCrc) {
                throw new Error(`CRC mismatch for chunk ${type}. Expected ${expectedCrc}, found ${actualCrc}`);
            }
        }
        else {
            this.skip(4);
        }
    }
    // https://www.w3.org/TR/PNG/#11IHDR
    decodeIHDR() {
        const image = this._png;
        image.width = this.readUint32();
        image.height = this.readUint32();
        image.depth = checkBitDepth(this.readUint8());
        const colorType = this.readUint8();
        this._colorType = colorType;
        let channels;
        switch (colorType) {
            case ColorType.GREYSCALE:
                channels = 1;
                break;
            case ColorType.TRUECOLOUR:
                channels = 3;
                break;
            case ColorType.INDEXED_COLOUR:
                channels = 1;
                break;
            case ColorType.GREYSCALE_ALPHA:
                channels = 2;
                break;
            case ColorType.TRUECOLOUR_ALPHA:
                channels = 4;
                break;
            default:
                throw new Error(`Unknown color type: ${colorType}`);
        }
        this._png.channels = channels;
        this._compressionMethod = this.readUint8();
        if (this._compressionMethod !== CompressionMethod.DEFLATE) {
            throw new Error(`Unsupported compression method: ${this._compressionMethod}`);
        }
        this._filterMethod = this.readUint8();
        this._interlaceMethod = this.readUint8();
    }
    // https://www.w3.org/TR/PNG/#11PLTE
    decodePLTE(length) {
        if (length % 3 !== 0) {
            throw new RangeError(`PLTE field length must be a multiple of 3. Got ${length}`);
        }
        const l = length / 3;
        this._hasPalette = true;
        const palette = [];
        this._palette = palette;
        for (let i = 0; i < l; i++) {
            palette.push([this.readUint8(), this.readUint8(), this.readUint8()]);
        }
    }
    // https://www.w3.org/TR/PNG/#11IDAT
    decodeIDAT(length) {
        this._inflator.push(new Uint8Array(this.buffer, this.offset + this.byteOffset, length));
        this.skip(length);
    }
    // https://www.w3.org/TR/PNG/#11tRNS
    decodetRNS(length) {
        switch (this._colorType) {
            case ColorType.GREYSCALE:
            case ColorType.TRUECOLOUR: {
                if (length % 2 !== 0) {
                    throw new RangeError(`tRNS chunk length must be a multiple of 2. Got ${length}`);
                }
                if (length / 2 > this._png.width * this._png.height) {
                    throw new Error(`tRNS chunk contains more alpha values than there are pixels (${length / 2} vs ${this._png.width * this._png.height})`);
                }
                this._hasTransparency = true;
                this._transparency = new Uint16Array(length / 2);
                for (let i = 0; i < length / 2; i++) {
                    this._transparency[i] = this.readUint16();
                }
                break;
            }
            case ColorType.INDEXED_COLOUR: {
                if (length > this._palette.length) {
                    throw new Error(`tRNS chunk contains more alpha values than there are palette colors (${length} vs ${this._palette.length})`);
                }
                let i = 0;
                for (; i < length; i++) {
                    const alpha = this.readByte();
                    this._palette[i].push(alpha);
                }
                for (; i < this._palette.length; i++) {
                    this._palette[i].push(255);
                }
                break;
            }
            default: {
                throw new Error(`tRNS chunk is not supported for color type ${this._colorType}`);
            }
        }
    }
    // https://www.w3.org/TR/PNG/#11iCCP
    decodeiCCP(length) {
        let name = '';
        let char;
        while ((char = this.readChar()) !== NULL) {
            name += char;
        }
        const compressionMethod = this.readUint8();
        if (compressionMethod !== CompressionMethod.DEFLATE) {
            throw new Error(`Unsupported iCCP compression method: ${compressionMethod}`);
        }
        const compressedProfile = this.readBytes(length - name.length - 2);
        this._png.iccEmbeddedProfile = {
            name,
            profile: inflate_1(compressedProfile),
        };
    }
    // https://www.w3.org/TR/PNG/#11tEXt
    decodetEXt(length) {
        let keyword = '';
        let char;
        while ((char = this.readChar()) !== NULL) {
            keyword += char;
        }
        this._png.text[keyword] = this.readChars(length - keyword.length - 1);
    }
    // https://www.w3.org/TR/PNG/#11pHYs
    decodepHYs() {
        const ppuX = this.readUint32();
        const ppuY = this.readUint32();
        const unitSpecifier = this.readByte();
        this._png.resolution = { x: ppuX, y: ppuY, unit: unitSpecifier };
    }
    decodeImage() {
        if (this._inflator.err) {
            throw new Error(`Error while decompressing the data: ${this._inflator.err}`);
        }
        const data = this._inflator.result;
        if (this._filterMethod !== FilterMethod.ADAPTIVE) {
            throw new Error(`Filter method ${this._filterMethod} not supported`);
        }
        if (this._interlaceMethod === InterlaceMethod.NO_INTERLACE) {
            this.decodeInterlaceNull(data);
        }
        else {
            throw new Error(`Interlace method ${this._interlaceMethod} not supported`);
        }
    }
    decodeInterlaceNull(data) {
        const height = this._png.height;
        const bytesPerPixel = (this._png.channels * this._png.depth) / 8;
        const bytesPerLine = this._png.width * bytesPerPixel;
        const newData = new Uint8Array(this._png.height * bytesPerLine);
        let prevLine = empty;
        let offset = 0;
        let currentLine;
        let newLine;
        for (let i = 0; i < height; i++) {
            currentLine = data.subarray(offset + 1, offset + 1 + bytesPerLine);
            newLine = newData.subarray(i * bytesPerLine, (i + 1) * bytesPerLine);
            switch (data[offset]) {
                case 0:
                    unfilterNone(currentLine, newLine, bytesPerLine);
                    break;
                case 1:
                    unfilterSub(currentLine, newLine, bytesPerLine, bytesPerPixel);
                    break;
                case 2:
                    unfilterUp(currentLine, newLine, prevLine, bytesPerLine);
                    break;
                case 3:
                    unfilterAverage(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                    break;
                case 4:
                    unfilterPaeth(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel);
                    break;
                default:
                    throw new Error(`Unsupported filter: ${data[offset]}`);
            }
            prevLine = newLine;
            offset += bytesPerLine + 1;
        }
        if (this._hasPalette) {
            this._png.palette = this._palette;
        }
        if (this._hasTransparency) {
            this._png.transparency = this._transparency;
        }
        if (this._png.depth === 16) {
            const uint16Data = new Uint16Array(newData.buffer);
            if (osIsLittleEndian) {
                for (let k = 0; k < uint16Data.length; k++) {
                    // PNG is always big endian. Swap the bytes.
                    uint16Data[k] = swap16(uint16Data[k]);
                }
            }
            this._png.data = uint16Data;
        }
        else {
            this._png.data = newData;
        }
    }
}
function unfilterNone(currentLine, newLine, bytesPerLine) {
    for (let i = 0; i < bytesPerLine; i++) {
        newLine[i] = currentLine[i];
    }
}
function unfilterSub(currentLine, newLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    for (; i < bytesPerPixel; i++) {
        // just copy first bytes
        newLine[i] = currentLine[i];
    }
    for (; i < bytesPerLine; i++) {
        newLine[i] = (currentLine[i] + newLine[i - bytesPerPixel]) & 0xff;
    }
}
function unfilterUp(currentLine, newLine, prevLine, bytesPerLine) {
    let i = 0;
    if (prevLine.length === 0) {
        // just copy bytes for first line
        for (; i < bytesPerLine; i++) {
            newLine[i] = currentLine[i];
        }
    }
    else {
        for (; i < bytesPerLine; i++) {
            newLine[i] = (currentLine[i] + prevLine[i]) & 0xff;
        }
    }
}
function unfilterAverage(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for (; i < bytesPerPixel; i++) {
            newLine[i] = currentLine[i];
        }
        for (; i < bytesPerLine; i++) {
            newLine[i] = (currentLine[i] + (newLine[i - bytesPerPixel] >> 1)) & 0xff;
        }
    }
    else {
        for (; i < bytesPerPixel; i++) {
            newLine[i] = (currentLine[i] + (prevLine[i] >> 1)) & 0xff;
        }
        for (; i < bytesPerLine; i++) {
            newLine[i] =
                (currentLine[i] + ((newLine[i - bytesPerPixel] + prevLine[i]) >> 1)) &
                    0xff;
        }
    }
}
function unfilterPaeth(currentLine, newLine, prevLine, bytesPerLine, bytesPerPixel) {
    let i = 0;
    if (prevLine.length === 0) {
        for (; i < bytesPerPixel; i++) {
            newLine[i] = currentLine[i];
        }
        for (; i < bytesPerLine; i++) {
            newLine[i] = (currentLine[i] + newLine[i - bytesPerPixel]) & 0xff;
        }
    }
    else {
        for (; i < bytesPerPixel; i++) {
            newLine[i] = (currentLine[i] + prevLine[i]) & 0xff;
        }
        for (; i < bytesPerLine; i++) {
            newLine[i] =
                (currentLine[i] +
                    paethPredictor(newLine[i - bytesPerPixel], prevLine[i], prevLine[i - bytesPerPixel])) &
                    0xff;
        }
    }
}
function paethPredictor(a, b, c) {
    const p = a + b - c;
    const pa = Math.abs(p - a);
    const pb = Math.abs(p - b);
    const pc = Math.abs(p - c);
    if (pa <= pb && pa <= pc)
        return a;
    else if (pb <= pc)
        return b;
    else
        return c;
}
function swap16(val) {
    return ((val & 0xff) << 8) | ((val >> 8) & 0xff);
}
function checkBitDepth(value) {
    if (value !== 1 &&
        value !== 2 &&
        value !== 4 &&
        value !== 8 &&
        value !== 16) {
        throw new Error(`invalid bit depth: ${value}`);
    }
    return value;
}

var ResolutionUnitSpecifier;
(function (ResolutionUnitSpecifier) {
    /**
     * Unit is unknown
     */
    ResolutionUnitSpecifier[ResolutionUnitSpecifier["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Unit is the metre
     */
    ResolutionUnitSpecifier[ResolutionUnitSpecifier["METRE"] = 1] = "METRE";
})(ResolutionUnitSpecifier || (ResolutionUnitSpecifier = {}));

function decodePng(data, options) {
    const decoder = new PngDecoder(data, options);
    return decoder.decode();
}

function getFilter( smooth, mipmap, miplinear ){
    return 0x2600 | (+smooth) | (+mipmap<<8) | ( +( mipmap && miplinear )<<1 );
}

class HeightMapTexture {

    constructor(gl, src) {

        this.gl       = gl;
        this.width    = 0;
        this.height   = 0;
        this.data     = null;
        this._texture = gl.createTexture();        MemoryManager.trackTexture( this._texture );


        const floatTextures = gl.getExtension('EXT_color_buffer_float');
        const floatTextureLinearFiltering = gl.getExtension('OES_texture_float_linear');

        if (!floatTextures || !floatTextureLinearFiltering) {
            gl.getExtension('EXT_color_buffer_float');
            gl.getExtension('OES_texture_half_float_linear');
        }

        const xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = () => {
            if(xmlhttp.readyState === 4){
                if (xmlhttp.status === 200) {
                    const {data, width, height} = decodePng(xmlhttp.response); 
                    let floatImageData = new Float32Array(width * height * 4);
                    for (let i = 0; i < data.length; i++) { 
                        const heightValue = (data[i]) / (65535); 
                        floatImageData[i * 4 + 0] = heightValue; // R
                        floatImageData[i * 4 + 1] = heightValue; // G
                        floatImageData[i * 4 + 2] = heightValue; // B
                        floatImageData[i * 4 + 3] = 1.0;         // A
                    }
                    this.data   = floatImageData;
                    this.width  = width;
                    this.height = height;
                    gl.bindTexture(gl.TEXTURE_2D, this._texture);
                    gl.pixelStorei( gl.UNPACK_FLIP_Y_WEBGL, false);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    const smooth    = true;
                    const mipmap    = true;
                    const miplinear = true;
                    const filter    = getFilter( !!smooth, !!mipmap, !!miplinear);
                    gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, getFilter( !!smooth, false, false ) );
                    gl.texParameteri( gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter );
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA32F, width, height, 0, gl.RGBA, gl.FLOAT, floatImageData);
                    gl.generateMipmap( gl.TEXTURE_2D );
                    gl.bindTexture(gl.TEXTURE_2D, null);
                }
            }
        };
        xmlhttp.open('GET', src, true);
        xmlhttp.responseType = 'arraybuffer';
        xmlhttp.send();
    }

    bind(unit) {
        if (!this.gl) {
            return;
        }
        if (unit !== void 0) {
            this.gl.activeTexture( this.gl.TEXTURE0 + (0|unit) );
        }
        this.gl.bindTexture(this.gl.TEXTURE_2D, this._texture);
    }

    delete() {
        if (this.gl) {
          this.gl.deleteTexture( this._texture );
        }
        this._texture = null;
        this.gl       = null;
    }

}

class Composer {
    constructor(renderer) {
        this.renderer = renderer;
        this.passes = [];
        this.camera = new Camera({
            left:          -1/2,
            right:          1/2,
            top:            1/2,
            bottom:        -1/2,
            near:          1,
            far:           4000.0,
            type:          'ortho',
            orbitControl:  false,
            lookAt:        [0,0,100], 
            position:      [0,0,-100] 
        });
        this.camera.updateMatrix();
        this.camera.updateWorldMatrix();
        this.camera.updateProjectionMatrix();
        this.bufferScene = new Scene();
        this.bufferPlane = new Mesh();
        this.bufferPlane.geometry = new BoxGeometryBuffer(renderer.gl, { width: 1, height: 1, depth: 1 });
        this.bufferScene.add(this.bufferPlane);

        this.frameBufferWrite = new FrameBuffer(renderer.gl, {
            width:   1,
            height:  1,
            type: renderer.gl.HALF_FLOAT,
            linear: true,
        });
        this.frameBufferRead = new FrameBuffer(renderer.gl, {
            width:   1,
            height:  1,
            type: renderer.gl.HALF_FLOAT,
            linear: true,
        });
        this.uniforms = {};
    }
    setUniform(key, value) {
        this.uniforms[key] = value;
    }
    addPass(pass) {
        this.passes.push(pass);
    }
    resize(w, h) {
        this.camera.left  =  -w/2;
        this.camera.right =   w/2;
        this.camera.top =     h/2;
        this.camera.bottom = -h/2;
        this.camera.updateMatrix();
        this.camera.updateWorldMatrix();
        this.camera.updateProjectionMatrix();
        this.bufferPlane.scale[0] =  w;
        this.bufferPlane.scale[1] =  h;
        this.resolution = [w,h];
        this.passes?.forEach(pass => {
            pass?.resize(w, h);
        });
        this.frameBufferRead?.resize(w, h);
        this.frameBufferWrite?.resize(w, h);
    }
    setScene(scene) {
        this.scene = scene;
        this.scene.WITH_POST_PROCESS = 1;
    }
    render(input, output) {
        let hasRenderedAnyPass = false;
        this.passes?.forEach((pass, passIndex) => {
            if (pass.material) {
                for (let k in this.uniforms) {
                    pass.material?.setUniform(k, this.uniforms[k]);
                }
                if (this.scene) {
                    for (let u in this.scene.uniforms) {
                        pass.material?.setUniform(u, this.scene.uniforms[u]);
                    }
                    for (let d in this.scene.defines) {
                        pass.material?.setDefine(d, this.scene.defines[d]);
                    }
                }
            }
            const isLastPass = passIndex == this.passes.length - 1;
            if ( pass.enabled ) {
                pass?.render( 
                    !hasRenderedAnyPass ? input : this.frameBufferRead, 
                    isLastPass ? output : this.frameBufferWrite 
                );
                if (!isLastPass) {
                    let tmp = this.frameBufferRead;
                    this.frameBufferRead = this.frameBufferWrite;
                    this.frameBufferWrite = tmp;
                }
                hasRenderedAnyPass = true;
            }
        });
    }
}

class Pass  {
    constructor(renderer) {
        this.renderer = renderer;
        this.camera = new Camera({
            left:          -1/2,
            right:          1/2,
            top:            1/2,
            bottom:        -1/2,
            near:          1,
            far:           4000.0,
            type:          'ortho',
            orbitControl:  false,
            lookAt:        [0,0,100], 
            position:      [0,0,-100] 
        });
        this.camera.updateMatrix();
        this.camera.updateWorldMatrix();
        this.camera.updateProjectionMatrix();
        this.scene = new Scene();
        this.plane = new Mesh();
        this.plane.geometry = new BoxGeometryBuffer(renderer.gl, { width: 1, height: 1, depth: 1 });
        this.scene.add(this.plane);
        this.enabled = true;
    }
    resize(w,h) {
        this.camera.left  =  -w/2;
        this.camera.right =   w/2;
        this.camera.top =     h/2;
        this.camera.bottom = -h/2;
        this.camera.updateMatrix();
        this.camera.updateWorldMatrix();
        this.camera.updateProjectionMatrix();
        this.plane.scale[0] =  w;
        this.plane.scale[1] =  h;
        this.resolution = [w,h];
    }
    render(output) {
        this.plane.material = this.material;
        this.renderer.render(this.scene, this.camera, output);
    }
}

const settings = {
    exposure:             1,
    useGammaCorrection:   true,
    useExposure:          false,
    useToneMapping:       false,
    toneMappingExposure:  1.4,
    toneMappingMethod:    14,
};

class OutputRenderPass extends Pass {
    constructor(renderer, options) {
        super(renderer);
        this.material = new Program(this.renderer.gl, {
            vertexShader: /*glsl*/`
                #version 300 es
                precision highp float;
                precision highp int;
                in vec2 uv;
                in vec3 position;
                uniform mat4 uPMatrix;
                uniform mat4 uMVMatrix;
                out vec2 vUv;
                void main(void) {
                    vUv = uv;
                    gl_Position = uPMatrix * uMVMatrix * vec4(position, 1.0);
                }
            `,
            fragmentShader: /*glsl*/`
                #version 300 es
                precision highp float;
                in vec2 vUv;
                out vec4 fragColor;
                uniform sampler2D tInput;

                uniform int useExposure;
                uniform float uExposure;

                uniform int useGammaCorrection;

                uniform int useToneMapping;
                uniform float uToneMappingExposure;
                //  Baking Lab by MJP and David Neubelt
                //  http://mynameismjp.wordpress.com/
                //  All code licensed under the MIT license
                // The code in this file was originally written by Stephen Hill (@self_shadow), who deserves all
                // credit for coming up with this fit and implementing it. Buy him a beer next time you see him. :)
                vec3 RRTAndODTFit(vec3 v) {
                    vec3 a = v * (v + 0.0245786) - 0.000090537;
                    vec3 b = v * (0.983729 * v + 0.4329510) + 0.238081;
                    return a / b;
                }
                vec3 ACESFitted(vec3 color) {
                    mat3 ACESInputMat = mat3(
                        0.59719, 0.07600, 0.02840,
                        0.35458, 0.90834, 0.13383,
                        0.04823, 0.01566, 0.83777
                    );
                    mat3 ACESOutputMat = mat3 (
                        1.60475, -0.10208, -0.00327,
                        -0.53108, 1.10813, -0.07276,
                        -0.07367, -0.00605, 1.07602
                    );
                    color = ACESInputMat * color;
                    color = RRTAndODTFit(color);
                    color = ACESOutputMat * color;
                    color = clamp(color, 0., 1.);
                    return color;
                }
                
                void main() {
                    
                    fragColor = texture( tInput, vUv );

                    if (useExposure == 1) {
                        fragColor.rgb *= uExposure;
                    }

                    if (useToneMapping == 1) {
                        fragColor.rgb = ACESFitted( fragColor.rgb) * uToneMappingExposure;
                    }

                    if (useGammaCorrection == 1) {
                        fragColor.rgb  = pow( fragColor.rgb , vec3(1.0 / 2.2)) ;  
                    }

                }
            `,
        });

        this.useExposure          = settings.useExposure;
        this.exposure             = settings.exposure;
        this.useGammaCorrection   = settings.useGammaCorrection;
        this.useToneMapping       = settings.useToneMapping;
        this.toneMappingExposure  = settings.toneMappingExposure;
        this.toneMappingMethod    = settings.toneMappingMethod;

    }

    render(input, output) {
        this.renderer.clearColor(0,0,0,1);
        this.renderer.clear(); 
        this.material.setUniform('tInput',               input);
        this.material.setUniform('useExposure',          this.useExposure ? 1 : 0);
        this.material.setUniform('uExposure',            this.exposure);
        this.material.setUniform('useToneMapping',       this.useToneMapping);
        this.material.setUniform('uToneMappingMethod',   this.toneMappingMethod);
        this.material.setUniform('uToneMappingExposure', this.toneMappingExposure);
        this.material.setUniform('useGammaCorrection',   this.useGammaCorrection ? 1 : 0);
        super.render(output);
    }

}

console.log(`%c Beam %c v${"3.2.0"} `,"color: #fff; background: #ff0036; padding:5px 0;","color: #000; background: #f7f7f5; padding:5px 0;");

export { AmbientLight, ArrayBuffer$1 as ArrayBuffer, BoxGeometryBuffer, Camera, CircleGeometryBuffer, Composer, Container, CubeTexture, CylinderGeometryBuffer, DepthTexture, DirectionalLight, FrameBuffer, Frustum, GeometryBuffer, PlaneGeometryBuffer as GridGeometryBuffer, HDRTexture, HeightMapTexture as HeightmapTexture, JSONGeometryBuffer, Light, Material, MemoryManager, Mesh, ObjGeometryBuffer, Object3d, OutputRenderPass, ParticleSystem, Pass, PlaneGeometryBuffer$1 as PlaneGeometryBuffer, PointLight, Program, parse as RGBEParser, RectLight, Renderer, Scene, SphereGeometryBuffer, SpotLight, Texture, TriangleGeometryBuffer, generateUUID, mat2, mat2d, mat3, mat4, quat, setUniform, vec2, vec3, vec4 };
